import * as React from 'react';
import { chakra, type HTMLChakraProps } from '@chakra-ui/react';

export type LogoProps = HTMLChakraProps<'svg'> & {
  /**
   * Sets the SVG's CSS `color`, used by `currentColor` fills/strokes.
   * Accepts Chakra tokens (e.g. "white", "gray.900") or hex.
   */
  color?: string;
};

export const Logo = (props: LogoProps) => {
  const color = props.color ?? '#d4af37';

  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0.00 0.00 1728.00 624.00"
      width="full"
      height="full"
      maxH={32}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      focusable="false"
      {...props}
      color={color}
    >
      <g strokeWidth="2.00" fill="none" strokeLinecap="butt">
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 798.24 237.12
  L 790.03 238.87"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 786.56 239.87
  L 781.01 241.02"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 776.89 242.55
  Q 771.70 243.18 767.36 245.89"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 757.32 250.46
  L 754.07 251.84"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 742.47 258.40
  Q 741.20 258.92 739.88 260.10"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 730.72 266.06
  Q 726.60 267.85 723.99 271.26"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 719.12 275.76
  L 713.87 280.74"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 709.71 285.12
  L 706.53 288.42"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 698.05 299.43
  Q 694.15 303.62 691.39 307.51
  Q 689.90 309.60 689.89 311.22"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 682.53 324.75
  Q 676.91 329.73 677.01 337.70"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 672.96 351.46
  L 672.78 353.65"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 669.62 368.18
  L 669.97 370.53"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 667.15 384.45
  L 667.08 388.03"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 668.22 401.71
  L 668.21 404.44"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 670.91 418.75
  L 669.87 421.58"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 673.97 435.89
  L 674.20 438.00"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 677.34 449.39
  L 679.01 452.43"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 683.95 461.79
  L 684.71 464.12"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 691.67 475.27
  L 693.84 477.41"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 701.97 487.74
  L 700.93 487.91
  A 0.89 0.89 0.0 0 0 700.82 489.64
  L 702.48 490.14"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 707.62 498.77
  L 708.90 500.21"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 719.67 510.80
  L 722.41 512.99"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 732.80 521.70
  L 735.68 523.51"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 746.80 530.83
  Q 748.34 531.15 750.03 532.30"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 762.47 538.80
  L 765.11 540.00"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 778.04 544.80
  Q 779.72 545.77 781.33 546.09"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 794.88 549.36
  Q 802.15 552.04 811.72 551.90"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 823.37 552.34
  Q 824.28 552.63 825.01 552.39"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 835.89 552.04
  Q 836.98 551.73 836.69 552.12"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 853.16 550.22
  Q 858.95 549.71 865.68 547.68
  Q 867.88 547.02 869.36 546.20"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 877.22 543.74
  L 882.59 541.34"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 894.33 536.44
  L 897.73 534.72"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 907.51 529.10
  Q 909.28 529.23 910.94 525.45"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 921.80 518.76
  Q 924.89 517.07 927.03 514.75"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 932.51 510.37
  L 935.13 507.57"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 941.51 499.41
  Q 942.47 498.01 944.59 497.25"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 953.32 486.19
  L 956.22 482.52"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 959.21 477.95
  Q 962.03 475.14 963.49 472.52
  Q 967.84 464.75 973.05 453.57
  Q 975.19 448.98 976.40 441.05"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 978.40 434.49
  L 978.07 431.48"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 981.64 417.76
  Q 981.39 416.00 982.03 414.81"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 983.50 401.05
  Q 982.88 399.61 982.78 397.85"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 982.28 383.87
  Q 982.45 382.55 982.03 381.21"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 980.05 366.86
  Q 981.10 366.01 980.61 363.95"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 977.59 349.68
  L 976.73 347.14"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 972.90 336.48
  L 972.15 333.01
  A 0.17 0.17 0.0 0 0 971.82 333.00
  Q 971.70 333.39 971.87 333.83
  A 0.09 0.09 0.0 0 1 971.87 333.89
  Q 971.76 334.07 971.60 334.11
  A 0.15 0.15 0.0 0 1 971.42 333.91
  Q 972.18 331.97 970.77 330.30"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 970.67 329.82
  Q 969.74 325.23 966.58 321.67
  Q 966.16 321.20 965.99 320.21"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 960.28 309.54
  L 957.89 307.41"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 956.16 304.49
  Q 954.68 299.21 949.96 296.96
  A 0.52 0.52 0.0 0 1 949.70 296.30
  Q 950.37 294.62 949.12 294.17"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 944.13 288.11
  Q 941.67 287.10 941.84 286.01"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 931.28 275.41
  L 929.18 273.28"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 917.47 264.78
  L 915.10 263.04"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 903.08 255.99
  L 900.72 254.49"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 888.05 247.85
  Q 886.78 246.66 885.30 246.41"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 871.25 241.68
  Q 870.29 241.08 869.66 241.03"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 855.69 237.66
  L 850.04 237.32"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 846.58 236.91
  L 842.19 235.96"
        />
        <path stroke="currentColor" vectorEffect="non-scaling-stroke" d="
  M 825.95 234.84
  Q 818.98 234.10 810.77 235.41"
        />
      </g>
      <g fill="currentColor">
        <path d="
  M 511.57 433.49
  A 0.42 0.42 0.0 0 0 511.08 432.92
  C 503.58 434.81 493.38 436.09 486.21 432.95
  A 4.34 4.34 0.0 0 1 483.77 430.13
  C 482.05 423.89 485.33 414.16 487.82 408.33
  A 0.57 0.57 0.0 0 0 487.25 407.54
  Q 480.21 408.19 474.10 406.90
  A 2.39 2.38 -0.9 0 1 472.28 405.15
  L 470.05 396.17
  A 0.74 0.74 0.0 0 0 469.05 395.66
  Q 465.85 397.00 463.01 398.76
  C 454.81 403.84 448.57 407.30 440.02 408.75
  Q 436.12 409.40 433.56 408.89
  A 4.25 4.25 0.0 0 1 430.40 406.14
  C 429.44 403.40 428.65 399.03 428.66 396.14
  Q 428.69 381.30 431.44 367.35
  A 0.71 0.71 0.0 0 0 430.45 366.57
  Q 420.76 371.00 401.88 379.61
  Q 395.85 382.36 387.94 384.76
  C 378.32 387.67 369.94 389.85 361.21 387.63
  C 356.14 386.34 356.95 384.20 357.16 379.42
  Q 357.56 370.15 361.32 361.26
  Q 365.92 350.36 370.44 340.83
  A 0.83 0.83 0.0 0 0 369.79 339.65
  Q 369.41 339.61 368.24 339.69
  C 363.52 340.05 356.70 342.65 351.06 344.18
  C 333.62 348.91 317.90 352.60 300.77 354.58
  C 287.96 356.06 270.65 355.69 260.78 346.43
  A 1.59 1.58 -56.1 0 1 260.43 344.61
  C 266.08 332.21 275.76 323.58 285.13 313.75
  A 0.96 0.96 0.0 0 0 284.62 312.15
  C 282.77 311.79 280.83 311.65 278.79 311.88
  Q 252.10 314.85 226.46 313.26
  C 211.11 312.30 192.16 308.38 180.88 298.84
  C 178.56 296.87 176.31 294.36 178.53 291.31
  Q 181.84 286.79 187.33 282.58
  Q 201.92 271.37 218.72 263.54
  C 220.33 262.79 222.02 261.64 223.95 260.45
  A 0.48 0.48 0.0 0 0 223.67 259.56
  Q 219.68 259.82 210.14 260.03
  Q 183.84 260.62 160.78 256.69
  Q 147.63 254.45 132.93 248.49
  C 123.75 244.78 117.39 240.07 111.69 232.51
  A 0.85 0.85 0.0 0 1 111.61 231.60
  Q 112.48 229.96 114.07 228.32
  Q 122.96 219.13 134.64 213.66
  Q 147.56 207.62 158.27 204.03
  Q 166.24 201.35 175.53 197.27
  A 0.32 0.32 0.0 0 0 175.41 196.65
  Q 157.07 196.31 140.50 193.43
  C 116.35 189.23 90.08 182.74 72.57 164.17
  Q 70.23 161.70 71.12 160.08
  Q 71.59 159.22 73.98 156.56
  Q 78.19 151.86 80.86 150.08
  Q 92.55 142.29 105.65 138.16
  Q 110.55 136.62 118.65 133.74
  A 0.55 0.55 0.0 0 0 118.59 132.68
  Q 115.33 131.90 108.04 130.38
  Q 83.93 125.36 66.21 116.98
  Q 50.69 109.65 39.92 96.33
  Q 38.64 94.74 38.85 93.00
  A 2.55 2.43 -29.6 0 1 39.11 92.14
  Q 41.29 87.93 45.40 85.68
  Q 62.54 76.32 79.21 72.73
  Q 91.28 70.13 104.68 68.42
  Q 113.95 67.23 121.75 67.18
  C 139.19 67.07 159.83 67.34 175.42 67.17
  Q 300.57 65.75 389.50 65.44
  Q 450.73 65.23 511.41 66.61
  Q 537.57 67.21 545.71 68.66
  C 565.42 72.17 583.66 80.66 596.96 95.52
  C 613.93 114.47 624.19 138.08 632.15 162.09
  C 637.97 179.61 641.55 191.92 647.94 206.03
  C 651.02 212.83 655.54 214.93 663.03 217.71
  Q 683.33 225.28 703.79 225.99
  Q 715.80 226.42 738.25 224.77
  Q 740.10 224.64 741.93 223.92
  C 753.57 219.39 762.67 215.08 772.31 212.66
  Q 785.42 209.36 795.70 207.66
  Q 826.28 202.59 856.84 207.90
  Q 867.16 209.70 879.91 213.10
  Q 887.41 215.10 907.43 223.59
  Q 910.75 225.00 915.76 225.21
  Q 931.97 225.92 939.00 226.09
  Q 965.48 226.70 989.71 216.98
  C 994.76 214.96 999.25 213.03 1001.70 208.24
  C 1005.95 199.95 1009.64 190.36 1012.31 181.79
  C 1021.55 152.15 1031.59 121.89 1051.16 98.65
  C 1065.18 81.99 1084.75 71.61 1105.96 68.47
  Q 1114.80 67.16 1127.50 66.86
  Q 1206.81 65.01 1293.75 65.58
  Q 1377.94 66.13 1472.75 67.14
  Q 1487.43 67.29 1519.01 67.09
  Q 1548.65 66.90 1577.82 74.39
  C 1586.53 76.62 1594.55 80.35 1602.62 84.12
  Q 1607.93 86.61 1611.17 91.48
  A 2.76 2.76 0.0 0 1 1611.24 94.42
  Q 1608.57 98.90 1605.40 102.14
  Q 1596.05 111.69 1584.69 116.92
  Q 1571.49 123.00 1556.41 127.21
  C 1549.17 129.23 1541.13 130.43 1534.91 131.87
  Q 1533.25 132.26 1532.22 132.80
  A 0.46 0.46 0.0 0 0 1532.27 133.64
  Q 1539.00 136.28 1546.02 138.48
  C 1558.49 142.38 1571.50 149.04 1579.41 159.93
  A 1.67 1.66 42.6 0 1 1579.49 161.78
  Q 1577.92 164.35 1575.67 166.68
  Q 1567.41 175.22 1555.11 180.60
  C 1534.55 189.60 1511.94 194.11 1489.68 195.72
  Q 1481.83 196.29 1476.11 196.97
  A 0.31 0.31 0.0 0 0 1476.04 197.57
  C 1480.50 199.26 1484.14 201.27 1488.74 202.60
  Q 1496.48 204.86 1512.35 211.89
  Q 1526.02 217.95 1536.58 227.91
  Q 1538.22 229.46 1539.18 231.27
  A 1.30 1.30 0.0 0 1 1539.06 232.67
  C 1533.47 240.02 1526.78 244.95 1517.88 248.47
  Q 1503.80 254.02 1493.10 256.11
  C 1472.60 260.11 1450.15 260.48 1428.01 259.47
  Q 1427.63 259.45 1427.22 259.62
  A 0.51 0.51 0.0 0 0 1427.12 260.50
  Q 1429.70 262.42 1434.34 264.63
  Q 1451.67 272.90 1463.69 282.56
  Q 1469.04 286.85 1472.47 290.99
  C 1475.22 294.30 1471.69 297.30 1468.95 299.47
  Q 1461.17 305.63 1449.97 308.74
  Q 1441.18 311.19 1433.22 312.15
  Q 1403.77 315.71 1374.04 311.79
  C 1371.83 311.50 1367.99 311.58 1365.90 312.19
  A 0.54 0.54 0.0 0 0 1365.58 312.97
  C 1367.61 316.75 1370.61 319.05 1374.81 323.18
  Q 1384.52 332.74 1390.49 344.64
  A 1.20 1.20 0.0 0 1 1390.24 346.05
  C 1382.93 352.89 1372.09 355.37 1362.22 355.19
  C 1336.33 354.73 1314.39 348.22 1286.00 339.94
  Q 1283.95 339.34 1281.94 339.33
  A 0.90 0.90 0.0 0 0 1281.05 340.35
  Q 1281.23 341.72 1282.00 343.51
  C 1286.11 353.17 1292.76 365.44 1293.95 377.86
  C 1294.39 382.47 1294.74 386.57 1289.39 387.61
  C 1285.52 388.36 1281.42 389.01 1277.51 388.27
  Q 1264.96 385.88 1258.58 383.39
  Q 1249.98 380.05 1223.34 367.73
  Q 1222.46 367.33 1220.93 366.80
  A 0.77 0.77 0.0 0 0 1219.92 367.66
  C 1221.97 379.79 1223.95 392.45 1221.58 404.29
  Q 1220.53 409.58 1215.25 409.04
  Q 1204.43 407.92 1197.80 404.18
  Q 1189.89 399.73 1182.31 395.71
  A 0.63 0.63 0.0 0 0 1181.40 396.13
  L 1179.45 404.97
  A 2.37 2.36 -0.6 0 1 1177.70 406.75
  Q 1171.39 408.25 1164.40 407.34
  A 0.62 0.62 0.0 0 0 1163.73 408.14
  Q 1166.00 415.32 1166.99 419.01
  Q 1168.11 423.23 1168.04 428.01
  C 1167.97 432.18 1165.38 433.38 1161.51 433.99
  Q 1151.46 435.55 1140.77 432.73
  A 0.53 0.53 0.0 0 0 1140.14 433.42
  C 1142.26 439.48 1144.64 446.32 1144.70 452.68
  C 1144.72 454.94 1143.70 455.78 1141.81 456.82
  C 1134.24 460.98 1124.23 461.13 1115.68 460.45
  A 0.99 0.99 0.0 0 0 1114.63 461.66
  Q 1116.60 470.35 1116.01 478.76
  C 1115.50 485.96 1097.03 483.53 1092.82 482.95
  A 0.42 0.41 3.0 0 0 1092.35 483.37
  C 1092.49 492.26 1092.68 499.04 1089.19 507.07
  Q 1087.83 510.19 1083.96 509.61
  C 1072.00 507.82 1063.08 501.78 1053.39 494.77
  A 0.83 0.83 0.0 0 0 1052.19 495.01
  Q 1051.04 496.87 1050.49 498.52
  C 1047.37 507.91 1044.78 516.03 1037.60 522.50
  A 2.25 2.24 27.8 0 1 1035.80 523.05
  C 1028.28 521.98 1022.99 516.03 1017.31 509.70
  Q 1014.69 506.78 1011.92 504.91
  A 0.79 0.79 0.0 0 0 1010.80 505.16
  C 1006.31 512.66 1002.38 519.31 996.01 524.54
  Q 992.93 527.07 989.51 524.75
  C 983.27 520.53 979.66 515.39 975.47 509.48
  A 0.95 0.95 0.0 0 0 973.98 509.40
  C 963.76 521.04 953.28 532.46 940.36 542.10
  C 931.55 548.67 923.36 554.62 914.64 559.22
  Q 861.61 587.24 803.53 580.63
  Q 785.75 578.61 763.37 571.19
  C 745.78 565.36 728.70 555.53 714.29 545.16
  C 701.34 535.84 690.06 524.04 678.91 511.60
  Q 678.07 510.66 676.43 509.55
  A 0.89 0.88 -56.1 0 0 675.19 509.80
  C 671.21 515.91 665.64 523.30 658.63 526.21
  A 1.59 1.58 -45.2 0 1 657.43 526.22
  C 653.24 524.55 648.94 518.88 646.32 514.96
  Q 643.54 510.78 640.49 505.35
  A 1.22 1.21 -32.4 0 0 638.72 504.96
  Q 636.06 506.88 632.87 510.62
  C 627.54 516.86 623.66 520.88 616.85 523.08
  C 609.55 525.42 600.84 499.52 599.31 495.99
  A 1.24 1.24 0.0 0 0 597.47 495.47
  C 589.86 500.73 581.89 505.63 572.50 508.50
  Q 568.84 509.63 565.34 509.63
  A 3.34 3.32 77.7 0 1 562.29 507.66
  C 559.06 500.46 558.42 491.81 558.96 483.82
  A 0.69 0.69 0.0 0 0 558.18 483.10
  C 552.61 483.83 539.01 485.56 535.33 480.13
  A 1.99 1.98 25.8 0 1 534.99 479.16
  Q 534.42 472.25 534.85 470.35
  Q 536.40 463.60 536.90 461.14
  A 0.72 0.72 0.0 0 0 536.12 460.28
  C 527.41 461.23 517.03 461.20 509.36 457.16
  C 505.68 455.23 506.03 452.01 506.82 448.02
  Q 508.15 441.34 511.57 433.49
  Z
  M 601.94 246.71
  Q 595.56 263.74 592.61 275.08
  Q 591.91 277.76 591.94 280.50
  A 1.01 1.01 0.0 0 0 593.20 281.46
  Q 601.69 279.31 609.31 274.79
  Q 616.09 270.77 625.50 264.30
  A 0.73 0.73 0.0 0 1 626.63 265.03
  C 625.12 272.97 623.00 281.91 622.70 290.34
  Q 622.42 297.98 622.51 303.26
  A 1.00 0.99 77.3 0 0 623.91 304.15
  C 636.63 298.37 645.91 287.46 655.95 278.16
  A 0.61 0.61 0.0 0 1 656.98 278.64
  Q 656.55 287.59 656.02 294.50
  Q 655.43 302.16 655.95 308.61
  A 0.45 0.45 0.0 0 0 656.80 308.78
  Q 661.08 300.70 667.87 289.36
  C 672.18 282.18 677.28 276.63 683.86 268.61
  C 694.25 255.95 707.13 245.14 721.05 236.15
  A 0.29 0.29 0.0 0 0 721.04 235.66
  Q 720.51 235.34 720.19 235.36
  Q 714.77 235.54 700.03 235.37
  C 685.68 235.20 671.33 231.94 658.67 227.06
  Q 651.86 224.44 648.89 222.16
  C 642.03 216.88 638.92 211.06 635.73 203.25
  C 631.25 192.27 627.54 181.01 624.06 169.71
  Q 619.35 154.40 612.69 140.12
  Q 607.11 128.15 604.32 123.18
  C 595.53 107.52 581.87 92.42 565.24 84.97
  C 554.53 80.18 538.61 76.99 526.75 77.09
  C 511.39 77.21 494.10 76.23 477.42 76.07
  Q 387.93 75.22 297.27 76.15
  Q 208.02 77.06 173.51 77.62
  Q 165.10 77.76 133.06 77.57
  Q 114.20 77.46 104.01 78.79
  Q 81.77 81.68 60.79 89.27
  Q 56.31 90.89 52.21 93.48
  A 0.93 0.93 0.0 0 0 52.00 94.87
  Q 53.84 97.00 56.82 99.21
  C 67.50 107.12 80.66 112.90 94.78 116.49
  Q 113.91 121.36 127.27 122.62
  Q 147.43 124.52 160.01 124.35
  Q 312.83 122.34 373.75 121.78
  Q 378.05 121.74 380.86 122.43
  C 383.26 123.02 385.86 123.43 387.27 123.40
  Q 395.25 123.28 433.50 122.26
  C 455.05 121.68 476.06 122.44 505.08 123.00
  C 522.10 123.32 533.20 123.52 544.67 132.55
  Q 554.42 140.22 560.36 149.37
  C 569.17 162.94 576.16 179.22 578.26 195.45
  C 578.83 199.88 579.96 205.14 576.04 208.32
  C 571.16 212.28 566.58 215.70 563.92 220.52
  A 1.27 1.27 0.0 0 0 564.76 222.37
  L 580.82 225.92
  A 0.98 0.97 -70.2 0 1 581.47 227.32
  Q 577.66 234.60 575.39 238.63
  Q 571.21 246.03 569.09 252.85
  A 1.21 1.21 0.0 0 0 570.24 254.42
  Q 575.90 254.46 581.75 252.72
  Q 592.71 249.47 601.55 246.31
  A 0.31 0.30 -89.8 0 1 601.94 246.71
  Z
  M 1598.92 94.45
  A 0.46 0.46 0.0 0 0 1598.82 93.76
  Q 1593.43 90.33 1587.09 88.21
  Q 1565.89 81.11 1544.04 78.61
  Q 1533.96 77.45 1519.42 77.66
  C 1499.78 77.95 1473.51 77.60 1457.75 77.36
  Q 1314.65 75.20 1202.25 75.85
  C 1175.37 76.00 1149.15 76.81 1123.03 77.05
  Q 1114.66 77.13 1103.02 79.52
  C 1092.47 81.69 1082.17 85.71 1073.38 92.44
  Q 1064.81 98.99 1056.86 108.18
  Q 1050.80 115.18 1044.49 127.28
  Q 1033.51 148.37 1026.89 169.75
  C 1022.61 183.58 1019.16 193.91 1013.21 208.46
  C 1009.10 218.52 1002.12 223.25 991.89 227.13
  Q 978.27 232.29 965.55 234.27
  C 954.80 235.94 942.12 235.56 930.22 235.29
  A 0.53 0.52 -16.4 0 0 929.77 236.11
  Q 930.02 236.47 930.49 236.77
  C 955.49 252.85 976.76 276.64 990.27 302.47
  Q 993.05 307.78 994.30 309.27
  A 0.36 0.36 0.0 0 0 994.94 309.03
  C 994.85 305.53 995.37 300.26 995.05 295.98
  Q 994.27 285.47 994.36 278.84
  A 0.48 0.48 0.0 0 1 995.17 278.49
  Q 1000.49 283.36 1008.88 291.35
  Q 1013.50 295.74 1024.80 303.18
  Q 1026.04 304.00 1027.26 304.44
  A 1.01 1.00 -78.6 0 0 1028.60 303.54
  C 1028.93 296.70 1028.69 288.43 1027.43 281.21
  Q 1025.69 271.22 1024.86 265.12
  A 0.48 0.48 0.0 0 1 1025.60 264.65
  Q 1035.62 271.18 1043.92 276.07
  Q 1050.84 280.14 1058.23 281.52
  A 0.88 0.87 -87.0 0 0 1059.26 280.59
  Q 1058.83 274.80 1056.82 268.90
  Q 1053.24 258.43 1049.32 246.93
  A 0.40 0.40 0.0 0 1 1049.83 246.42
  Q 1061.22 250.26 1070.20 252.79
  Q 1075.84 254.38 1081.21 254.21
  A 0.78 0.78 0.0 0 0 1081.95 253.28
  Q 1081.12 248.97 1079.12 245.16
  Q 1075.03 237.36 1070.33 228.96
  Q 1069.56 227.59 1069.32 226.95
  A 0.57 0.57 0.0 0 1 1069.71 226.19
  L 1086.67 221.99
  A 1.05 1.05 0.0 0 0 1087.28 220.38
  Q 1084.31 216.04 1079.79 212.34
  C 1075.66 208.96 1071.66 206.43 1072.12 201.60
  Q 1074.99 171.23 1092.72 146.46
  C 1101.98 133.52 1115.65 123.87 1132.04 123.39
  Q 1161.40 122.55 1190.81 122.09
  Q 1210.74 121.78 1254.00 123.28
  Q 1260.91 123.52 1264.01 123.30
  Q 1264.53 123.26 1271.92 122.19
  Q 1275.01 121.75 1280.00 121.80
  Q 1377.13 122.79 1482.00 124.29
  C 1499.38 124.53 1519.31 124.19 1536.64 120.77
  Q 1553.63 117.42 1562.03 114.79
  Q 1578.29 109.70 1592.11 100.36
  Q 1596.33 97.51 1598.92 94.45
  Z
  M 361.11 173.92
  A 0.36 0.36 0.0 0 0 361.12 173.24
  C 348.65 168.89 334.69 162.35 326.80 151.79
  C 320.89 143.88 337.78 135.69 342.44 133.57
  A 0.22 0.21 -57.6 0 0 342.35 133.16
  Q 252.51 134.66 194.25 134.94
  C 178.11 135.02 161.41 137.48 145.48 139.85
  C 133.40 141.65 120.44 144.64 110.27 147.74
  Q 97.74 151.56 87.62 157.86
  Q 85.31 159.30 84.10 161.02
  A 0.69 0.69 0.0 0 0 84.21 161.93
  Q 86.86 164.29 89.48 165.83
  Q 101.45 172.84 111.61 176.10
  C 127.39 181.17 146.34 184.77 164.49 185.31
  Q 179.24 185.76 188.07 185.18
  Q 254.70 180.81 320.44 176.93
  Q 327.69 176.50 359.79 174.15
  Q 360.56 174.10 361.11 173.92
  Z
  M 1290.25 173.91
  Q 1290.80 174.08 1291.57 174.13
  Q 1323.57 176.47 1330.80 176.90
  Q 1396.35 180.75 1462.78 185.09
  Q 1471.58 185.67 1486.29 185.22
  C 1504.39 184.68 1523.28 181.08 1539.01 176.02
  Q 1549.14 172.77 1561.07 165.78
  Q 1563.69 164.24 1566.33 161.89
  A 0.69 0.68 -38.4 0 0 1566.44 160.98
  Q 1565.23 159.27 1562.93 157.83
  Q 1552.84 151.55 1540.34 147.75
  C 1530.20 144.66 1517.28 141.68 1505.23 139.89
  C 1489.35 137.53 1472.70 135.08 1456.61 135.00
  Q 1398.52 134.74 1308.95 133.26
  A 0.21 0.21 0.0 0 0 1308.86 133.67
  C 1313.50 135.78 1330.34 143.95 1324.45 151.83
  C 1316.59 162.36 1302.67 168.89 1290.24 173.23
  A 0.36 0.36 0.0 0 0 1290.25 173.91
  Z
  M 557.48 168.43
  A 0.56 0.56 0.0 0 0 557.96 167.65
  Q 551.88 153.47 540.03 142.91
  Q 531.25 135.09 518.71 134.73
  Q 496.03 134.07 464.85 133.31
  C 447.52 132.89 428.89 133.33 412.55 133.97
  C 391.62 134.80 375.43 136.21 358.57 140.19
  C 352.13 141.72 345.31 143.94 340.27 148.00
  A 0.82 0.81 49.1 0 0 340.19 149.20
  C 349.19 158.70 363.12 162.11 375.42 165.52
  Q 401.68 172.81 427.78 173.18
  Q 438.32 173.34 460.59 172.14
  Q 474.07 171.42 493.41 170.61
  Q 543.49 168.55 554.18 168.53
  Q 555.94 168.52 557.48 168.43
  Z
  M 1093.69 168.43
  Q 1095.24 168.52 1097.00 168.53
  Q 1107.70 168.56 1157.82 170.63
  Q 1177.17 171.44 1190.66 172.17
  Q 1212.95 173.37 1223.50 173.22
  Q 1249.62 172.85 1275.90 165.56
  C 1288.21 162.15 1302.15 158.74 1311.16 149.24
  A 0.82 0.81 -49.1 0 0 1311.08 148.04
  C 1306.04 143.97 1299.22 141.75 1292.77 140.22
  C 1275.90 136.23 1259.70 134.81 1238.75 133.98
  C 1222.40 133.33 1203.75 132.89 1186.41 133.31
  Q 1155.20 134.06 1132.50 134.71
  Q 1119.95 135.07 1111.16 142.90
  Q 1099.30 153.46 1093.21 167.65
  A 0.56 0.56 0.0 0 0 1093.69 168.43
  Z
  M 566.71 194.69
  A 0.67 0.66 78.4 0 0 567.26 193.84
  L 563.83 181.40
  A 2.44 2.44 0.0 0 0 561.47 179.61
  Q 546.06 179.70 520.65 180.80
  Q 464.82 183.22 440.45 184.24
  Q 421.05 185.05 402.24 182.57
  C 401.18 182.43 398.51 182.71 397.21 183.05
  C 383.95 186.58 371.19 192.06 360.05 199.83
  A 0.82 0.82 0.0 0 0 360.10 201.20
  C 375.64 210.46 392.91 213.77 411.59 215.06
  C 427.85 216.18 443.38 215.09 460.13 212.71
  C 477.67 210.22 497.26 206.20 511.90 203.61
  Q 544.19 197.93 566.71 194.69
  Z
  M 1084.55 194.77
  Q 1107.14 198.02 1139.52 203.73
  C 1154.20 206.33 1173.85 210.36 1191.44 212.86
  C 1208.24 215.25 1223.81 216.35 1240.12 215.23
  C 1258.86 213.94 1276.18 210.62 1291.76 201.34
  A 0.82 0.82 0.0 0 0 1291.81 199.96
  C 1280.64 192.17 1267.85 186.67 1254.55 183.13
  C 1253.25 182.79 1250.57 182.51 1249.50 182.65
  Q 1230.64 185.13 1211.18 184.31
  Q 1186.74 183.29 1130.75 180.85
  Q 1105.26 179.74 1089.81 179.65
  A 2.45 2.44 7.9 0 0 1087.44 181.44
  L 1084.00 193.92
  A 0.68 0.66 -78.4 0 0 1084.55 194.77
  Z
  M 383.29 222.71
  A 0.31 0.30 -46.2 0 0 383.28 222.12
  Q 374.32 219.79 365.45 216.55
  C 357.38 213.61 351.52 209.35 346.44 202.63
  A 2.19 2.17 27.4 0 1 346.00 201.26
  C 346.21 194.45 354.88 189.55 360.06 185.86
  A 0.27 0.27 0.0 0 0 359.88 185.37
  Q 331.78 187.27 262.74 191.41
  Q 252.16 192.04 245.36 193.26
  C 217.05 198.31 189.17 204.64 163.60 213.10
  Q 153.93 216.30 149.18 218.47
  C 139.60 222.84 132.35 225.71 125.21 231.31
  A 0.73 0.72 44.7 0 0 125.22 232.45
  C 134.96 239.86 147.93 243.93 159.80 245.95
  Q 189.57 251.01 220.97 248.45
  Q 229.99 247.72 269.04 241.12
  Q 320.37 232.43 373.78 224.81
  Q 378.43 224.15 383.29 222.71
  Z
  M 1268.25 222.72
  Q 1273.10 224.16 1277.74 224.81
  Q 1331.03 232.39 1382.24 241.03
  Q 1421.21 247.60 1430.20 248.32
  Q 1461.53 250.86 1491.23 245.80
  C 1503.07 243.77 1516.01 239.71 1525.73 232.31
  A 0.73 0.72 -44.8 0 0 1525.73 231.17
  C 1518.61 225.59 1511.37 222.73 1501.81 218.37
  Q 1497.07 216.21 1487.42 213.02
  C 1461.91 204.60 1434.09 198.29 1405.84 193.27
  Q 1399.06 192.06 1388.50 191.43
  Q 1319.62 187.34 1291.58 185.46
  A 0.27 0.27 0.0 0 0 1291.41 185.95
  C 1296.58 189.62 1305.23 194.51 1305.44 201.30
  A 2.18 2.17 -27.4 0 1 1305.00 202.67
  C 1299.94 209.38 1294.09 213.63 1286.04 216.57
  Q 1277.20 219.80 1268.26 222.13
  A 0.31 0.30 46.1 0 0 1268.25 222.72
  Z
  M 1096.59 229.80
  Q 1114.45 234.71 1140.50 242.64
  C 1166.59 250.58 1195.44 255.20 1223.00 251.54
  Q 1235.62 249.87 1246.32 244.75
  A 1.32 1.31 -28.4 0 0 1246.88 242.89
  Q 1246.29 241.89 1244.69 240.78
  Q 1233.70 233.07 1221.76 228.28
  C 1220.26 227.68 1218.27 227.31 1217.18 227.19
  Q 1200.05 225.27 1186.00 223.24
  C 1166.74 220.45 1141.18 215.23 1119.60 211.65
  Q 1104.54 209.15 1091.81 207.20
  A 0.34 0.34 0.0 0 0 1091.51 207.76
  Q 1095.90 212.68 1098.75 217.01
  Q 1103.87 224.77 1096.52 229.33
  A 0.26 0.26 0.0 0 0 1096.59 229.80
  Z
  M 554.57 229.74
  A 0.26 0.26 0.0 0 0 554.64 229.28
  Q 547.30 224.72 552.41 216.97
  Q 555.26 212.65 559.64 207.73
  A 0.34 0.33 -73.5 0 0 559.34 207.17
  Q 546.63 209.12 531.59 211.63
  C 510.03 215.21 484.51 220.43 465.27 223.23
  Q 451.24 225.26 434.13 227.19
  C 433.05 227.31 431.06 227.68 429.56 228.28
  Q 417.64 233.07 406.66 240.77
  Q 405.07 241.88 404.48 242.88
  A 1.32 1.31 28.4 0 0 405.04 244.74
  Q 415.73 249.85 428.33 251.51
  C 455.86 255.15 484.67 250.53 510.72 242.59
  Q 536.74 234.66 554.57 229.74
  Z
  M 961.30 508.47
  C 965.51 503.13 970.02 498.04 972.66 493.35
  C 977.33 485.06 983.16 476.99 987.05 468.41
  Q 995.13 450.54 998.76 433.83
  Q 1001.76 420.03 1002.35 413.77
  Q 1004.78 387.72 1002.10 370.86
  Q 999.27 353.01 997.69 347.27
  C 992.34 327.82 983.62 308.86 971.81 291.97
  Q 964.94 282.16 962.55 279.35
  Q 934.74 246.80 897.51 230.33
  Q 860.10 213.78 817.46 215.41
  Q 767.24 217.33 724.01 246.57
  Q 716.59 251.59 710.48 257.02
  C 701.05 265.38 690.75 275.01 683.99 284.73
  C 679.93 290.56 673.57 299.29 669.48 306.73
  Q 637.35 365.30 651.38 431.87
  Q 652.92 439.17 654.94 444.83
  C 657.97 453.32 660.61 461.77 664.42 469.62
  Q 685.77 513.65 726.13 541.60
  C 739.41 550.79 753.61 557.44 769.05 562.93
  Q 782.60 567.75 796.69 569.94
  Q 835.61 575.99 874.20 565.55
  Q 886.98 562.09 900.21 555.48
  C 915.92 547.64 929.10 540.00 941.73 528.23
  C 950.76 519.80 955.34 516.02 961.30 508.47
  Z
  M 423.26 262.44
  Q 422.91 262.28 416.16 260.63
  C 406.78 258.32 396.02 254.20 389.91 246.95
  A 1.51 1.50 -65.8 0 1 389.55 246.00
  C 389.45 241.48 395.05 235.47 398.58 232.72
  A 0.34 0.34 0.0 0 0 398.31 232.12
  Q 355.54 239.04 292.72 248.41
  Q 283.41 249.80 276.00 252.47
  Q 267.43 255.56 243.44 264.70
  C 229.55 270.00 215.85 276.86 203.72 282.96
  Q 196.84 286.42 191.59 291.98
  A 1.02 1.01 -51.0 0 0 191.75 293.51
  C 200.22 299.32 210.87 301.46 221.26 302.75
  C 250.72 306.40 280.15 302.66 309.27 294.78
  Q 373.50 277.39 394.99 271.26
  Q 402.79 269.04 413.12 266.45
  C 416.30 265.66 420.61 263.80 423.21 263.08
  A 0.34 0.34 0.0 0 0 423.26 262.44
  Z
  M 1227.66 262.62
  Q 1229.73 263.88 1232.84 264.77
  Q 1259.26 272.35 1312.77 286.98
  Q 1344.81 295.74 1358.39 298.83
  C 1384.37 304.75 1410.53 305.94 1436.70 301.65
  Q 1449.20 299.60 1459.81 293.49
  A 0.82 0.82 0.0 0 0 1459.96 292.18
  Q 1453.79 286.39 1445.77 282.23
  Q 1436.07 277.18 1427.05 272.69
  C 1415.13 266.76 1395.15 259.76 1380.68 254.25
  C 1372.07 250.97 1364.78 249.35 1356.00 248.01
  Q 1299.63 239.45 1253.15 232.11
  A 0.37 0.36 -21.8 0 0 1252.87 232.76
  C 1256.10 235.22 1264.75 244.06 1259.99 248.52
  C 1251.29 256.65 1239.63 260.07 1227.85 261.69
  A 0.50 0.50 0.0 0 0 1227.66 262.62
  Z
  M 562.02 240.09
  A 0.37 0.37 0.0 0 0 561.57 239.61
  Q 538.56 245.99 507.49 255.01
  C 494.13 258.89 481.88 260.75 469.47 262.93
  Q 466.86 263.39 465.07 264.81
  Q 459.24 269.42 451.64 276.90
  Q 449.09 279.41 447.78 281.48
  A 0.83 0.82 -68.6 0 0 448.32 282.73
  C 461.12 285.11 471.64 283.06 486.63 279.95
  Q 500.33 277.10 511.62 273.09
  Q 525.29 268.23 555.83 256.28
  A 2.35 2.32 -4.8 0 0 557.27 254.59
  C 558.40 249.30 560.37 244.92 562.02 240.09
  Z
  M 1089.33 240.12
  C 1090.98 244.95 1092.96 249.33 1094.09 254.62
  A 2.35 2.33 4.8 0 0 1095.53 256.31
  Q 1126.07 268.25 1139.75 273.11
  Q 1151.04 277.12 1164.74 279.97
  C 1179.74 283.07 1190.26 285.12 1203.06 282.74
  A 0.83 0.82 68.5 0 0 1203.60 281.49
  Q 1202.29 279.42 1199.74 276.91
  Q 1192.14 269.43 1186.30 264.82
  Q 1184.51 263.40 1181.90 262.94
  C 1169.49 260.76 1157.24 258.90 1143.87 255.03
  Q 1112.80 246.01 1089.78 239.64
  A 0.37 0.37 0.0 0 0 1089.33 240.12
  Z
  M 579.62 265.26
  A 0.35 0.35 0.0 0 0 579.34 264.66
  Q 573.69 265.26 564.35 265.61
  C 562.62 265.68 560.92 266.20 559.64 266.72
  Q 531.42 278.32 518.57 282.20
  Q 515.56 283.10 514.49 286.67
  Q 511.25 297.49 510.15 308.59
  A 0.97 0.97 0.0 0 0 511.23 309.65
  Q 520.13 308.65 528.56 304.39
  Q 544.03 296.59 556.92 285.71
  Q 570.42 274.32 579.62 265.26
  Z
  M 1071.38 265.25
  Q 1080.65 274.34 1094.25 285.75
  Q 1107.23 296.65 1122.79 304.46
  Q 1131.28 308.72 1140.23 309.70
  A 0.98 0.98 0.0 0 0 1141.31 308.63
  Q 1140.18 297.48 1136.89 286.61
  Q 1135.81 283.03 1132.78 282.13
  Q 1119.86 278.26 1091.46 266.67
  C 1090.18 266.15 1088.47 265.63 1086.73 265.57
  Q 1077.34 265.24 1071.66 264.65
  A 0.35 0.35 0.0 0 0 1071.38 265.25
  Z
  M 453.45 295.34
  Q 452.24 295.14 448.77 294.67
  C 443.27 293.92 436.49 291.69 433.83 286.18
  A 1.82 1.77 -53.4 0 1 433.68 285.06
  Q 434.26 281.78 435.18 280.41
  Q 438.93 274.87 442.19 270.67
  A 0.36 0.35 24.8 0 0 441.98 270.11
  Q 441.49 270.00 441.11 270.11
  Q 378.25 287.81 329.24 300.98
  Q 319.25 303.66 315.72 305.47
  Q 312.33 307.20 307.71 310.44
  Q 291.74 321.67 279.08 335.16
  C 277.22 337.14 275.00 340.25 273.62 342.28
  A 0.51 0.50 23.7 0 0 273.93 343.06
  C 285.65 345.81 295.23 345.05 308.35 343.24
  C 330.24 340.20 347.35 334.21 371.92 326.44
  Q 382.62 323.05 398.89 316.54
  C 413.03 310.87 423.72 307.53 436.73 302.30
  Q 439.65 301.12 453.48 295.60
  A 0.14 0.14 0.0 0 0 453.45 295.34
  Z
  M 1209.42 270.27
  A 0.26 0.26 0.0 0 0 1209.15 270.68
  C 1212.20 274.70 1217.88 281.35 1217.59 285.02
  C 1217.16 290.47 1207.55 293.72 1203.01 294.31
  Q 1200.31 294.65 1197.12 294.64
  A 0.39 0.39 0.0 0 0 1196.99 295.40
  C 1207.55 299.02 1219.47 304.46 1229.51 307.95
  Q 1234.56 309.71 1261.65 320.07
  Q 1285.84 329.33 1313.74 337.19
  Q 1336.49 343.59 1357.50 344.96
  Q 1368.01 345.64 1377.38 342.81
  A 0.61 0.60 62.0 0 0 1377.67 341.85
  Q 1361.56 321.99 1339.38 307.60
  C 1334.75 304.60 1329.67 303.05 1324.57 301.67
  Q 1279.91 289.62 1233.05 276.46
  Q 1218.45 272.36 1209.42 270.27
  Z
  M 611.58 286.22
  Q 609.57 287.12 605.94 288.95
  Q 597.75 293.08 589.07 292.98
  C 584.71 292.93 581.68 292.91 581.12 288.05
  Q 580.83 285.50 580.52 280.99
  A 0.41 0.41 0.0 0 0 579.84 280.72
  Q 572.98 287.03 565.04 293.15
  Q 558.84 297.93 555.93 301.80
  Q 549.63 310.17 547.26 318.77
  A 1.22 1.21 13.9 0 0 548.18 320.28
  Q 556.53 322.06 565.44 320.65
  C 581.12 318.17 596.03 313.08 611.07 307.37
  A 1.10 1.10 0.0 0 0 611.77 306.19
  Q 610.41 296.10 611.83 286.40
  A 0.18 0.17 -8.7 0 0 611.58 286.22
  Z
  M 1039.46 286.28
  A 0.18 0.17 8.6 0 0 1039.21 286.46
  Q 1040.65 296.16 1039.31 306.26
  A 1.10 1.10 0.0 0 0 1040.01 307.43
  C 1055.07 313.12 1069.99 318.18 1085.68 320.63
  Q 1094.60 322.02 1102.95 320.23
  A 1.22 1.21 -14.0 0 0 1103.86 318.71
  Q 1101.48 310.12 1095.16 301.76
  Q 1092.24 297.89 1086.03 293.12
  Q 1078.07 287.01 1071.20 280.72
  A 0.41 0.41 0.0 0 0 1070.52 280.99
  Q 1070.22 285.50 1069.93 288.05
  C 1069.38 292.91 1066.35 292.94 1061.99 293.00
  Q 1053.31 293.11 1045.11 289.00
  Q 1041.47 287.18 1039.46 286.28
  Z
  M 502.11 289.82
  Q 499.36 290.34 494.20 292.21
  Q 485.33 295.43 467.59 302.51
  Q 460.56 305.32 442.52 311.90
  Q 438.55 313.35 417.56 321.54
  Q 401.46 327.81 387.40 332.81
  A 2.62 2.60 2.4 0 0 385.88 334.20
  Q 383.63 339.07 376.35 353.37
  C 372.22 361.49 369.24 369.30 367.29 377.82
  A 0.32 0.31 5.6 0 0 367.61 378.20
  Q 372.45 378.08 377.61 376.84
  Q 394.06 372.87 409.37 365.11
  Q 424.91 357.24 433.88 351.88
  Q 437.47 349.74 452.65 338.78
  C 458.97 334.21 463.31 329.94 468.99 325.39
  C 477.04 318.95 484.11 310.70 492.13 304.06
  C 496.50 300.44 500.88 295.48 502.40 290.15
  A 0.26 0.25 -87.0 0 0 502.11 289.82
  Z
  M 1149.83 290.19
  A 0.72 0.71 -23.4 0 0 1149.44 291.17
  Q 1153.10 298.68 1159.40 304.36
  C 1168.90 312.92 1177.97 322.17 1186.27 329.13
  Q 1195.47 336.85 1209.44 346.74
  C 1218.63 353.24 1225.02 356.26 1236.49 362.50
  Q 1255.07 372.60 1273.28 376.69
  Q 1277.94 377.74 1283.17 378.16
  A 0.62 0.61 -3.5 0 0 1283.82 377.43
  C 1282.17 369.33 1279.33 361.75 1275.20 353.84
  Q 1269.72 343.33 1265.67 334.11
  A 2.73 2.73 0.0 0 0 1264.04 332.63
  Q 1250.99 328.25 1239.89 323.84
  C 1216.95 314.73 1205.02 310.83 1181.79 301.58
  Q 1167.67 295.96 1150.62 290.32
  Q 1150.01 290.12 1149.83 290.19
  Z
  M 644.28 304.39
  Q 639.05 307.93 639.00 307.97
  Q 633.23 311.93 627.66 314.34
  C 623.95 315.95 619.23 316.55 615.93 317.31
  A 15.60 15.49 26.8 0 0 613.44 318.12
  C 601.25 323.25 591.91 325.95 578.44 329.63
  C 576.01 330.29 574.57 331.25 573.23 333.24
  Q 570.81 336.83 568.39 340.94
  A 0.62 0.62 0.0 0 0 568.73 341.84
  C 578.21 344.96 587.89 345.91 598.55 345.38
  Q 621.26 344.26 643.15 339.02
  A 3.09 3.08 -89.8 0 0 645.42 336.76
  L 647.18 329.74
  A 8.09 8.05 50.6 0 0 647.42 327.22
  Q 647.39 326.23 647.09 324.84
  Q 645.00 315.10 644.72 304.62
  A 0.29 0.28 71.9 0 0 644.28 304.39
  Z
  M 1006.55 304.52
  A 0.29 0.28 -72.2 0 0 1006.11 304.76
  Q 1005.88 315.26 1003.82 325.03
  Q 1003.53 326.42 1003.50 327.41
  A 8.11 8.07 -50.8 0 0 1003.75 329.94
  L 1005.55 336.96
  A 3.09 3.09 0.0 0 0 1007.83 339.22
  Q 1029.78 344.38 1052.54 345.40
  C 1063.23 345.89 1072.92 344.90 1082.41 341.73
  A 0.62 0.62 0.0 0 0 1082.74 340.83
  Q 1080.30 336.72 1077.86 333.13
  C 1076.51 331.15 1075.07 330.19 1072.63 329.54
  C 1059.12 325.91 1049.75 323.24 1037.51 318.15
  A 15.63 15.52 -27.0 0 0 1035.01 317.35
  C 1031.70 316.60 1026.97 316.02 1023.25 314.42
  Q 1017.66 312.03 1011.86 308.09
  Q 1011.81 308.05 1006.55 304.52
  Z
  M 523.27 318.47
  Q 521.47 318.92 518.19 319.94
  Q 510.97 322.18 504.05 321.66
  C 500.33 321.38 499.70 317.25 499.00 314.14
  A 0.60 0.60 0.0 0 0 498.01 313.84
  Q 482.86 328.12 472.80 336.92
  Q 466.44 342.48 447.61 356.41
  C 444.40 358.78 443.69 362.59 442.56 367.38
  Q 440.35 376.87 438.84 390.30
  Q 438.44 393.80 438.93 397.44
  A 0.80 0.79 79.7 0 0 439.88 398.11
  C 449.99 395.90 459.18 389.72 467.54 383.49
  C 490.60 366.31 509.14 343.45 523.42 318.67
  A 0.14 0.13 8.6 0 0 523.27 318.47
  Z
  M 1127.69 318.19
  A 0.14 0.13 -8.6 0 0 1127.54 318.39
  C 1141.85 343.25 1160.44 366.18 1183.56 383.42
  C 1191.95 389.67 1201.16 395.87 1211.30 398.09
  A 0.80 0.79 -79.7 0 0 1212.26 397.42
  Q 1212.75 393.77 1212.35 390.26
  Q 1210.84 376.79 1208.62 367.27
  C 1207.49 362.46 1206.78 358.64 1203.56 356.26
  Q 1184.68 342.29 1178.30 336.71
  Q 1168.22 327.88 1153.03 313.55
  A 0.60 0.60 0.0 0 0 1152.03 313.85
  C 1151.33 316.97 1150.70 321.11 1146.97 321.39
  Q 1140.02 321.91 1132.78 319.66
  Q 1129.49 318.64 1127.69 318.19
  Z
  M 1117.03 324.52
  C 1114.10 331.92 1098.47 332.55 1091.72 331.92
  A 0.48 0.48 0.0 0 0 1091.23 332.57
  C 1095.19 342.49 1102.81 350.35 1110.79 358.22
  Q 1131.51 378.65 1155.90 392.39
  Q 1162.52 396.12 1169.53 397.21
  A 0.70 0.69 6.6 0 0 1170.33 396.58
  C 1170.64 393.15 1170.74 387.57 1168.01 385.23
  Q 1159.83 378.23 1152.71 370.54
  Q 1132.83 349.04 1117.98 324.44
  A 0.53 0.53 0.0 0 0 1117.03 324.52
  Z
  M 534.04 324.71
  A 0.53 0.53 0.0 0 0 533.09 324.64
  Q 518.32 349.19 498.52 370.66
  Q 491.43 378.34 483.29 385.33
  C 480.57 387.67 480.68 393.23 480.99 396.65
  A 0.70 0.69 -6.6 0 0 481.79 397.28
  Q 488.78 396.18 495.37 392.45
  Q 519.68 378.72 540.31 358.31
  C 548.26 350.45 555.85 342.60 559.78 332.71
  A 0.48 0.48 0.0 0 0 559.29 332.06
  C 552.56 332.70 536.97 332.09 534.04 324.71
  Z
  M 641.06 351.35
  A 0.27 0.27 0.0 0 0 640.73 351.05
  Q 624.98 354.76 608.52 356.28
  Q 603.42 356.75 601.21 358.30
  Q 595.86 362.03 591.76 367.99
  A 0.61 0.61 0.0 0 0 592.02 368.89
  C 606.27 375.02 621.24 376.32 636.70 376.35
  A 0.58 0.57 4.0 0 0 637.27 375.86
  L 641.06 351.35
  Z
  M 584.78 357.70
  A 0.48 0.47 -67.5 0 0 584.46 356.92
  Q 572.87 355.82 562.85 351.37
  A 1.18 1.18 0.0 0 0 561.48 351.68
  Q 536.80 380.44 504.54 400.04
  Q 502.82 401.08 501.40 403.60
  Q 496.10 412.96 494.33 423.20
  A 0.79 0.78 -86.0 0 0 495.11 424.11
  Q 507.07 423.91 519.09 419.04
  C 542.60 409.50 564.74 394.36 585.46 378.66
  A 0.53 0.53 0.0 0 0 585.38 377.76
  C 583.47 376.78 578.79 373.99 578.37 371.67
  C 577.54 367.08 581.83 361.24 584.78 357.70
  Z
  M 1009.81 351.31
  L 1013.64 375.86
  A 0.58 0.57 -4.1 0 0 1014.22 376.35
  C 1029.70 376.30 1044.70 374.97 1058.97 368.80
  A 0.61 0.61 0.0 0 0 1059.23 367.90
  Q 1055.11 361.94 1049.74 358.21
  Q 1047.53 356.66 1042.41 356.20
  Q 1025.92 354.70 1010.14 351.01
  A 0.27 0.27 0.0 0 0 1009.81 351.31
  Z
  M 1157.12 423.74
  Q 1155.23 413.02 1149.61 403.37
  Q 1148.37 401.25 1146.90 400.34
  C 1125.42 387.02 1106.23 370.48 1089.42 351.52
  A 0.96 0.95 -29.2 0 0 1088.41 351.24
  Q 1087.32 351.58 1085.16 352.50
  C 1079.07 355.08 1072.14 356.15 1065.19 356.48
  A 0.42 0.42 0.0 0 0 1064.92 357.20
  Q 1069.69 361.87 1072.37 368.10
  C 1074.43 372.91 1068.41 375.79 1065.36 377.59
  A 0.55 0.55 0.0 0 0 1065.30 378.50
  C 1080.64 390.52 1099.41 403.33 1115.61 411.64
  C 1128.00 418.01 1142.97 424.52 1156.82 424.12
  A 0.32 0.32 0.0 0 0 1157.12 423.74
  Z
  M 605.50 384.86
  L 599.37 383.35
  A 4.02 4.00 32.0 0 0 595.82 384.16
  Q 564.50 410.15 528.38 427.57
  A 7.32 7.28 4.8 0 0 525.57 429.94
  Q 519.73 438.12 517.01 448.23
  A 0.64 0.63 14.7 0 0 517.47 449.01
  Q 531.00 452.34 544.76 447.69
  Q 555.50 444.08 571.52 435.86
  Q 577.41 432.84 585.29 427.41
  C 594.37 421.14 602.87 416.06 611.39 408.81
  A 0.66 0.66 0.0 0 0 611.22 407.70
  Q 605.18 405.20 601.32 402.04
  C 595.23 397.06 601.55 390.22 605.90 386.65
  A 1.02 1.02 0.0 0 0 605.50 384.86
  Z
  M 1045.33 384.71
  A 1.03 1.02 57.7 0 0 1044.93 386.50
  C 1049.30 390.08 1055.65 396.94 1049.54 401.94
  Q 1045.67 405.11 1039.62 407.62
  A 0.66 0.66 0.0 0 0 1039.45 408.74
  C 1048.00 416.00 1056.53 421.09 1065.65 427.37
  Q 1073.56 432.81 1079.47 435.83
  Q 1095.55 444.06 1106.32 447.68
  Q 1120.13 452.33 1133.70 448.97
  A 0.64 0.63 -14.8 0 0 1134.16 448.19
  Q 1131.42 438.05 1125.56 429.85
  A 7.34 7.30 -4.8 0 0 1122.74 427.48
  Q 1086.49 410.04 1055.04 384.00
  A 4.03 4.02 -32.1 0 0 1051.48 383.19
  L 1045.33 384.71
  Z
  M 636.23 387.89
  Q 627.49 387.73 624.00 387.76
  C 619.72 387.79 615.40 392.15 612.98 395.08
  A 1.00 1.00 0.0 0 0 613.31 396.62
  C 620.19 400.03 628.01 401.03 636.33 401.86
  A 0.39 0.39 0.0 0 0 636.76 401.47
  L 636.76 388.43
  A 0.54 0.54 0.0 0 0 636.23 387.89
  Z
  M 1014.29 402.02
  Q 1027.34 401.05 1038.45 396.54
  A 0.69 0.69 0.0 0 0 1038.71 395.45
  C 1036.54 393.00 1031.40 388.10 1027.82 387.90
  Q 1021.13 387.53 1014.41 387.86
  A 0.53 0.53 0.0 0 0 1013.90 388.39
  L 1013.90 401.65
  A 0.37 0.36 87.8 0 0 1014.29 402.02
  Z
  M 630.79 412.98
  A 0.24 0.24 0.0 0 0 630.65 412.62
  Q 626.30 411.39 622.85 414.19
  Q 601.95 431.24 575.54 446.39
  C 567.98 450.73 561.55 453.32 552.80 456.64
  Q 549.69 457.82 548.51 461.36
  Q 546.51 467.27 545.70 472.54
  A 0.53 0.53 0.0 0 0 546.20 473.14
  Q 552.41 473.26 557.27 471.70
  Q 577.36 465.27 588.02 458.47
  C 601.37 449.95 610.53 443.96 620.66 435.02
  A 2.82 2.81 -18.0 0 0 621.60 433.19
  Q 622.33 425.86 626.39 419.46
  Q 626.47 419.34 630.79 412.98
  Z
  M 1020.02 412.76
  Q 1024.38 419.17 1024.46 419.29
  Q 1028.56 425.75 1029.30 433.14
  A 2.85 2.83 18.0 0 0 1030.25 434.99
  C 1040.47 444.00 1049.72 450.04 1063.19 458.63
  Q 1073.94 465.48 1094.21 471.96
  Q 1099.12 473.53 1105.38 473.41
  A 0.53 0.53 0.0 0 0 1105.89 472.80
  Q 1105.07 467.49 1103.05 461.52
  Q 1101.85 457.95 1098.72 456.76
  C 1089.89 453.42 1083.40 450.81 1075.77 446.44
  Q 1049.12 431.16 1028.03 413.97
  Q 1024.55 411.15 1020.16 412.39
  A 0.24 0.24 0.0 0 0 1020.02 412.76
  Z
  M 1011.81 421.91
  L 1011.71 427.58
  A 0.43 0.43 0.0 0 0 1012.14 428.02
  L 1015.28 428.02
  A 0.73 0.72 74.9 0 0 1015.90 426.93
  L 1012.85 421.64
  A 0.56 0.56 0.0 0 0 1011.81 421.91
  Z
  M 637.83 421.90
  L 635.61 426.50
  A 0.84 0.84 0.0 0 0 636.35 427.70
  L 639.12 427.75
  A 0.77 0.76 85.3 0 0 639.88 426.85
  L 639.00 422.06
  A 0.62 0.62 0.0 0 0 637.83 421.90
  Z
  M 1019.46 440.90
  A 0.22 0.22 0.0 0 0 1019.12 441.18
  C 1024.61 450.86 1032.20 459.32 1040.18 468.30
  Q 1051.53 481.06 1065.97 491.27
  Q 1072.64 495.98 1080.32 498.37
  A 0.76 0.76 0.0 0 0 1081.30 497.73
  Q 1082.26 489.28 1081.40 480.83
  A 2.44 2.40 -81.9 0 0 1079.93 478.84
  Q 1058.27 469.84 1039.04 455.94
  Q 1026.70 447.02 1019.46 440.90
  Z
  M 630.96 441.58
  Q 623.81 447.63 611.61 456.44
  Q 592.60 470.17 571.19 479.05
  A 2.41 2.38 81.9 0 0 569.74 481.02
  Q 568.89 489.37 569.83 497.72
  A 0.75 0.75 0.0 0 0 570.80 498.35
  Q 578.39 495.99 584.98 491.34
  Q 599.26 481.26 610.48 468.65
  C 618.37 459.78 625.87 451.43 631.30 441.86
  A 0.22 0.22 0.0 0 0 630.96 441.58
  Z
  M 643.33 444.37
  Q 638.78 450.87 634.49 456.86
  C 626.88 467.46 618.23 477.40 609.65 485.69
  A 2.24 2.22 63.6 0 0 609.00 487.66
  Q 610.93 499.61 616.89 510.34
  A 0.89 0.89 0.0 0 0 618.26 510.57
  Q 629.73 500.45 637.35 486.62
  Q 644.21 474.15 648.44 462.10
  Q 649.04 460.36 648.15 457.70
  Q 644.36 446.32 643.84 444.46
  A 0.29 0.28 54.8 0 0 643.33 444.37
  Z
  M 1007.63 444.38
  A 0.29 0.29 0.0 0 0 1007.12 444.47
  Q 1006.60 446.34 1002.82 457.77
  Q 1001.93 460.45 1002.54 462.19
  Q 1006.81 474.28 1013.73 486.79
  Q 1021.41 500.66 1032.95 510.80
  A 0.90 0.90 0.0 0 0 1034.33 510.56
  Q 1040.29 499.77 1042.20 487.77
  A 2.25 2.22 -63.8 0 0 1041.54 485.79
  C 1032.91 477.49 1024.20 467.53 1016.54 456.90
  Q 1012.21 450.89 1007.63 444.38
  Z
  M 655.93 475.29
  A 0.23 0.22 44.3 0 0 655.53 475.29
  L 647.74 491.48
  A 3.61 3.61 0.0 0 0 647.54 494.12
  Q 648.90 498.56 651.59 502.93
  Q 656.71 511.23 658.29 513.44
  A 0.74 0.74 0.0 0 0 659.50 513.44
  L 668.55 500.79
  A 2.35 2.34 -44.0 0 0 668.60 498.12
  C 663.64 490.60 660.09 483.18 655.93 475.29
  Z
  M 995.12 475.47
  Q 995.08 475.48 994.87 475.59
  A 0.28 0.24 -7.2 0 0 994.78 475.69
  Q 989.75 487.02 982.86 497.27
  A 3.52 3.52 0.0 0 0 982.92 501.27
  L 991.30 513.03
  A 0.84 0.84 0.0 0 0 992.65 513.06
  Q 998.50 505.46 1003.18 496.04
  C 1004.23 493.94 1004.37 492.74 1003.30 490.75
  Q 999.01 482.75 996.08 475.91
  A 0.78 0.77 69.3 0 0 995.12 475.47
  Z"
        />
        <path d="
  M 732.93 251.64
  L 738.96 247.86
  A 1.08 1.02 20.1 0 1 739.24 247.74
  Q 741.50 247.04 743.97 245.33
  Q 746.11 243.86 748.45 242.71
  Q 757.78 238.11 759.96 237.24
  Q 798.90 221.56 840.94 225.13
  Q 877.08 228.20 908.33 246.10
  Q 933.28 260.39 950.94 280.08
  Q 953.55 283.00 959.90 290.77
  C 965.16 297.20 968.80 304.14 973.22 311.34
  C 976.51 316.70 979.06 323.45 981.56 329.15
  Q 991.96 352.93 994.05 382.50
  Q 994.97 395.43 994.40 399.89
  C 993.65 405.74 993.09 416.46 991.39 424.30
  Q 986.68 446.09 981.22 459.24
  Q 979.46 463.49 973.58 474.81
  Q 969.83 482.02 964.49 489.56
  Q 952.72 506.21 935.92 521.43
  Q 928.07 528.53 920.12 533.63
  Q 910.77 539.62 903.00 543.96
  Q 889.27 551.63 869.74 557.03
  Q 839.76 565.32 811.77 562.52
  C 792.92 560.63 775.68 556.83 758.15 548.83
  C 744.75 542.72 732.72 535.91 721.86 527.10
  Q 715.01 521.54 713.35 520.04
  Q 708.63 515.78 698.64 505.14
  C 692.56 498.65 686.28 489.32 682.91 484.26
  Q 676.84 475.15 671.22 462.35
  Q 662.45 442.38 658.81 421.28
  C 653.88 392.68 656.42 362.06 667.00 334.51
  Q 672.94 319.04 676.51 312.99
  Q 679.84 307.35 685.23 298.48
  Q 690.75 289.40 703.51 275.75
  Q 704.31 274.89 704.85 274.03
  A 2.40 2.37 -1.5 0 1 705.55 273.30
  C 708.06 271.61 710.98 268.32 713.70 266.11
  Q 724.08 257.63 731.27 252.97
  Q 732.11 252.42 732.66 251.87
  A 1.55 1.43 2.3 0 1 732.93 251.64
  Z
  M 810.77 235.41
  L 798.24 237.12
  L 790.03 238.87
  L 786.56 239.87
  L 781.01 241.02
  L 776.89 242.55
  Q 771.70 243.18 767.36 245.89
  L 757.32 250.46
  L 754.07 251.84
  L 742.47 258.40
  Q 741.20 258.92 739.88 260.10
  L 730.72 266.06
  Q 726.60 267.85 723.99 271.26
  L 719.12 275.76
  L 713.87 280.74
  L 709.71 285.12
  L 706.53 288.42
  L 698.05 299.43
  Q 694.15 303.62 691.39 307.51
  Q 689.90 309.60 689.89 311.22
  L 682.53 324.75
  Q 676.91 329.73 677.01 337.70
  Q 674.66 344.49 672.73 350.76
  Q 672.60 351.18 672.96 351.46
  L 672.78 353.65
  Q 671.93 353.47 671.76 354.26
  Q 670.33 360.94 668.95 367.63
  A 0.33 0.30 -60.7 0 0 669.01 367.89
  Q 669.22 368.16 669.62 368.18
  L 669.97 370.53
  Q 668.61 370.45 668.41 371.69
  Q 667.23 379.02 667.15 384.45
  L 667.08 388.03
  Q 666.72 393.86 667.28 400.48
  Q 667.37 401.52 668.22 401.71
  L 668.21 404.44
  Q 667.95 404.37 667.69 404.63
  A 0.48 0.45 -23.7 0 0 667.55 404.96
  Q 667.60 409.54 668.98 417.53
  Q 669.27 419.20 670.91 418.75
  L 669.87 421.58
  Q 670.57 425.34 672.64 433.87
  Q 673.02 435.41 673.97 435.89
  L 674.20 438.00
  Q 673.71 438.25 673.94 438.99
  Q 675.52 444.08 677.34 449.39
  L 679.01 452.43
  Q 680.74 457.46 682.98 461.27
  Q 683.23 461.70 683.95 461.79
  L 684.71 464.12
  Q 684.53 464.07 684.35 464.32
  A 0.45 0.45 0.0 0 0 684.32 464.82
  L 690.37 475.29
  A 0.49 0.46 81.6 0 0 690.66 475.52
  Q 691.26 475.70 691.67 475.27
  L 693.84 477.41
  Q 693.22 478.35 693.11 479.65
  A 1.09 1.04 -61.5 0 0 693.30 480.35
  L 697.94 486.86
  A 1.48 1.46 -14.8 0 0 699.01 487.47
  L 701.97 487.74
  L 700.93 487.91
  A 0.89 0.89 0.0 0 0 700.82 489.64
  L 702.48 490.14
  Q 701.81 490.02 701.41 490.14
  A 0.45 0.45 0.0 0 0 701.19 490.85
  L 707.62 498.77
  L 708.90 500.21
  Q 713.82 506.53 719.67 510.80
  L 722.41 512.99
  L 732.80 521.70
  L 735.68 523.51
  L 746.80 530.83
  Q 748.34 531.15 750.03 532.30
  Q 755.51 536.46 762.47 538.80
  L 765.11 540.00
  L 778.04 544.80
  Q 779.72 545.77 781.33 546.09
  L 794.88 549.36
  Q 802.15 552.04 811.72 551.90
  L 823.37 552.34
  Q 824.28 552.63 825.01 552.39
  L 835.89 552.04
  Q 836.98 551.73 836.69 552.12
  L 853.16 550.22
  Q 858.95 549.71 865.68 547.68
  Q 867.88 547.02 869.36 546.20
  L 877.22 543.74
  L 882.59 541.34
  L 894.33 536.44
  L 897.73 534.72
  L 907.51 529.10
  Q 909.28 529.23 910.94 525.45
  Q 911.11 526.60 912.30 525.82
  Q 913.16 525.27 913.27 525.20
  Q 917.83 522.64 921.80 518.76
  Q 924.89 517.07 927.03 514.75
  L 932.51 510.37
  L 935.13 507.57
  Q 940.13 503.75 941.51 499.41
  Q 942.47 498.01 944.59 497.25
  L 953.32 486.19
  L 956.22 482.52
  L 959.21 477.95
  Q 962.03 475.14 963.49 472.52
  Q 967.84 464.75 973.05 453.57
  Q 975.19 448.98 976.40 441.05
  L 978.40 434.49
  L 978.07 431.48
  Q 978.41 431.58 978.70 431.41
  Q 978.93 431.27 979.03 430.89
  Q 980.79 424.46 981.64 417.76
  Q 981.39 416.00 982.03 414.81
  L 983.50 401.05
  Q 982.88 399.61 982.78 397.85
  Q 983.02 397.86 983.24 397.61
  A 0.50 0.47 -23.3 0 0 983.37 397.31
  Q 983.83 388.95 983.48 384.47
  Q 983.42 383.61 982.28 383.87
  Q 982.45 382.55 982.03 381.21
  Q 982.69 381.36 983.02 381.16
  Q 983.33 380.97 983.25 380.25
  Q 982.57 373.79 981.45 367.33
  A 0.38 0.37 17.4 0 0 981.33 367.11
  Q 980.94 366.77 980.05 366.86
  Q 981.10 366.01 980.61 363.95
  Q 979.91 357.16 977.59 349.68
  L 976.73 347.14
  L 972.90 336.48
  L 972.15 333.01
  A 0.17 0.17 0.0 0 0 971.82 333.00
  Q 971.70 333.39 971.87 333.83
  A 0.09 0.09 0.0 0 1 971.87 333.89
  Q 971.76 334.07 971.60 334.11
  A 0.15 0.15 0.0 0 1 971.42 333.91
  Q 972.18 331.97 970.77 330.30
  Q 970.79 330.07 970.67 329.82
  Q 969.74 325.23 966.58 321.67
  Q 966.16 321.20 965.99 320.21
  L 960.28 309.54
  L 957.89 307.41
  Q 957.66 305.93 956.16 304.49
  Q 954.68 299.21 949.96 296.96
  A 0.52 0.52 0.0 0 1 949.70 296.30
  Q 950.37 294.62 949.12 294.17
  L 944.13 288.11
  Q 941.67 287.10 941.84 286.01
  Q 936.84 279.99 931.28 275.41
  L 929.18 273.28
  Q 924.22 268.22 917.47 264.78
  L 915.10 263.04
  Q 909.44 258.45 904.23 255.94
  Q 903.78 255.72 903.08 255.99
  L 900.72 254.49
  Q 900.73 253.64 899.69 253.05
  Q 894.33 249.99 888.05 247.85
  Q 886.78 246.66 885.30 246.41
  L 871.25 241.68
  Q 870.29 241.08 869.66 241.03
  L 855.69 237.66
  L 850.04 237.32
  L 846.58 236.91
  L 842.19 235.96
  Q 833.89 234.67 825.95 234.84
  Q 818.98 234.10 810.77 235.41
  Z"
        />
        <path d="
  M 883.97 327.66
  Q 884.03 332.87 883.33 337.10
  Q 883.06 338.73 879.72 345.85
  Q 877.75 350.05 874.76 353.87
  C 869.15 361.05 865.72 365.21 859.80 369.67
  Q 855.79 372.68 851.79 375.31
  A 1.11 1.10 -32.1 0 0 851.45 376.79
  Q 856.40 385.16 864.94 399.30
  Q 870.31 408.19 875.40 415.35
  Q 894.10 441.65 903.37 454.14
  Q 910.37 463.57 914.54 468.55
  A 0.53 0.53 0.0 0 1 914.31 469.39
  Q 910.49 470.68 906.75 469.40
  A 3.15 3.07 -17.4 0 1 905.90 468.97
  Q 900.81 465.29 898.76 463.23
  C 894.70 459.17 889.09 453.48 884.64 448.38
  Q 871.99 433.89 866.13 427.23
  C 854.52 414.01 843.30 400.06 830.98 385.98
  A 2.62 2.60 73.2 0 0 829.35 385.10
  C 826.91 384.77 824.76 385.47 822.52 385.62
  Q 810.17 386.48 798.08 386.37
  A 0.54 0.54 0.0 0 0 797.54 386.91
  Q 797.57 412.60 798.41 440.31
  Q 798.67 448.99 799.28 456.84
  A 1.78 1.78 0.0 0 0 800.78 458.46
  L 824.43 462.11
  A 1.31 1.30 4.4 0 1 825.54 463.40
  L 825.54 463.75
  A 0.80 0.80 0.0 0 1 824.74 464.55
  L 754.81 464.66
  A 1.32 1.31 2.4 0 1 753.49 463.23
  L 753.50 463.16
  A 2.00 1.99 1.6 0 1 755.32 461.45
  Q 767.41 460.48 776.76 458.41
  A 2.56 2.55 -3.3 0 0 778.75 456.18
  Q 779.27 451.27 779.38 447.25
  Q 779.95 427.50 780.09 391.50
  Q 780.22 357.68 780.10 322.84
  C 780.08 316.42 779.62 308.55 778.76 302.60
  Q 778.47 300.58 775.50 300.41
  Q 773.57 300.30 755.06 298.59
  A 2.11 2.10 1.1 0 1 753.15 296.61
  L 753.14 296.54
  A 1.65 1.64 89.0 0 1 754.81 294.81
  Q 784.62 295.36 800.75 294.89
  Q 825.09 294.17 846.99 297.23
  Q 855.12 298.37 863.68 301.52
  Q 876.50 306.23 882.07 318.39
  Q 883.91 322.40 883.97 327.66
  Z
  M 799.58 300.17
  A 0.62 0.62 0.0 0 0 798.96 300.76
  Q 797.22 338.63 797.70 379.52
  A 0.56 0.56 0.0 0 0 798.23 380.08
  Q 815.65 381.20 832.35 376.58
  Q 846.56 372.64 855.65 360.37
  Q 862.53 351.07 864.00 340.56
  Q 865.18 332.13 862.49 325.71
  Q 859.30 318.08 853.46 313.69
  C 837.66 301.81 819.03 300.12 799.58 300.17
  Z"
        />
        <path d="
  M 957.46 338.52
  Q 957.69 336.83 958.74 335.84
  A 0.68 0.68 0.0 0 1 959.87 336.21
  Q 960.36 338.74 960.11 342.00
  Q 959.14 354.23 958.64 364.80
  A 1.04 1.03 4.6 0 1 957.48 365.78
  L 957.15 365.72
  A 1.22 1.22 0.0 0 1 956.14 364.52
  L 956.14 356.17
  A 5.39 5.37 -63.6 0 0 955.05 352.92
  C 950.78 347.26 944.63 345.95 937.02 345.25
  C 927.96 344.41 918.67 345.63 911.30 350.80
  Q 901.24 357.84 898.69 368.52
  Q 897.16 374.95 898.09 381.51
  Q 899.00 387.88 901.69 394.08
  C 904.07 399.57 908.48 404.10 913.97 408.10
  C 923.61 415.14 936.49 416.76 948.29 414.58
  Q 955.98 413.16 961.55 409.99
  A 1.60 1.53 -60.2 0 1 962.23 409.79
  Q 962.59 409.76 962.61 409.76
  A 1.00 1.00 0.0 0 1 962.99 411.46
  Q 959.84 414.32 957.13 415.35
  Q 932.96 424.52 909.31 414.30
  C 889.23 405.61 884.66 380.94 894.17 363.13
  Q 902.97 346.64 921.32 342.83
  Q 938.75 339.20 955.75 344.22
  A 0.71 0.71 0.0 0 0 956.65 343.67
  Q 957.08 341.23 957.46 338.52
  Z"
        />
        <path d="
  M 689.18 344.65
  Q 693.75 344.68 699.00 345.06
  Q 704.79 345.48 715.34 344.53
  A 1.23 1.22 -17.7 0 1 716.49 345.12
  L 716.50 345.14
  A 0.54 0.54 0.0 0 1 716.14 345.95
  L 708.22 347.39
  A 1.69 1.69 0.0 0 0 706.83 349.03
  L 706.27 380.38
  A 0.56 0.56 0.0 0 0 707.17 380.83
  C 719.69 371.33 726.98 363.88 742.51 348.74
  A 0.85 0.84 26.4 0 0 742.02 347.30
  L 736.96 346.65
  A 1.16 1.15 0.7 0 1 735.96 345.64
  L 735.96 345.61
  A 0.71 0.71 0.0 0 1 736.67 344.86
  L 759.26 344.66
  A 0.61 0.60 15.9 0 1 759.78 345.59
  L 759.74 345.65
  A 2.65 2.64 -76.7 0 1 757.82 346.84
  Q 753.30 347.37 751.77 348.52
  Q 737.98 358.82 723.70 371.95
  A 0.80 0.80 0.0 0 0 723.64 373.07
  Q 729.51 379.74 734.31 385.96
  C 743.12 397.35 751.85 407.21 761.13 418.43
  Q 761.47 418.84 766.50 424.03
  Q 767.23 424.80 767.38 425.46
  A 0.59 0.58 5.4 0 1 766.58 426.12
  Q 762.07 424.18 758.63 421.12
  Q 745.53 409.48 736.77 399.99
  C 729.66 392.27 722.97 386.37 716.24 378.69
  A 0.86 0.85 -38.2 0 0 715.09 378.56
  L 706.72 384.52
  A 0.87 0.86 -18.1 0 0 706.36 385.22
  L 706.36 416.37
  A 1.52 1.51 -84.5 0 0 707.58 417.86
  L 716.73 419.62
  A 0.88 0.87 11.8 0 1 717.42 420.67
  L 717.41 420.71
  A 1.01 1.01 0.0 0 1 716.35 421.51
  Q 702.77 420.56 689.41 421.37
  A 1.08 1.07 -9.3 0 1 688.31 420.59
  L 688.30 420.56
  A 0.73 0.73 0.0 0 1 688.96 419.64
  Q 695.83 419.19 696.88 417.90
  Q 697.69 416.90 697.78 413.50
  Q 698.53 385.75 698.33 357.25
  Q 698.32 355.83 697.88 349.05
  A 1.31 1.29 6.1 0 0 696.93 347.89
  L 689.04 345.71
  A 0.54 0.54 0.0 0 1 689.18 344.65
  Z"
        />
      </g>
      <g fill="gray">
        <path d="
  M 825.95 234.84
  Q 826.76 239.00 829.47 242.96
  A 1.30 1.27 72.5 0 0 830.50 243.51
  L 837.79 243.64
  A 1.39 1.38 -77.0 0 0 839.08 242.83
  L 842.19 235.96
  L 846.58 236.91
  Q 842.93 237.86 840.51 244.05
  A 1.12 1.11 41.1 0 0 840.58 245.02
  L 844.21 251.30
  A 0.78 0.78 0.0 0 0 844.87 251.69
  L 851.91 251.82
  A 2.05 2.05 0.0 0 0 853.79 250.66
  L 856.78 244.44
  A 0.80 0.80 0.0 0 0 856.75 243.68
  L 853.50 238.03
  A 1.14 1.14 0.0 0 0 852.88 237.54
  Q 851.53 237.14 850.04 237.32
  L 855.69 237.66
  L 858.71 243.08
  A 1.03 1.03 0.0 0 0 859.47 243.60
  Q 864.70 244.32 866.98 243.75
  Q 868.86 243.28 869.66 241.03
  Q 870.29 241.08 871.25 241.68
  Q 869.39 244.24 870.69 246.83
  Q 872.28 249.99 873.40 251.68
  A 1.34 1.33 -16.5 0 0 874.49 252.27
  L 881.06 252.39
  A 1.52 1.51 -75.1 0 0 882.40 251.61
  L 885.30 246.41
  Q 886.78 246.66 888.05 247.85
  Q 885.72 250.19 884.50 253.59
  A 1.63 1.62 40.0 0 0 884.62 254.92
  L 887.80 260.42
  A 1.56 1.54 75.3 0 0 889.10 261.19
  L 896.07 261.31
  A 0.97 0.95 -73.3 0 0 896.90 260.85
  L 900.72 254.49
  L 903.08 255.99
  Q 901.08 258.01 899.58 261.34
  A 2.69 2.67 42.4 0 0 899.70 263.77
  L 902.79 269.11
  A 0.92 0.90 75.2 0 0 903.56 269.57
  L 910.99 269.70
  A 0.72 0.72 0.0 0 0 911.64 269.32
  L 915.10 263.04
  L 917.47 264.78
  L 913.69 270.82
  A 0.92 0.91 45.8 0 0 913.68 271.75
  L 917.19 277.83
  A 1.30 1.30 0.0 0 0 918.30 278.48
  L 925.25 278.61
  A 1.03 1.01 -73.0 0 0 926.13 278.13
  L 929.18 273.28
  L 931.28 275.41
  Q 929.16 276.77 928.57 279.85
  A 1.42 1.40 35.5 0 0 928.74 280.83
  L 931.77 286.08
  A 1.63 1.60 80.7 0 0 932.82 286.85
  Q 937.90 287.97 941.84 286.01
  Q 941.67 287.10 944.13 288.11
  L 943.75 288.05
  A 0.50 0.49 12.4 0 0 943.19 288.40
  Q 943.07 288.78 943.17 289.05
  Q 944.09 291.74 946.08 294.47
  A 2.31 2.31 0.0 0 0 946.91 295.17
  Q 949.37 296.43 949.12 294.17
  Q 950.37 294.62 949.70 296.30
  A 0.52 0.52 0.0 0 0 949.96 296.96
  Q 954.68 299.21 956.16 304.49
  L 953.53 300.00
  A 2.67 2.65 -14.4 0 0 951.28 298.68
  L 947.22 298.61
  A 1.58 1.56 -76.4 0 0 945.78 299.50
  L 942.95 305.38
  A 1.14 1.13 42.9 0 0 942.99 306.44
  L 946.33 312.22
  A 1.41 1.39 75.2 0 0 947.52 312.92
  L 953.78 313.03
  A 1.51 1.50 15.1 0 0 955.13 312.26
  L 957.89 307.41
  L 960.28 309.54
  Q 958.15 311.47 957.28 313.97
  A 1.06 1.04 40.2 0 0 957.36 314.84
  L 960.58 320.41
  A 1.05 1.04 80.3 0 0 961.29 320.92
  Q 964.89 321.56 965.99 320.21
  Q 966.16 321.20 966.58 321.67
  Q 969.74 325.23 970.67 329.82
  L 968.42 325.04
  A 1.78 1.77 77.9 0 0 966.85 324.02
  L 962.22 323.94
  A 1.40 1.36 22.0 0 0 961.21 324.35
  Q 957.36 328.32 957.17 332.93
  A 0.57 0.57 0.0 0 1 956.39 333.43
  Q 952.07 331.71 947.25 332.29
  A 2.86 2.85 -80.5 0 0 945.03 333.88
  L 943.47 337.11
  A 2.68 2.67 13.2 0 1 941.01 338.63
  L 930.12 338.43
  A 2.15 2.14 75.2 0 1 928.31 337.37
  L 925.72 332.88
  A 1.48 1.45 75.1 0 0 924.47 332.14
  L 917.71 332.02
  A 1.64 1.63 16.3 0 0 916.28 332.80
  L 912.84 338.37
  A 1.19 1.19 0.0 0 0 912.74 339.42
  L 913.82 342.28
  A 0.65 0.65 0.0 0 1 912.76 342.97
  L 910.47 340.68
  A 1.75 1.72 67.6 0 0 909.27 340.17
  L 903.38 340.07
  A 1.73 1.73 0.0 0 0 901.88 340.88
  L 898.24 346.67
  A 1.62 1.60 46.4 0 0 898.21 348.34
  L 899.56 350.67
  A 1.00 0.99 -84.9 0 1 898.06 351.93
  Q 896.98 351.01 896.00 349.48
  A 1.52 1.52 0.0 0 0 894.73 348.77
  L 888.96 348.67
  A 2.04 2.04 0.0 0 0 887.24 349.56
  L 884.34 353.83
  A 3.64 3.60 -37.0 0 0 883.89 356.93
  Q 885.64 362.41 889.09 363.55
  A 0.57 0.57 0.0 0 1 889.25 364.56
  C 886.78 366.33 882.60 371.34 883.94 374.08
  Q 886.35 378.99 886.57 379.45
  A 3.23 3.21 45.2 0 1 886.57 382.24
  L 883.46 388.70
  A 1.24 1.20 46.4 0 0 883.45 389.74
  L 886.01 395.44
  A 1.55 1.53 -86.9 0 0 886.63 396.14
  L 889.01 397.55
  A 0.70 0.70 0.0 0 1 888.87 398.81
  C 886.15 399.70 885.15 402.34 883.27 405.99
  A 1.58 1.55 -46.6 0 0 883.30 407.50
  L 886.45 412.96
  A 1.48 1.47 75.3 0 0 887.71 413.70
  L 894.33 413.82
  A 1.57 1.57 0.0 0 0 895.73 413.02
  L 896.87 410.99
  A 1.10 1.09 36.1 0 1 898.58 410.73
  L 898.66 410.80
  A 1.46 1.45 -50.9 0 1 898.85 412.72
  Q 897.83 414.17 897.62 415.07
  A 1.22 1.20 36.2 0 0 897.76 415.94
  L 901.15 421.82
  A 1.33 1.33 0.0 0 0 902.28 422.48
  L 909.06 422.60
  A 1.17 1.16 17.0 0 0 910.05 422.08
  L 911.78 419.45
  A 1.27 1.25 24.6 0 1 913.20 418.93
  L 913.22 418.93
  A 0.89 0.88 -64.7 0 1 913.66 420.17
  L 912.11 423.05
  A 1.17 1.16 -46.4 0 0 912.13 424.19
  L 915.59 430.20
  A 1.54 1.53 -14.3 0 0 916.88 430.96
  L 923.38 431.07
  A 1.40 1.40 0.0 0 0 924.61 430.40
  Q 926.13 427.93 927.88 425.12
  Q 928.19 424.62 928.11 423.94
  Q 928.01 423.16 928.25 422.82
  A 0.86 0.84 24.6 0 1 929.19 422.48
  Q 935.29 424.24 941.07 422.20
  A 0.50 0.50 0.0 0 1 941.73 422.57
  C 941.84 423.09 940.92 423.83 941.47 424.96
  Q 943.03 428.23 945.05 431.01
  A 0.91 0.89 -16.6 0 0 945.77 431.39
  L 952.29 431.51
  A 1.48 1.46 15.5 0 0 953.57 430.80
  L 957.22 424.71
  A 1.04 1.02 45.5 0 0 957.22 423.66
  L 955.25 420.24
  A 0.91 0.90 74.9 0 1 956.03 418.88
  L 956.59 418.88
  A 1.35 1.34 74.8 0 1 957.75 419.55
  L 959.52 422.62
  A 1.09 1.08 75.2 0 0 960.44 423.16
  L 966.95 423.28
  A 1.46 1.46 0.0 0 0 968.22 422.57
  L 971.79 416.54
  A 1.15 1.12 50.3 0 0 971.87 415.55
  Q 969.90 410.34 966.12 407.48
  A 0.42 0.42 0.0 0 1 966.31 406.73
  C 969.47 406.28 970.23 402.92 971.71 399.23
  A 1.28 1.26 41.3 0 0 971.63 398.12
  L 968.45 392.62
  A 1.30 1.28 75.2 0 0 967.35 391.97
  L 960.45 391.84
  A 1.30 1.30 0.0 0 0 959.26 392.58
  L 956.15 399.04
  A 0.65 0.65 0.0 0 0 956.17 399.63
  L 959.91 406.09
  A 1.34 1.33 60.3 0 1 959.42 407.91
  L 958.89 408.22
  A 1.33 1.32 -22.1 0 1 956.94 407.40
  Q 955.98 403.59 953.75 400.74
  A 1.39 1.38 70.9 0 0 952.69 400.22
  L 946.36 400.10
  A 1.42 1.41 13.2 0 0 945.07 400.89
  L 941.96 407.36
  A 1.01 0.98 -47.7 0 0 941.99 408.29
  L 943.83 411.48
  A 0.67 0.66 75.3 0 1 943.25 412.48
  L 942.91 412.48
  A 2.51 2.48 -16.7 0 1 940.93 411.43
  C 940.03 410.16 939.18 408.75 937.48 408.69
  C 934.77 408.60 930.49 407.94 929.49 410.79
  A 0.86 0.85 -79.5 0 1 928.67 411.36
  L 928.10 411.35
  A 0.94 0.94 0.0 0 1 927.28 410.00
  L 928.33 407.83
  A 1.55 1.53 -47.7 0 0 928.27 406.39
  L 925.01 400.73
  A 1.49 1.48 -14.5 0 0 923.74 399.99
  L 917.30 399.87
  A 1.89 1.88 18.3 0 0 915.76 400.64
  L 913.24 404.11
  A 0.64 0.64 0.0 0 1 912.09 403.85
  L 912.04 403.46
  A 2.49 2.48 54.5 0 1 912.27 402.07
  L 913.74 399.02
  A 1.37 1.36 -47.4 0 0 913.69 397.75
  L 910.51 392.24
  A 1.52 1.51 75.5 0 0 909.21 391.47
  L 904.88 391.39
  A 1.79 1.78 -14.1 0 1 903.36 390.49
  L 903.13 390.10
  A 0.79 0.78 75.4 0 1 903.82 388.92
  L 909.64 389.03
  A 1.01 1.00 -76.6 0 0 910.56 388.46
  L 913.96 381.39
  A 0.47 0.45 43.7 0 0 913.94 380.95
  L 910.34 374.71
  A 1.40 1.39 -17.8 0 0 908.99 374.02
  L 901.62 374.76
  A 0.48 0.48 0.0 0 1 901.10 374.32
  Q 901.04 373.69 901.27 372.60
  A 0.51 0.51 0.0 0 1 901.78 372.20
  L 909.63 372.34
  A 1.35 1.34 13.1 0 0 910.86 371.58
  L 914.21 364.62
  A 0.60 0.59 -44.4 0 0 914.22 364.12
  Q 912.22 359.56 909.44 357.23
  A 0.29 0.29 0.0 0 1 909.42 356.81
  L 913.59 352.65
  A 0.34 0.34 0.0 0 1 914.14 353.03
  L 913.15 355.08
  A 2.28 2.27 42.9 0 0 913.23 357.22
  L 916.44 362.79
  A 1.12 1.11 74.9 0 0 917.38 363.34
  L 924.15 363.46
  A 1.80 1.79 -76.6 0 0 925.80 362.44
  L 928.78 356.25
  A 0.86 0.85 43.2 0 0 928.75 355.46
  L 925.21 349.33
  A 0.71 0.71 0.0 0 1 925.82 348.27
  L 926.33 348.27
  A 1.52 1.50 74.6 0 1 927.63 349.02
  L 931.00 354.86
  A 1.14 1.13 -14.3 0 0 931.97 355.43
  L 939.00 355.55
  A 1.43 1.40 -76.2 0 0 940.30 354.75
  L 942.91 349.33
  A 0.76 0.76 0.0 0 1 944.13 349.12
  L 944.70 349.70
  A 0.91 0.91 0.0 0 1 944.88 350.73
  L 942.12 356.46
  A 0.79 0.79 0.0 0 0 942.14 357.19
  L 945.56 363.11
  A 1.38 1.37 -14.4 0 0 946.74 363.80
  L 952.35 363.90
  A 0.88 0.88 0.0 0 1 953.19 365.01
  L 953.10 365.34
  A 1.48 1.47 8.1 0 1 951.65 366.42
  L 946.10 366.32
  A 0.97 0.94 -76.2 0 0 945.23 366.86
  L 942.10 373.36
  A 1.21 1.19 -47.5 0 0 942.14 374.47
  L 945.20 379.75
  A 1.35 1.35 0.0 0 0 946.36 380.44
  L 953.18 380.56
  A 1.54 1.54 0.0 0 0 954.60 379.69
  L 957.62 373.41
  A 0.52 0.52 0.0 0 0 957.60 372.92
  L 955.51 369.30
  A 0.55 0.55 0.0 0 1 956.11 368.49
  Q 958.47 369.04 959.30 371.07
  Q 959.85 372.40 960.86 372.46
  Q 962.95 372.57 968.02 372.49
  A 1.28 1.27 12.2 0 0 969.16 371.76
  L 972.37 365.10
  A 0.73 0.72 42.9 0 0 972.34 364.43
  L 969.10 358.81
  A 1.73 1.73 0.0 0 0 967.64 357.95
  L 962.09 357.85
  A 0.71 0.71 0.0 0 1 961.39 357.13
  L 961.40 356.77
  A 1.08 1.08 0.0 0 1 962.50 355.71
  L 967.92 355.81
  A 1.55 1.54 -76.6 0 0 969.34 354.93
  L 972.47 348.44
  A 0.67 0.64 43.6 0 0 972.44 347.84
  L 969.27 342.35
  A 2.34 2.33 77.8 0 0 967.48 341.19
  L 964.04 340.85
  A 1.15 1.15 0.0 0 1 963.05 339.41
  L 963.07 339.34
  A 1.36 1.35 12.1 0 1 964.59 338.36
  Q 968.30 338.93 968.83 338.08
  Q 969.45 337.10 971.04 333.98
  Q 972.02 332.08 970.77 330.30
  Q 972.18 331.97 971.42 333.91
  A 0.15 0.15 0.0 0 0 971.60 334.11
  Q 971.76 334.07 971.87 333.89
  A 0.09 0.09 0.0 0 0 971.87 333.83
  Q 971.70 333.39 971.82 333.00
  A 0.17 0.17 0.0 0 1 972.15 333.01
  L 972.90 336.48
  Q 970.83 337.99 971.39 340.25
  Q 972.46 344.61 976.73 347.14
  L 977.59 349.68
  Q 973.41 350.44 971.25 356.55
  A 1.18 1.18 0.0 0 0 971.34 357.55
  L 974.66 363.30
  A 0.90 0.89 -13.8 0 0 975.43 363.76
  L 980.61 363.95
  Q 981.10 366.01 980.05 366.86
  L 975.77 366.83
  A 1.30 1.29 15.6 0 0 974.64 367.46
  L 970.94 373.53
  A 1.09 1.08 -44.0 0 0 970.92 374.64
  L 974.36 380.59
  A 0.83 0.80 -13.0 0 0 975.04 381.00
  L 982.03 381.21
  Q 982.45 382.55 982.28 383.87
  L 974.98 383.64
  A 1.01 1.00 -75.7 0 0 974.03 384.21
  L 970.80 390.92
  A 0.52 0.52 0.0 0 0 970.82 391.41
  L 974.36 397.53
  A 0.78 0.78 0.0 0 0 975.06 397.93
  L 982.78 397.85
  Q 982.88 399.61 983.50 401.05
  L 974.77 400.74
  A 1.14 1.13 13.8 0 0 973.70 401.38
  L 970.64 407.74
  A 0.65 0.64 -47.6 0 0 970.66 408.36
  L 974.02 414.17
  A 1.15 1.13 75.0 0 0 975.01 414.75
  L 982.03 414.81
  Q 981.39 416.00 981.64 417.76
  L 975.12 417.56
  A 0.93 0.92 16.3 0 0 974.29 418.01
  L 970.56 424.25
  A 0.88 0.86 -45.6 0 0 970.56 425.12
  L 973.90 430.92
  A 1.11 1.11 0.0 0 0 974.86 431.47
  L 978.07 431.48
  L 978.40 434.49
  L 974.79 434.58
  A 0.96 0.95 14.5 0 0 973.98 435.05
  L 970.32 441.16
  A 1.04 1.04 0.0 0 0 970.32 442.20
  L 973.40 447.55
  A 0.29 0.29 0.0 0 0 973.92 447.51
  L 976.40 441.05
  Q 975.19 448.98 973.05 453.57
  Q 967.84 464.75 963.49 472.52
  Q 962.03 475.14 959.21 477.95
  Q 959.73 477.34 959.79 476.80
  A 0.36 0.36 0.0 0 0 959.15 476.53
  Q 956.94 479.23 955.40 481.89
  Q 955.01 482.55 955.57 482.77
  Q 955.83 482.87 956.22 482.52
  L 953.32 486.19
  Q 951.43 483.66 945.09 484.77
  A 1.80 1.80 0.0 0 0 943.78 485.76
  L 940.98 491.57
  A 0.92 0.89 50.6 0 0 940.93 492.22
  Q 941.81 495.45 944.59 497.25
  Q 942.47 498.01 941.51 499.41
  L 938.42 494.33
  A 2.05 2.03 -14.9 0 0 936.71 493.35
  L 930.59 493.24
  A 1.76 1.76 0.0 0 0 928.97 494.24
  L 926.07 500.26
  A 1.03 1.01 43.2 0 0 926.11 501.21
  L 929.32 506.77
  A 1.14 1.13 76.4 0 0 930.25 507.34
  L 935.13 507.57
  L 932.51 510.37
  Q 930.73 509.15 929.20 510.71
  Q 927.45 512.48 927.03 514.75
  Q 924.89 517.07 921.80 518.76
  Q 919.30 518.21 915.84 518.80
  A 2.33 2.32 -79.5 0 0 914.22 519.92
  L 910.94 525.45
  Q 909.28 529.23 907.51 529.10
  Q 908.17 528.66 908.56 528.14
  A 0.80 0.80 0.0 0 0 907.93 526.86
  L 901.00 526.74
  A 1.15 1.14 19.1 0 0 900.07 527.19
  Q 897.86 530.14 896.43 533.63
  Q 896.17 534.28 896.62 534.69
  Q 896.95 534.99 897.73 534.72
  L 894.33 536.44
  Q 891.29 534.29 886.23 535.32
  A 1.81 1.80 16.3 0 0 885.29 535.83
  Q 882.93 538.20 882.59 541.34
  L 877.22 543.74
  Q 874.00 542.38 871.02 543.58
  Q 868.43 544.62 869.36 546.20
  Q 867.88 547.02 865.68 547.68
  Q 858.95 549.71 853.16 550.22
  Q 852.54 546.97 850.28 543.54
  A 1.54 1.53 73.5 0 0 849.02 542.85
  L 842.58 542.73
  A 1.48 1.48 0.0 0 0 841.44 543.24
  Q 838.20 546.95 836.69 552.12
  Q 836.98 551.73 835.89 552.04
  Q 836.02 551.19 834.98 550.95
  C 832.75 550.45 830.34 550.67 827.91 550.79
  Q 825.77 550.90 825.01 552.39
  Q 824.28 552.63 823.37 552.34
  Q 824.41 552.03 824.77 550.14
  A 1.50 1.47 35.5 0 0 824.59 549.12
  L 821.13 543.12
  A 1.53 1.49 -13.9 0 0 819.85 542.37
  L 813.33 542.26
  A 1.38 1.36 -72.5 0 0 812.15 542.88
  L 808.60 548.33
  A 2.29 2.29 0.0 0 0 809.31 551.52
  Q 810.00 551.94 811.72 551.90
  Q 802.15 552.04 794.88 549.36
  Q 794.05 546.05 791.78 543.08
  A 2.17 2.16 -18.3 0 0 790.08 542.23
  C 786.42 542.16 782.62 541.25 781.33 546.09
  Q 779.72 545.77 778.04 544.80
  L 780.66 540.95
  A 0.83 0.83 0.0 0 0 780.69 540.07
  L 777.22 534.04
  A 1.13 1.12 -14.8 0 0 776.27 533.49
  L 769.79 533.37
  A 1.34 1.33 15.4 0 0 768.62 534.03
  L 765.11 540.00
  L 762.47 538.80
  L 766.26 532.52
  A 1.11 1.10 45.7 0 0 766.27 531.39
  L 762.93 525.61
  A 1.50 1.50 0.0 0 0 761.66 524.85
  L 755.52 524.75
  A 2.46 2.44 14.3 0 0 753.30 526.06
  L 750.03 532.30
  Q 748.34 531.15 746.80 530.83
  L 751.60 523.56
  A 0.97 0.97 0.0 0 0 751.63 522.54
  L 748.21 516.61
  A 1.06 1.06 0.0 0 0 747.31 516.08
  L 740.99 515.97
  A 2.24 2.23 -75.7 0 0 738.96 517.18
  L 735.68 523.51
  L 732.80 521.70
  L 737.29 515.42
  A 1.24 1.23 -42.2 0 0 737.36 514.08
  L 733.84 507.98
  A 1.41 1.40 -14.6 0 0 732.64 507.28
  L 726.16 507.16
  A 1.28 1.28 0.0 0 0 725.18 507.59
  Q 723.14 509.89 722.41 512.99
  L 719.67 510.80
  L 722.69 506.15
  A 1.03 1.02 46.7 0 0 722.72 505.07
  L 719.30 499.15
  A 0.99 0.98 79.9 0 0 718.62 498.67
  Q 712.84 497.67 708.90 500.21
  L 707.62 498.77
  Q 708.41 498.60 708.34 497.55
  Q 708.29 496.76 707.84 496.09
  Q 706.16 493.55 704.88 490.84
  A 1.26 1.26 0.0 0 0 704.10 490.17
  Q 703.34 489.95 702.48 490.14
  L 700.82 489.64
  A 0.89 0.89 0.0 0 1 700.93 487.91
  L 701.97 487.74
  L 703.86 487.50
  A 1.23 1.22 12.5 0 0 704.75 486.94
  L 708.60 480.75
  A 0.87 0.87 0.0 0 0 708.61 479.86
  L 705.06 473.71
  A 1.03 1.02 -14.5 0 0 704.19 473.20
  L 697.43 473.08
  A 1.61 1.60 16.3 0 0 696.03 473.84
  L 693.84 477.41
  L 691.67 475.27
  Q 693.10 473.52 693.79 471.45
  A 1.08 1.06 -51.4 0 0 693.70 470.56
  L 690.30 464.67
  A 1.03 1.03 0.0 0 0 689.42 464.15
  L 684.71 464.12
  L 683.95 461.79
  L 689.74 461.79
  A 0.89 0.86 14.7 0 0 690.50 461.36
  L 694.44 454.80
  A 0.85 0.82 46.5 0 0 694.45 453.96
  L 690.85 447.74
  A 0.81 0.81 0.0 0 0 690.17 447.34
  L 683.05 447.21
  A 1.31 1.30 16.5 0 0 681.93 447.81
  L 679.01 452.43
  L 677.34 449.39
  Q 678.92 448.29 679.35 446.74
  Q 679.72 445.40 678.68 443.55
  C 677.78 441.94 676.06 438.46 674.20 438.00
  L 673.97 435.89
  C 676.67 435.64 678.49 431.18 679.63 429.00
  A 1.34 1.33 -46.3 0 0 679.61 427.72
  L 676.24 421.89
  A 1.17 1.16 -16.0 0 0 675.18 421.31
  L 669.87 421.58
  L 670.91 418.75
  L 676.08 418.59
  A 0.96 0.95 11.8 0 0 676.91 418.05
  L 679.94 411.75
  A 0.94 0.93 -47.2 0 0 679.91 410.87
  L 676.48 404.93
  A 1.35 1.34 -15.7 0 0 675.28 404.26
  L 668.21 404.44
  L 668.22 401.71
  L 675.19 401.80
  A 2.17 2.16 -76.7 0 0 677.17 400.57
  L 679.79 395.14
  A 1.74 1.72 -47.4 0 0 679.73 393.52
  L 676.55 388.01
  A 1.41 1.39 76.9 0 0 675.46 387.32
  Q 671.14 386.96 667.08 388.03
  L 667.15 384.45
  L 676.21 384.94
  A 0.95 0.95 0.0 0 0 677.12 384.41
  L 680.24 377.93
  A 0.78 0.77 43.1 0 0 680.21 377.20
  L 676.77 371.25
  A 1.44 1.43 -14.6 0 0 675.52 370.52
  L 669.97 370.53
  L 669.62 368.18
  L 676.00 368.18
  A 1.64 1.62 12.6 0 0 677.47 367.26
  L 680.53 360.91
  A 0.69 0.67 44.1 0 0 680.51 360.27
  L 677.12 354.40
  A 1.06 1.05 -13.2 0 0 676.29 353.89
  L 672.78 353.65
  L 672.96 351.46
  L 676.72 351.12
  A 0.92 0.91 9.7 0 0 677.46 350.60
  L 680.55 344.20
  A 1.07 1.02 48.9 0 0 680.59 343.39
  Q 679.46 340.24 677.01 337.70
  Q 676.91 329.73 682.53 324.75
  Q 686.21 326.72 691.64 325.69
  A 1.12 1.10 -82.6 0 0 692.41 325.09
  L 695.46 318.75
  A 1.09 1.08 46.4 0 0 695.48 317.86
  Q 693.40 313.18 689.89 311.22
  Q 689.90 309.60 691.39 307.51
  Q 694.15 303.62 698.05 299.43
  Q 700.75 301.18 706.25 300.23
  A 1.63 1.63 0.0 0 0 707.42 299.34
  L 710.24 293.49
  A 0.76 0.73 49.3 0 0 710.27 292.95
  Q 709.01 289.13 706.53 288.42
  L 709.71 285.12
  Q 710.21 288.83 712.50 291.97
  A 1.76 1.76 0.0 0 0 713.90 292.69
  L 720.83 292.82
  A 0.83 0.82 -76.6 0 0 721.59 292.35
  L 724.78 285.72
  A 1.03 1.02 -47.0 0 0 724.75 284.76
  L 721.88 279.80
  A 1.70 1.68 -6.7 0 0 720.88 279.02
  Q 716.64 277.81 713.87 280.74
  L 719.12 275.76
  Q 720.49 276.40 721.50 275.49
  Q 723.43 273.75 723.99 271.26
  Q 726.60 267.85 730.72 266.06
  Q 730.06 266.31 729.91 266.80
  Q 729.72 267.42 730.31 267.49
  Q 733.03 267.81 735.53 267.37
  A 1.56 1.56 0.0 0 0 736.63 266.55
  L 739.88 260.10
  Q 741.20 258.92 742.47 258.40
  Q 745.69 259.83 749.93 259.27
  A 1.35 1.34 16.4 0 0 750.76 258.82
  Q 753.48 255.64 754.07 251.84
  L 757.32 250.46
  Q 761.15 251.21 764.80 250.62
  A 1.42 1.42 0.0 0 0 765.63 250.19
  Q 767.69 248.00 767.36 245.89
  Q 771.70 243.18 776.89 242.55
  Q 779.41 243.59 781.01 241.02
  L 786.56 239.87
  Q 783.12 240.82 782.74 243.95
  A 1.69 1.69 0.0 0 0 782.95 245.00
  L 785.97 250.24
  A 1.16 1.16 0.0 0 0 786.95 250.81
  L 793.74 250.93
  A 1.44 1.44 0.0 0 0 795.07 250.11
  L 797.91 244.21
  A 1.67 1.67 0.0 0 0 797.85 242.62
  L 795.72 238.91
  A 1.63 1.62 64.3 0 0 793.73 238.21
  Q 792.08 238.86 790.03 238.87
  L 798.24 237.12
  Q 798.59 240.07 800.59 242.85
  A 1.01 0.99 -17.1 0 0 801.38 243.26
  L 807.81 243.38
  A 1.85 1.83 -73.8 0 0 809.42 242.48
  Q 811.50 238.98 812.50 236.68
  Q 812.90 235.78 812.23 235.46
  Q 811.72 235.22 810.77 235.41
  Q 818.98 234.10 825.95 234.84
  Z
  M 811.46 244.22
  Q 811.45 244.57 811.48 244.63
  Q 813.15 247.83 815.02 250.91
  A 1.29 1.27 -14.7 0 0 816.09 251.52
  L 822.89 251.61
  A 1.22 1.20 -72.6 0 0 823.90 251.07
  Q 825.96 247.95 827.60 244.56
  Q 827.63 244.50 827.63 244.32
  Q 827.63 244.16 827.60 244.11
  Q 826.00 240.69 823.98 237.56
  A 1.22 1.20 73.2 0 0 822.97 237.01
  L 816.17 237.02
  A 1.29 1.27 15.3 0 0 815.10 237.62
  Q 813.19 240.68 811.49 243.86
  Q 811.46 243.92 811.46 244.22
  Z
  M 781.92 248.93
  Q 780.75 246.93 780.36 246.28
  A 1.80 1.79 74.3 0 0 778.82 245.42
  L 772.62 245.46
  A 2.23 2.23 0.0 0 0 770.68 246.65
  L 767.82 252.11
  A 1.31 1.31 0.0 0 0 767.80 253.25
  Q 767.87 253.47 769.51 256.25
  Q 771.15 259.03 771.30 259.20
  A 1.31 1.31 0.0 0 0 772.31 259.73
  L 778.47 259.87
  A 2.23 2.23 0.0 0 0 780.45 258.74
  L 783.50 253.34
  A 1.80 1.79 44.7 0 0 783.48 251.58
  Q 783.10 250.93 781.92 248.93
  Z
  M 809.06 245.80
  Q 808.60 245.52 807.25 245.52
  Q 801.67 245.52 801.54 245.54
  A 1.67 1.67 0.0 0 0 800.48 246.30
  L 797.30 251.44
  A 2.17 2.16 48.4 0 0 797.18 253.50
  Q 798.75 256.83 800.66 259.64
  Q 800.70 259.70 800.76 259.73
  Q 800.84 259.78 800.91 259.79
  Q 804.28 260.15 807.96 259.95
  A 2.17 2.16 13.4 0 0 809.73 258.87
  L 812.75 253.63
  A 1.67 1.67 0.0 0 0 812.92 252.34
  Q 812.87 252.22 810.23 247.30
  Q 809.59 246.12 809.06 245.80
  Z
  M 838.34 245.79
  Q 837.86 245.51 836.47 245.52
  Q 830.72 245.59 830.59 245.61
  A 1.72 1.72 0.0 0 0 829.51 246.40
  L 826.29 251.73
  A 2.23 2.22 47.7 0 0 826.20 253.86
  Q 827.86 257.27 829.86 260.13
  Q 829.90 260.19 829.96 260.23
  Q 830.05 260.28 830.12 260.29
  Q 833.60 260.61 837.38 260.37
  A 2.23 2.22 12.7 0 0 839.18 259.23
  L 842.23 253.80
  A 1.72 1.72 0.0 0 0 842.39 252.47
  Q 842.34 252.35 839.56 247.32
  Q 838.88 246.10 838.34 245.79
  Z
  M 859.48 246.39
  Q 859.00 246.65 858.29 247.81
  Q 855.36 252.65 855.32 252.77
  A 1.69 1.69 0.0 0 0 855.42 254.08
  L 858.20 259.53
  A 2.19 2.19 0.0 0 0 859.93 260.71
  Q 863.64 261.09 867.06 260.91
  Q 867.13 260.91 867.20 260.87
  Q 867.29 260.82 867.33 260.77
  Q 869.40 258.03 871.16 254.75
  A 2.19 2.19 0.0 0 0 871.14 252.65
  L 868.19 247.29
  A 1.69 1.69 0.0 0 0 867.16 246.48
  Q 867.03 246.45 861.39 246.17
  Q 860.03 246.10 859.48 246.39
  Z
  M 757.41 253.41
  Q 756.93 253.68 756.26 254.84
  Q 753.47 259.66 753.43 259.77
  A 1.67 1.67 0.0 0 0 753.55 261.07
  L 756.40 266.38
  A 2.16 2.15 -11.6 0 0 758.13 267.51
  Q 761.78 267.82 765.15 267.57
  Q 765.22 267.56 765.29 267.53
  Q 765.37 267.48 765.41 267.42
  Q 767.40 264.69 769.07 261.42
  A 2.16 2.15 -46.6 0 0 769.01 259.36
  L 766.00 254.14
  A 1.67 1.67 0.0 0 0 764.97 253.35
  Q 764.84 253.33 759.28 253.16
  Q 757.94 253.12 757.41 253.41
  Z
  M 811.26 261.03
  Q 811.26 261.38 811.29 261.44
  Q 812.95 264.64 814.82 267.71
  A 1.29 1.27 -14.7 0 0 815.89 268.33
  L 822.68 268.41
  A 1.22 1.20 -72.5 0 0 823.69 267.88
  Q 825.75 264.77 827.39 261.37
  Q 827.41 261.32 827.41 261.14
  Q 827.42 260.98 827.39 260.92
  Q 825.80 257.51 823.77 254.38
  A 1.22 1.20 73.2 0 0 822.76 253.83
  L 815.98 253.84
  A 1.29 1.27 15.3 0 0 814.90 254.44
  Q 812.99 257.49 811.29 260.67
  Q 811.26 260.72 811.26 261.03
  Z
  M 782.19 260.96
  Q 782.19 261.30 782.22 261.36
  Q 783.88 264.50 785.75 267.52
  A 1.27 1.25 -15.0 0 0 786.81 268.12
  L 793.50 268.17
  A 1.20 1.19 -72.9 0 0 794.50 267.63
  Q 796.51 264.55 798.10 261.19
  Q 798.13 261.13 798.13 260.96
  Q 798.13 260.80 798.10 260.75
  Q 796.51 257.39 794.49 254.31
  A 1.20 1.19 72.9 0 0 793.49 253.78
  L 786.80 253.83
  A 1.27 1.25 15.0 0 0 785.74 254.43
  Q 783.87 257.45 782.22 260.60
  Q 782.19 260.65 782.19 260.96
  Z
  M 844.59 254.54
  Q 844.28 254.71 844.25 254.76
  Q 842.22 257.82 840.42 261.01
  A 1.31 1.29 46.2 0 0 840.40 262.26
  L 843.68 268.34
  A 1.24 1.22 -11.6 0 0 844.66 268.98
  Q 848.44 269.27 852.27 269.05
  Q 852.33 269.04 852.49 268.96
  Q 852.63 268.88 852.67 268.83
  Q 854.91 265.72 856.70 262.37
  A 1.24 1.22 -45.9 0 0 856.69 261.20
  L 853.33 255.17
  A 1.31 1.29 76.3 0 0 852.26 254.51
  Q 848.60 254.32 844.93 254.38
  Q 844.87 254.39 844.59 254.54
  Z
  M 881.82 269.32
  Q 882.30 269.05 882.98 267.87
  Q 885.81 262.96 885.85 262.84
  A 1.70 1.69 -50.7 0 0 885.72 261.53
  L 882.81 256.13
  A 2.20 2.19 -11.7 0 0 881.06 254.98
  Q 877.34 254.68 873.91 254.94
  Q 873.84 254.95 873.77 254.98
  Q 873.69 255.03 873.65 255.09
  Q 871.63 257.87 869.94 261.20
  A 2.20 2.19 -46.7 0 0 870.00 263.30
  L 873.08 268.60
  A 1.70 1.69 -7.7 0 0 874.13 269.40
  Q 874.25 269.42 879.91 269.58
  Q 881.28 269.62 881.82 269.32
  Z
  M 750.48 262.31
  Q 750.18 262.14 750.12 262.13
  Q 746.52 261.96 742.93 262.03
  A 1.29 1.27 -74.4 0 0 741.86 262.64
  L 738.38 268.44
  A 1.21 1.20 47.7 0 0 738.33 269.59
  Q 739.98 272.93 742.08 276.04
  Q 742.11 276.09 742.26 276.18
  Q 742.40 276.26 742.46 276.27
  Q 746.20 276.61 749.92 276.44
  A 1.21 1.20 13.5 0 0 750.90 275.85
  L 754.31 270.00
  A 1.29 1.27 -44.4 0 0 754.33 268.76
  Q 752.66 265.58 750.77 262.52
  Q 750.74 262.47 750.48 262.31
  Z
  M 779.70 262.44
  Q 779.23 262.16 777.88 262.17
  Q 772.27 262.21 772.14 262.23
  A 1.68 1.68 0.0 0 0 771.09 262.99
  L 767.92 268.18
  A 2.18 2.17 48.0 0 0 767.82 270.25
  Q 769.42 273.59 771.35 276.39
  Q 771.40 276.45 771.46 276.48
  Q 771.54 276.53 771.61 276.54
  Q 775.00 276.87 778.69 276.65
  A 2.18 2.17 13.0 0 0 780.46 275.55
  L 783.45 270.27
  A 1.68 1.68 0.0 0 0 783.61 268.98
  Q 783.57 268.86 780.88 263.94
  Q 780.23 262.75 779.70 262.44
  Z
  M 804.61 277.03
  Q 807.72 277.03 808.13 276.96
  A 1.74 1.74 0.0 0 0 809.34 276.09
  L 812.56 270.30
  A 1.50 1.49 -45.5 0 0 812.55 268.83
  L 809.15 262.95
  A 1.19 1.16 -13.3 0 0 808.17 262.36
  Q 807.65 262.34 804.62 262.34
  Q 801.57 262.34 801.05 262.36
  A 1.19 1.16 13.3 0 0 800.08 262.95
  L 796.68 268.83
  A 1.50 1.49 45.5 0 0 796.67 270.30
  L 799.89 276.09
  A 1.74 1.74 0.0 0 0 801.10 276.96
  Q 801.51 277.03 804.61 277.03
  Z
  M 829.80 262.85
  Q 829.31 263.12 828.62 264.31
  Q 825.77 269.27 825.72 269.40
  A 1.71 1.71 0.0 0 0 825.85 270.72
  L 828.79 276.18
  A 2.22 2.21 -11.7 0 0 830.57 277.34
  Q 834.33 277.65 837.79 277.38
  Q 837.86 277.38 837.93 277.34
  Q 838.02 277.29 838.06 277.23
  Q 840.10 274.42 841.80 271.06
  A 2.22 2.21 -46.7 0 0 841.75 268.94
  L 838.64 263.57
  A 1.71 1.71 0.0 0 0 837.58 262.77
  Q 837.45 262.74 831.72 262.58
  Q 830.34 262.54 829.80 262.85
  Z
  M 871.36 270.46
  Q 871.36 270.11 871.33 270.05
  Q 869.66 266.80 867.77 263.66
  A 1.31 1.29 -14.4 0 0 866.68 263.03
  L 859.79 262.92
  A 1.24 1.22 -72.3 0 0 858.76 263.46
  Q 856.65 266.61 854.98 270.05
  Q 854.95 270.11 854.95 270.29
  Q 854.95 270.45 854.97 270.51
  Q 856.58 273.98 858.62 277.17
  A 1.24 1.22 73.5 0 0 859.64 277.73
  L 866.54 277.75
  A 1.31 1.29 15.6 0 0 867.63 277.15
  Q 869.59 274.05 871.33 270.83
  Q 871.36 270.77 871.36 270.46
  Z
  M 896.23 278.15
  Q 896.54 277.98 896.57 277.92
  Q 898.53 274.92 900.27 271.79
  A 1.28 1.27 45.8 0 0 900.28 270.56
  L 897.03 264.64
  A 1.21 1.20 -12.0 0 0 896.07 264.03
  Q 892.37 263.76 888.63 264.01
  Q 888.56 264.02 888.41 264.10
  Q 888.27 264.18 888.24 264.23
  Q 886.06 267.28 884.34 270.57
  A 1.21 1.20 -46.3 0 0 884.36 271.71
  L 887.69 277.59
  A 1.28 1.27 75.9 0 0 888.74 278.22
  Q 892.32 278.38 895.90 278.30
  Q 895.97 278.30 896.23 278.15
  Z
  M 723.78 276.92
  Q 723.77 277.26 723.80 277.32
  Q 725.39 280.51 727.21 283.57
  A 1.28 1.26 -13.8 0 0 728.25 284.20
  L 734.97 284.38
  A 1.20 1.19 -71.7 0 0 735.98 283.86
  Q 738.06 280.82 739.73 277.48
  Q 739.76 277.43 739.76 277.25
  Q 739.76 277.10 739.74 277.04
  Q 738.21 273.64 736.25 270.51
  A 1.20 1.19 74.1 0 0 735.26 269.95
  L 728.55 269.86
  A 1.28 1.26 16.2 0 0 727.47 270.44
  Q 725.54 273.44 723.81 276.56
  Q 723.78 276.61 723.78 276.92
  Z
  M 752.84 277.59
  Q 752.83 278.12 753.51 279.28
  Q 756.32 284.09 756.40 284.19
  A 1.67 1.66 69.1 0 0 757.58 284.72
  L 763.61 284.87
  A 2.16 2.15 -72.0 0 0 765.44 283.93
  Q 767.52 280.91 768.97 277.86
  Q 769.00 277.79 769.00 277.72
  Q 769.00 277.62 768.97 277.56
  Q 767.58 274.48 765.57 271.41
  A 2.16 2.15 73.1 0 0 763.75 270.44
  L 757.72 270.47
  A 1.67 1.66 -68.0 0 0 756.53 270.98
  Q 756.44 271.08 753.54 275.83
  Q 752.84 276.98 752.84 277.59
  Z
  M 798.13 277.97
  Q 798.13 277.63 798.11 277.58
  Q 796.48 274.47 794.66 271.48
  A 1.25 1.24 -14.7 0 0 793.61 270.88
  L 787.01 270.80
  A 1.18 1.17 -72.6 0 0 786.02 271.33
  Q 784.02 274.36 782.43 277.66
  Q 782.40 277.72 782.40 277.89
  Q 782.40 278.04 782.43 278.10
  Q 783.99 281.42 785.96 284.47
  A 1.18 1.17 73.2 0 0 786.94 285.00
  L 793.55 284.99
  A 1.25 1.24 15.3 0 0 794.60 284.40
  Q 796.45 281.42 798.10 278.33
  Q 798.13 278.27 798.13 277.97
  Z
  M 827.31 278.34
  Q 827.31 277.99 827.28 277.94
  Q 825.61 274.73 823.72 271.66
  A 1.29 1.27 -14.8 0 0 822.65 271.04
  L 815.84 270.97
  A 1.22 1.21 -72.7 0 0 814.83 271.51
  Q 812.77 274.64 811.14 278.05
  Q 811.11 278.10 811.11 278.28
  Q 811.11 278.44 811.14 278.50
  Q 812.75 281.91 814.79 285.05
  A 1.22 1.21 73.1 0 0 815.80 285.60
  L 822.60 285.57
  A 1.29 1.27 15.2 0 0 823.68 284.96
  Q 825.59 281.90 827.28 278.70
  Q 827.31 278.65 827.31 278.34
  Z
  M 856.55 278.86
  Q 856.56 278.50 856.53 278.45
  Q 854.89 275.14 853.03 271.96
  A 1.32 1.30 -13.7 0 0 851.94 271.31
  L 845.00 271.10
  A 1.25 1.23 -71.5 0 0 843.95 271.63
  Q 841.78 274.78 840.05 278.22
  Q 840.02 278.28 840.02 278.45
  Q 840.01 278.62 840.04 278.68
  Q 841.61 282.20 843.62 285.45
  A 1.25 1.23 74.2 0 0 844.65 286.03
  L 851.59 286.14
  A 1.32 1.30 16.4 0 0 852.71 285.54
  Q 854.72 282.45 856.51 279.23
  Q 856.55 279.17 856.55 278.86
  Z
  M 873.51 272.09
  Q 873.04 272.37 872.38 273.57
  Q 869.66 278.55 869.61 278.67
  A 1.70 1.70 0.0 0 0 869.77 279.98
  L 872.81 285.33
  A 2.20 2.19 -13.0 0 0 874.59 286.44
  Q 878.33 286.66 881.76 286.32
  Q 881.83 286.32 881.89 286.28
  Q 881.98 286.23 882.02 286.17
  Q 883.98 283.34 885.60 279.96
  A 2.20 2.19 -48.0 0 0 885.49 277.86
  L 882.29 272.61
  A 1.70 1.70 0.0 0 0 881.22 271.84
  Q 881.09 271.82 875.42 271.78
  Q 874.05 271.77 873.51 272.09
  Z
  M 903.14 272.43
  Q 902.83 272.59 902.80 272.64
  Q 900.82 275.64 899.06 278.76
  A 1.28 1.27 46.2 0 0 899.04 279.99
  L 902.26 285.94
  A 1.21 1.20 -11.7 0 0 903.22 286.56
  Q 906.92 286.84 910.67 286.62
  Q 910.73 286.62 910.88 286.53
  Q 911.02 286.45 911.06 286.40
  Q 913.25 283.36 915.00 280.08
  A 1.21 1.20 -45.9 0 0 914.98 278.94
  L 911.69 273.04
  A 1.28 1.27 76.2 0 0 910.64 272.39
  Q 907.06 272.21 903.47 272.28
  Q 903.40 272.28 903.14 272.43
  Z
  M 825.62 468.49
  L 823.58 472.71
  A 1.53 1.52 42.7 0 0 823.64 474.14
  L 827.10 480.14
  A 0.94 0.92 -14.1 0 0 827.89 480.60
  L 836.16 480.75
  A 0.65 0.65 0.0 0 0 836.76 480.38
  L 839.90 473.85
  A 1.31 1.31 0.0 0 0 839.86 472.63
  L 836.65 467.07
  A 2.48 2.46 75.4 0 0 834.57 465.84
  L 828.44 465.73
  A 0.36 0.35 17.9 0 1 828.15 465.17
  L 828.53 464.64
  A 2.01 1.99 -72.0 0 1 830.15 463.81
  L 835.89 463.81
  A 1.14 1.12 -77.1 0 0 836.91 463.16
  L 840.13 456.47
  A 0.82 0.81 43.1 0 0 840.10 455.72
  L 836.36 449.25
  A 0.94 0.94 0.0 0 0 835.54 448.77
  L 828.56 448.77
  A 1.20 1.20 0.0 0 0 827.53 449.35
  C 825.66 452.42 823.70 455.11 823.64 456.52
  Q 823.60 457.50 823.51 457.63
  A 0.71 0.71 0.0 0 1 822.71 457.90
  Q 817.69 456.31 811.66 456.95
  A 1.04 1.04 0.0 0 1 810.63 456.38
  Q 808.06 451.18 807.62 450.38
  C 806.19 447.79 804.18 448.82 801.90 448.98
  A 0.77 0.76 87.9 0 1 801.08 448.21
  L 801.08 447.32
  A 0.68 0.68 0.0 0 1 801.78 446.64
  L 805.99 446.71
  A 1.29 1.28 15.8 0 0 807.11 446.09
  L 810.85 439.87
  A 1.12 1.11 -44.7 0 0 810.86 438.75
  L 807.47 432.88
  A 2.25 2.24 74.9 0 0 805.53 431.76
  L 801.93 431.76
  A 1.03 1.03 0.0 0 1 800.90 430.71
  L 800.90 430.39
  A 0.91 0.90 -88.7 0 1 801.82 429.50
  L 806.38 429.58
  A 1.88 1.87 13.3 0 0 808.10 428.52
  L 811.13 422.22
  A 0.39 0.37 44.2 0 0 811.12 421.88
  L 807.43 415.50
  A 1.50 1.49 -14.8 0 0 806.13 414.75
  L 801.54 414.75
  A 1.06 1.05 0.0 0 1 800.48 413.70
  L 800.48 413.34
  A 0.94 0.93 0.6 0 1 801.44 412.41
  L 805.49 412.48
  A 3.06 3.05 -73.9 0 0 808.16 411.00
  L 811.29 405.80
  A 1.15 1.14 45.7 0 0 811.30 404.65
  L 807.66 398.36
  A 1.25 1.23 -14.4 0 0 806.60 397.74
  L 801.90 397.65
  A 1.14 1.13 84.7 0 1 800.80 396.73
  L 800.73 396.35
  A 0.90 0.89 -1.2 0 1 801.72 395.32
  Q 803.83 395.59 804.68 395.71
  C 808.42 396.26 809.15 392.23 811.02 390.23
  A 2.08 2.06 21.3 0 1 812.53 389.58
  L 813.31 389.58
  A 0.38 0.38 0.0 0 1 813.64 390.15
  L 809.84 396.46
  A 0.93 0.90 -45.2 0 0 809.83 397.39
  L 813.45 403.65
  A 1.20 1.18 75.2 0 0 814.46 404.25
  L 820.98 404.37
  A 1.93 1.92 -74.2 0 0 822.67 403.42
  L 826.26 397.40
  A 0.74 0.73 -44.6 0 0 826.27 396.66
  L 822.65 390.38
  A 0.81 0.81 0.0 0 1 823.25 389.17
  L 823.57 389.13
  A 0.91 0.91 0.0 0 1 824.46 389.57
  L 827.94 395.61
  A 1.01 1.00 -15.0 0 0 828.81 396.11
  L 835.65 396.11
  A 1.23 1.20 67.0 0 1 836.51 396.47
  Q 837.48 397.42 838.75 399.37
  C 840.43 401.93 842.66 404.38 844.86 406.10
  A 0.29 0.29 0.0 0 1 844.68 406.62
  Q 843.22 406.61 842.41 407.89
  Q 840.71 410.58 838.78 413.49
  A 1.03 1.02 46.7 0 0 838.75 414.57
  L 842.64 421.31
  A 0.73 0.71 -13.9 0 0 843.25 421.67
  L 851.07 421.81
  A 0.77 0.76 10.8 0 0 851.80 421.32
  Q 852.46 419.61 853.73 418.45
  A 0.60 0.60 0.0 0 1 854.67 419.15
  L 853.56 421.45
  A 2.30 2.28 -47.4 0 0 853.64 423.58
  L 857.21 429.76
  A 1.02 1.02 0.0 0 0 858.02 430.27
  C 860.22 430.44 863.92 429.81 865.65 430.79
  A 2.05 2.02 0.9 0 1 866.40 431.55
  Q 869.39 436.98 873.34 440.36
  A 0.39 0.39 0.0 0 1 873.25 441.01
  C 870.31 442.41 869.31 445.57 867.86 448.07
  A 1.08 1.08 0.0 0 0 867.86 449.15
  L 871.40 455.27
  A 1.06 1.06 0.0 0 0 872.30 455.80
  L 879.36 455.93
  A 0.99 0.98 18.2 0 0 880.18 455.52
  L 882.55 452.19
  A 0.71 0.70 -58.7 0 1 883.42 451.97
  L 883.67 452.09
  A 0.77 0.76 26.1 0 1 884.03 453.12
  L 882.20 456.92
  A 0.73 0.72 42.9 0 0 882.23 457.59
  L 885.93 464.00
  A 0.97 0.93 -14.4 0 0 886.76 464.47
  L 895.44 464.47
  A 0.46 0.45 -15.0 0 1 895.83 464.69
  L 900.35 471.99
  A 1.47 1.46 85.6 0 0 901.00 472.55
  C 903.47 473.62 907.38 473.37 909.93 473.07
  A 0.75 0.73 -17.7 0 1 910.67 473.44
  L 915.33 481.50
  A 0.95 0.94 -14.7 0 0 916.15 481.97
  L 923.30 481.97
  A 0.85 0.83 -73.5 0 0 924.01 481.57
  L 927.70 475.55
  A 0.98 0.98 0.0 0 0 927.72 474.56
  L 924.14 468.36
  A 1.49 1.49 0.0 0 0 922.85 467.62
  L 918.37 467.62
  A 2.19 2.17 67.3 0 1 916.83 466.98
  L 915.59 465.74
  A 0.53 0.53 0.0 0 1 915.97 464.84
  L 923.17 464.97
  A 1.02 1.00 16.1 0 0 924.05 464.49
  L 927.78 458.36
  A 1.07 1.06 45.7 0 0 927.79 457.27
  L 924.16 450.98
  A 0.76 0.76 0.0 0 0 923.50 450.60
  L 916.47 450.60
  A 1.20 1.20 0.0 0 0 915.45 451.17
  L 911.67 457.39
  A 1.03 1.03 0.0 0 0 911.65 458.44
  Q 913.02 460.84 913.43 462.12
  A 0.23 0.23 0.0 0 1 913.03 462.33
  L 909.31 457.11
  A 1.06 1.05 -45.3 0 1 909.31 455.88
  L 913.40 450.17
  A 1.02 1.01 47.9 0 0 913.45 449.07
  L 909.76 442.67
  A 1.15 1.13 75.4 0 0 908.82 442.11
  C 906.50 442.03 901.99 441.86 900.46 443.10
  Q 899.99 443.48 899.48 443.63
  Q 898.78 443.83 898.70 442.50
  Q 898.42 437.66 894.43 433.51
  A 1.75 1.72 -17.7 0 0 893.40 432.99
  L 890.98 432.69
  A 0.99 0.99 0.0 0 1 890.11 431.77
  L 890.11 431.73
  A 0.78 0.78 0.0 0 1 890.88 430.89
  L 894.31 430.83
  A 1.53 1.52 -77.5 0 0 895.65 429.97
  L 898.45 424.16
  A 1.94 1.92 45.4 0 0 898.45 422.51
  Q 898.05 421.67 896.17 418.07
  C 895.09 416.00 893.98 416.54 892.09 416.53
  Q 887.83 416.52 887.09 416.71
  A 1.45 1.44 -80.7 0 0 886.22 417.34
  L 883.82 421.16
  A 0.63 0.63 0.0 0 1 882.74 421.14
  L 882.57 420.84
  A 1.93 1.92 -47.4 0 1 882.50 419.06
  L 884.16 415.62
  A 2.11 2.08 -47.4 0 0 884.09 413.65
  L 881.22 408.67
  A 2.50 2.47 75.2 0 0 879.11 407.43
  L 874.54 407.35
  A 1.70 1.70 0.0 0 1 873.11 406.51
  L 872.88 406.10
  A 0.43 0.43 0.0 0 1 873.26 405.46
  L 879.67 405.57
  A 1.84 1.83 -76.6 0 0 881.35 404.53
  L 884.33 398.34
  A 1.53 1.52 42.7 0 0 884.27 396.91
  L 881.17 391.53
  A 1.30 1.28 -14.8 0 0 880.05 390.89
  L 873.08 390.89
  A 1.90 1.90 0.0 0 0 871.37 391.96
  L 868.73 397.44
  A 0.73 0.73 0.0 0 1 867.55 397.64
  L 867.18 397.27
  A 1.49 1.48 35.5 0 1 866.89 395.57
  L 869.86 389.41
  A 1.21 1.19 -47.5 0 0 869.82 388.30
  L 866.69 382.88
  A 1.61 1.59 -14.8 0 0 865.30 382.08
  L 858.99 382.08
  A 1.77 1.75 74.8 0 1 857.47 381.20
  L 856.70 379.87
  A 0.32 0.32 0.0 0 1 857.10 379.42
  Q 860.65 381.01 865.33 380.09
  A 1.82 1.80 9.2 0 0 866.55 379.22
  L 869.96 373.39
  A 1.54 1.51 -35.1 0 0 870.15 372.37
  Q 869.92 371.03 868.32 368.39
  A 1.95 1.95 0.0 0 1 868.40 366.24
  L 868.56 366.02
  A 0.66 0.66 0.0 0 1 869.67 366.08
  L 872.34 370.70
  A 1.16 1.15 75.2 0 0 873.32 371.28
  L 879.66 371.39
  A 1.26 1.25 -71.4 0 0 880.72 370.86
  L 884.82 365.14
  A 1.24 1.23 47.9 0 0 884.88 363.79
  L 881.21 357.43
  A 1.06 1.03 -11.2 0 0 880.42 356.92
  Q 879.08 356.76 878.26 356.96
  A 0.70 0.69 -70.3 0 1 877.68 355.73
  Q 878.97 354.76 880.45 354.51
  A 2.05 2.02 7.6 0 0 881.94 353.39
  L 884.70 347.67
  A 1.57 1.55 50.5 0 0 884.80 346.59
  C 884.35 344.89 883.69 342.87 884.30 341.80
  A 0.36 0.35 45.5 0 1 884.92 341.81
  L 886.75 345.06
  A 2.80 2.75 6.9 0 0 887.34 345.80
  Q 887.54 345.96 890.24 346.06
  Q 893.08 346.17 895.02 346.14
  A 1.07 1.07 0.0 0 0 895.94 345.62
  L 899.52 339.71
  A 1.95 1.95 0.0 0 0 899.54 337.72
  L 896.33 332.16
  A 1.10 1.08 -14.5 0 0 895.38 331.61
  L 888.11 331.61
  A 0.96 0.96 0.0 0 1 887.15 330.65
  L 887.15 330.15
  A 1.09 1.09 0.0 0 1 888.26 329.06
  L 895.64 329.19
  A 0.87 0.87 0.0 0 0 896.44 328.69
  L 899.75 321.83
  A 0.80 0.79 -47.6 0 0 899.72 321.09
  L 896.56 315.62
  A 1.85 1.85 0.0 0 0 894.99 314.69
  L 887.94 314.56
  A 1.05 1.04 13.3 0 0 886.98 315.15
  L 885.51 318.20
  A 0.75 0.75 0.0 0 1 884.09 317.96
  Q 883.83 315.66 885.39 313.72
  A 1.03 1.03 0.0 0 0 885.48 312.56
  L 881.84 306.25
  A 1.09 1.08 75.2 0 0 880.92 305.71
  C 878.53 305.65 875.07 305.79 873.92 303.77
  A 0.40 0.40 0.0 0 1 874.27 303.17
  L 881.07 303.17
  A 1.52 1.51 12.6 0 0 882.44 302.31
  L 885.52 295.91
  A 0.40 0.39 44.2 0 0 885.51 295.53
  L 881.95 289.37
  A 1.07 1.06 -15.2 0 0 881.01 288.84
  L 874.43 288.97
  A 1.66 1.64 21.8 0 0 873.29 289.45
  Q 872.75 289.91 870.51 293.86
  Q 868.99 296.53 870.79 298.49
  Q 871.23 298.96 873.00 302.35
  A 0.30 0.29 88.1 0 1 872.62 302.76
  Q 869.42 301.27 867.49 297.47
  A 1.29 1.29 0.0 0 0 866.38 296.78
  L 857.58 296.62
  A 0.83 0.83 0.0 0 1 856.86 296.20
  L 852.46 288.58
  A 0.70 0.68 -13.4 0 0 851.87 288.23
  L 844.84 288.11
  A 1.30 1.29 18.2 0 0 843.74 288.66
  L 840.92 292.59
  A 1.07 1.05 -72.2 0 1 840.05 293.05
  L 839.74 293.05
  A 0.53 0.52 -77.4 0 1 839.27 292.30
  L 841.73 287.20
  A 0.74 0.72 -47.4 0 0 841.71 286.52
  L 838.23 280.50
  A 1.67 1.67 0.0 0 0 836.78 279.66
  L 830.11 279.66
  A 1.06 1.05 -74.2 0 0 829.21 280.17
  L 825.77 285.75
  A 2.21 2.20 46.1 0 0 825.73 288.02
  L 827.56 291.19
  A 0.80 0.80 0.0 0 1 826.49 292.29
  Q 824.73 291.35 823.83 288.94
  A 1.35 1.34 80.3 0 0 822.60 288.06
  L 815.76 287.94
  A 1.19 1.18 18.2 0 0 814.78 288.43
  L 812.74 291.28
  A 2.01 2.00 -72.2 0 1 811.11 292.12
  L 810.76 292.12
  A 0.59 0.59 0.0 0 1 810.23 291.27
  L 812.26 287.05
  A 1.60 1.59 -47.0 0 0 812.21 285.54
  L 809.09 280.14
  A 1.60 1.59 -15.0 0 0 807.71 279.35
  L 801.73 279.35
  A 1.60 1.59 -71.8 0 0 800.44 280.01
  L 796.48 285.55
  A 1.08 1.07 48.3 0 0 796.42 286.72
  L 798.89 290.99
  A 0.70 0.70 0.0 0 1 798.26 292.04
  L 797.92 292.04
  A 2.59 2.55 -14.2 0 1 795.74 290.76
  L 794.30 288.27
  A 1.24 1.23 75.4 0 0 793.25 287.65
  L 786.73 287.53
  A 1.22 1.21 18.1 0 0 785.72 288.04
  L 783.10 291.71
  A 1.35 1.34 -71.7 0 1 781.99 292.27
  L 781.55 292.26
  A 0.53 0.53 0.0 0 1 781.08 291.50
  L 783.40 286.67
  A 0.92 0.91 43.4 0 0 783.37 285.80
  L 780.12 280.17
  A 1.53 1.52 75.7 0 0 778.83 279.40
  L 772.16 279.29
  A 0.71 0.71 0.0 0 0 771.57 279.58
  L 767.57 285.17
  A 1.41 1.41 0.0 0 0 767.50 286.70
  L 770.13 291.25
  A 0.68 0.68 0.0 0 1 769.39 292.26
  L 768.60 292.09
  A 2.73 2.72 81.1 0 1 766.84 290.80
  L 765.27 288.09
  A 1.15 1.15 0.0 0 0 764.27 287.51
  L 757.23 287.51
  A 1.14 1.12 -69.1 0 0 756.38 287.90
  Q 755.63 288.77 755.12 290.41
  A 2.42 2.41 -88.0 0 1 753.39 292.03
  L 752.01 292.38
  A 0.57 0.57 0.0 0 1 751.36 291.58
  L 754.08 285.95
  A 1.13 1.13 0.0 0 0 754.04 284.91
  L 751.02 279.67
  A 1.59 1.57 74.6 0 0 749.66 278.89
  L 742.97 278.89
  A 1.84 1.83 -77.1 0 0 741.32 279.93
  L 738.55 285.68
  A 0.74 0.72 46.0 0 0 738.55 286.31
  L 741.62 292.73
  A 1.05 1.02 77.3 0 0 742.53 293.32
  L 749.84 293.45
  A 0.64 0.63 8.9 0 1 750.44 294.27
  L 750.28 294.80
  A 1.25 1.24 8.5 0 1 749.09 295.67
  L 742.94 295.67
  A 1.07 1.07 0.0 0 0 742.07 296.12
  L 737.97 301.85
  A 1.23 1.22 48.0 0 0 737.91 303.18
  L 741.69 309.72
  A 0.96 0.94 -14.4 0 0 742.52 310.20
  Q 745.37 310.20 748.32 310.38
  Q 750.40 310.50 751.37 308.38
  Q 752.73 305.39 754.02 301.96
  A 0.50 0.49 14.5 0 1 754.56 301.65
  Q 758.35 302.22 763.55 302.28
  C 765.45 302.30 766.50 302.79 767.44 304.43
  Q 769.14 307.42 770.63 309.66
  A 1.58 1.56 -16.9 0 0 771.96 310.36
  L 775.67 310.31
  A 1.26 1.25 85.2 0 1 776.92 311.37
  L 776.93 311.41
  A 1.03 1.03 0.0 0 1 775.89 312.55
  L 772.09 312.47
  A 2.36 2.34 -76.4 0 0 769.93 313.80
  L 766.90 320.09
  A 0.60 0.59 42.6 0 0 766.93 320.66
  L 770.33 326.55
  A 1.34 1.33 76.8 0 0 771.42 327.23
  L 776.47 327.52
  A 0.99 0.97 -86.0 0 1 777.39 328.59
  L 777.39 328.62
  A 1.17 1.17 0.0 0 1 776.23 329.66
  L 771.45 329.64
  A 1.56 1.54 -76.7 0 0 770.04 330.52
  L 767.01 336.81
  A 0.83 0.82 44.6 0 0 767.02 337.53
  L 770.12 343.62
  A 1.39 1.39 0.0 0 0 771.34 344.38
  L 776.56 344.48
  A 0.80 0.80 0.0 0 1 777.35 345.29
  L 777.34 345.58
  A 0.93 0.92 -88.8 0 1 776.40 346.49
  L 771.87 346.41
  A 1.99 1.98 16.1 0 0 770.14 347.36
  L 766.61 353.20
  A 1.21 1.19 -44.5 0 0 766.59 354.42
  L 770.10 360.50
  A 1.34 1.32 75.7 0 0 771.19 361.16
  L 776.62 361.39
  A 0.91 0.90 -80.8 0 1 777.44 362.54
  L 777.37 362.74
  A 1.40 1.38 9.6 0 1 776.02 363.69
  L 771.56 363.61
  A 1.22 1.21 18.1 0 0 770.55 364.12
  L 766.34 370.00
  A 1.07 1.05 -42.8 0 0 766.28 371.16
  L 769.96 377.54
  A 1.74 1.74 0.0 0 0 771.43 378.41
  L 776.66 378.50
  A 0.68 0.68 0.0 0 1 777.33 379.19
  L 777.32 379.57
  A 1.00 0.99 -89.4 0 1 776.33 380.55
  L 770.78 380.55
  A 1.57 1.57 0.0 0 0 769.37 381.43
  L 766.27 387.87
  A 0.43 0.43 0.0 0 0 766.29 388.26
  L 769.73 394.22
  A 1.74 1.71 75.2 0 0 771.18 395.08
  L 776.37 395.17
  A 1.06 1.06 0.0 0 1 777.31 396.69
  L 777.13 397.07
  A 1.36 1.35 -76.4 0 1 775.88 397.84
  L 770.64 397.75
  A 1.33 1.33 0.0 0 0 769.41 398.51
  L 766.27 405.03
  A 0.56 0.55 -48.0 0 0 766.29 405.57
  L 769.80 411.66
  A 1.13 1.10 74.9 0 0 770.74 412.22
  L 776.38 412.32
  A 0.75 0.75 0.0 0 1 777.10 413.23
  L 777.04 413.49
  A 1.14 1.12 6.0 0 1 775.93 414.38
  L 770.49 414.38
  A 0.92 0.91 -75.6 0 0 769.69 414.86
  L 767.55 418.78
  A 0.88 0.87 37.9 0 1 766.14 418.95
  L 765.89 418.62
  A 1.48 1.47 39.9 0 1 765.75 417.10
  L 767.43 413.60
  A 1.18 1.18 0.0 0 0 767.39 412.50
  L 763.98 406.58
  A 1.22 1.21 -15.0 0 0 762.93 405.98
  L 754.66 405.98
  A 0.56 0.55 -15.0 0 1 754.18 405.71
  L 750.04 398.52
  A 1.75 1.74 87.5 0 0 749.29 397.83
  L 745.79 396.15
  A 0.69 0.69 0.0 0 1 745.97 394.85
  L 748.63 394.38
  A 1.22 1.19 12.0 0 0 749.39 393.90
  L 753.15 388.65
  A 1.41 1.41 0.0 0 0 753.22 387.12
  L 749.55 380.75
  A 0.98 0.97 -15.0 0 0 748.71 380.27
  L 742.06 380.27
  A 2.06 2.06 0.0 0 0 740.20 381.44
  L 738.39 385.18
  A 1.24 1.24 0.0 0 1 736.49 385.60
  L 736.26 385.38
  A 1.10 1.10 0.0 0 1 736.02 384.10
  L 738.36 379.25
  A 1.64 1.62 -47.6 0 0 738.30 377.73
  L 735.39 372.69
  A 1.92 1.91 -14.9 0 0 733.73 371.73
  L 729.64 371.73
  A 0.61 0.61 0.0 0 1 729.03 371.13
  Q 728.99 369.36 733.63 369.14
  A 2.41 2.40 -74.4 0 0 735.54 368.06
  L 739.89 361.52
  A 0.77 0.74 1.1 0 1 740.15 361.28
  Q 741.29 360.67 743.02 360.87
  Q 743.13 360.88 749.05 360.78
  A 1.03 1.02 14.5 0 0 749.92 360.27
  L 753.23 354.68
  A 1.38 1.37 53.9 0 0 753.39 353.63
  L 752.87 351.52
  A 0.91 0.91 0.0 0 1 754.39 350.66
  L 756.08 352.34
  A 1.21 1.18 -21.7 0 0 756.94 352.70
  L 763.66 352.70
  A 1.03 1.03 0.0 0 0 764.55 352.19
  L 768.27 345.97
  A 1.33 1.32 45.6 0 0 768.28 344.64
  L 764.86 338.72
  A 1.28 1.26 74.8 0 0 763.76 338.08
  L 756.74 338.08
  A 1.44 1.44 0.0 0 0 755.58 338.67
  L 753.89 341.04
  A 3.04 3.02 -79.1 0 1 752.16 342.22
  L 751.91 342.28
  A 0.53 0.52 5.9 0 1 751.31 341.55
  L 753.59 336.82
  A 1.17 1.15 -47.5 0 0 753.55 335.73
  L 750.15 329.83
  A 0.93 0.92 74.4 0 0 749.36 329.38
  L 741.95 329.38
  A 1.25 1.25 0.0 0 0 740.82 330.09
  L 737.89 336.17
  A 1.34 1.33 43.0 0 0 737.94 337.41
  L 740.00 340.99
  A 0.64 0.64 0.0 0 1 739.31 341.94
  L 737.94 341.63
  A 2.16 2.15 -8.8 0 1 736.51 340.59
  L 735.18 338.29
  A 0.88 0.87 -14.7 0 0 734.42 337.85
  L 727.59 337.85
  A 0.68 0.67 17.4 0 0 727.04 338.13
  L 722.87 343.96
  A 0.92 0.91 -37.1 0 0 722.75 344.80
  Q 723.01 345.57 725.16 349.50
  C 725.98 350.99 726.51 352.38 728.50 352.30
  Q 732.25 352.14 734.52 352.19
  A 0.54 0.54 0.0 0 1 734.88 353.13
  C 733.38 354.52 730.55 354.30 727.71 354.45
  A 1.51 1.46 16.2 0 0 726.60 355.04
  Q 723.19 359.57 722.62 364.25
  A 0.72 0.72 0.0 0 1 721.34 364.61
  Q 720.42 363.48 719.39 363.33
  Q 716.62 362.94 712.76 363.14
  A 1.48 1.47 13.4 0 0 711.55 363.88
  L 709.92 366.66
  A 0.30 0.29 -68.1 0 1 709.60 366.80
  L 709.58 366.80
  A 0.54 0.54 0.0 0 1 709.24 366.13
  Q 710.40 362.27 709.43 358.32
  A 0.59 0.58 -9.1 0 1 709.96 357.60
  L 710.00 357.60
  A 0.70 0.69 75.7 0 1 710.69 358.02
  C 711.18 359.14 711.45 360.21 712.95 360.29
  Q 716.90 360.49 720.06 360.57
  A 1.13 1.12 -76.0 0 0 721.10 359.94
  L 724.41 353.06
  A 0.69 0.69 0.0 0 0 724.37 352.40
  Q 722.10 348.80 720.52 345.91
  Q 719.43 343.92 721.23 341.75
  Q 722.34 340.42 724.35 336.67
  A 1.05 1.05 0.0 0 0 724.33 335.64
  L 720.81 329.54
  A 0.79 0.79 0.0 0 0 720.13 329.15
  L 713.53 329.15
  A 2.28 2.27 12.8 0 0 711.48 330.43
  L 708.78 336.03
  A 1.04 1.02 -47.8 0 0 708.82 337.00
  L 711.13 341.01
  A 0.73 0.73 0.0 0 1 710.38 342.10
  L 710.07 342.05
  A 2.61 2.57 -10.1 0 1 708.24 340.79
  L 706.52 337.81
  A 1.58 1.56 -14.8 0 0 705.16 337.03
  L 698.78 337.03
  A 1.34 1.31 -71.7 0 0 697.71 337.58
  L 695.42 340.78
  A 3.15 3.12 -75.5 0 1 693.27 342.06
  L 692.98 342.09
  A 0.66 0.65 -75.8 0 1 692.37 341.06
  L 695.20 337.10
  A 1.88 1.85 -42.5 0 0 695.30 335.07
  L 691.96 329.28
  A 1.21 1.20 74.8 0 0 690.92 328.68
  L 683.51 328.68
  A 1.38 1.36 12.6 0 0 682.27 329.46
  L 679.52 335.16
  A 1.40 1.37 -47.8 0 0 679.57 336.46
  L 682.71 341.91
  A 2.23 2.21 -8.2 0 0 684.13 342.96
  Q 685.42 343.27 686.23 343.92
  A 0.50 0.50 0.0 0 1 685.96 344.80
  C 682.60 345.08 681.01 349.25 679.32 352.23
  A 1.11 1.09 -45.5 0 0 679.32 353.32
  L 682.57 358.94
  A 1.38 1.37 79.3 0 0 683.55 359.61
  C 685.24 359.85 687.22 359.87 689.17 360.11
  C 692.31 360.49 693.91 356.09 694.74 353.65
  A 0.40 0.40 0.0 0 1 695.51 353.79
  Q 695.42 357.74 693.68 360.79
  A 1.18 1.18 0.0 0 0 693.70 362.00
  Q 695.44 364.90 695.46 368.90
  A 0.26 0.26 0.0 0 1 694.97 369.03
  L 691.65 363.27
  A 1.76 1.76 0.0 0 0 690.14 362.41
  L 683.66 362.41
  A 1.52 1.51 12.6 0 0 682.29 363.27
  L 679.15 369.78
  A 0.77 0.76 43.0 0 0 679.18 370.49
  L 682.52 376.28
  A 0.97 0.96 -14.2 0 0 683.34 376.76
  L 690.75 376.89
  A 1.30 1.29 13.4 0 0 691.95 376.16
  L 694.69 370.45
  A 0.47 0.47 0.0 0 1 695.58 370.63
  Q 695.74 373.01 693.47 377.77
  A 1.16 1.15 -46.9 0 0 693.50 378.83
  Q 697.77 386.49 693.54 394.08
  A 0.73 0.72 52.8 0 0 693.47 394.61
  L 695.48 402.72
  A 0.37 0.37 0.0 0 1 694.80 403.00
  L 691.65 397.56
  A 2.44 2.43 -14.8 0 0 689.53 396.33
  L 683.10 396.33
  A 1.46 1.44 -76.8 0 0 681.80 397.15
  L 678.74 403.50
  A 0.75 0.74 -47.9 0 0 678.77 404.18
  L 682.14 410.02
  A 1.25 1.23 -14.4 0 0 683.20 410.64
  L 690.16 410.77
  A 1.90 1.88 13.1 0 0 691.90 409.70
  L 694.52 404.26
  A 0.44 0.43 -26.0 0 1 695.34 404.54
  L 693.60 412.38
  A 1.96 1.86 47.3 0 0 693.59 413.13
  L 693.93 415.01
  A 0.74 0.74 0.0 0 1 692.68 415.67
  L 690.44 413.43
  A 1.06 1.03 66.9 0 0 689.70 413.12
  L 683.51 413.12
  A 1.14 1.11 -71.7 0 0 682.60 413.59
  L 678.40 419.46
  A 0.90 0.89 48.4 0 0 678.35 420.42
  L 682.26 427.18
  A 0.82 0.80 -14.3 0 0 682.97 427.59
  L 689.56 427.71
  A 1.52 1.49 21.9 0 0 690.67 427.25
  L 693.46 424.34
  A 0.87 0.87 0.0 0 1 694.88 425.32
  L 693.19 428.83
  A 1.30 1.29 -47.3 0 0 693.23 430.04
  L 696.60 435.88
  A 1.11 1.11 0.0 0 0 697.56 436.43
  L 704.48 436.43
  A 0.78 0.76 14.6 0 0 705.15 436.05
  L 708.68 429.97
  A 1.02 1.01 -42.2 0 0 708.73 429.05
  Q 707.83 427.03 707.11 425.90
  Q 706.56 425.03 706.57 424.74
  A 1.00 1.00 0.0 0 1 708.29 424.10
  L 711.80 427.82
  A 1.15 1.12 68.3 0 0 712.60 428.18
  L 718.80 428.29
  A 0.88 0.87 -71.4 0 0 719.53 427.92
  L 723.53 422.33
  A 1.86 1.85 48.0 0 0 723.63 420.32
  L 720.10 414.21
  A 1.01 0.97 -11.4 0 0 719.33 413.72
  C 716.24 413.46 712.76 412.99 710.51 414.47
  A 0.52 0.52 0.0 0 1 709.71 414.03
  L 709.71 409.23
  A 0.23 0.23 0.0 0 1 710.10 409.07
  L 711.47 410.44
  A 1.79 1.79 0.0 0 0 712.67 410.95
  L 719.49 411.07
  A 1.37 1.37 0.0 0 0 720.74 410.30
  L 723.58 404.39
  A 1.12 1.12 0.0 0 0 723.58 403.39
  L 720.44 397.11
  A 1.00 0.98 -12.9 0 0 719.55 396.56
  L 712.47 396.56
  A 1.24 1.24 0.0 0 0 711.46 397.08
  L 710.30 398.70
  A 0.41 0.41 0.0 0 1 709.56 398.38
  Q 710.27 395.01 709.10 391.16
  A 0.33 0.32 -19.0 0 1 709.30 390.76
  L 709.31 390.76
  A 0.43 0.43 0.0 0 1 709.80 390.97
  L 711.00 393.22
  A 1.59 1.59 0.0 0 0 712.37 394.06
  L 719.65 394.19
  A 1.34 1.33 3.3 0 0 721.00 392.99
  Q 721.13 391.69 721.92 391.07
  Q 723.03 390.21 723.33 391.78
  Q 723.64 393.37 722.37 394.81
  A 0.97 0.97 0.0 0 0 722.26 395.95
  L 725.91 402.28
  A 1.29 1.27 75.6 0 0 726.98 402.92
  L 735.01 403.12
  A 0.82 0.82 0.0 0 1 735.70 403.56
  C 735.86 404.00 735.74 404.39 736.10 404.84
  Q 739.22 408.83 740.41 410.88
  A 1.06 1.05 -13.7 0 0 741.29 411.41
  Q 743.57 411.47 745.27 412.76
  A 0.71 0.71 0.0 0 1 744.83 414.04
  L 741.62 413.98
  A 0.85 0.84 -71.7 0 0 740.91 414.34
  L 736.73 420.19
  A 1.44 1.42 -42.4 0 0 736.65 421.75
  L 740.15 427.81
  A 1.28 1.25 -14.6 0 0 741.25 428.44
  L 748.41 428.44
  A 1.24 1.23 -76.9 0 0 749.52 427.74
  L 752.31 421.95
  A 1.17 1.17 0.0 0 1 753.88 421.40
  L 754.72 421.80
  A 0.86 0.85 -59.4 0 1 755.04 423.07
  L 750.87 428.90
  A 0.91 0.90 -42.2 0 0 750.82 429.89
  L 754.93 437.00
  A 1.05 1.04 -14.7 0 0 755.84 437.53
  L 762.35 437.53
  A 1.29 1.28 -75.2 0 0 763.47 436.87
  L 767.27 430.09
  A 0.96 0.94 -88.4 0 1 767.66 429.71
  C 770.41 428.25 774.36 429.53 776.31 429.03
  A 0.52 0.52 0.0 0 1 776.95 429.64
  L 776.83 430.19
  A 1.60 1.58 6.7 0 1 775.25 431.43
  L 770.74 431.35
  A 0.98 0.97 -71.8 0 0 769.92 431.77
  L 765.65 437.72
  A 1.40 1.38 -42.8 0 0 765.58 439.21
  L 769.34 445.73
  A 1.07 1.06 74.7 0 0 770.26 446.26
  L 775.71 446.26
  A 0.77 0.77 0.0 0 1 776.48 447.04
  L 776.47 447.36
  A 0.93 0.92 0.9 0 1 775.52 448.27
  L 770.84 448.19
  A 1.61 1.61 0.0 0 0 769.60 448.75
  Q 766.41 452.47 765.58 456.83
  A 0.30 0.29 -82.3 0 1 765.27 457.07
  L 755.48 456.39
  A 1.32 1.31 -70.1 0 0 754.32 456.94
  L 751.01 461.56
  A 4.12 4.12 0.0 0 0 751.45 466.87
  L 755.51 470.93
  A 0.90 0.88 -21.6 0 0 756.15 471.20
  L 761.93 471.20
  A 2.04 2.03 -72.2 0 0 763.59 470.34
  L 765.36 467.87
  A 0.89 0.87 17.2 0 1 766.08 467.50
  L 766.79 467.50
  A 0.50 0.49 -77.1 0 1 767.23 468.21
  L 765.44 471.93
  A 1.31 1.29 42.9 0 0 765.49 473.15
  L 769.05 479.32
  A 1.04 1.02 74.7 0 0 769.94 479.84
  L 777.00 479.84
  A 1.30 1.30 0.0 0 0 778.18 479.09
  L 781.32 472.57
  A 0.65 0.64 -47.6 0 0 781.30 471.95
  L 779.35 468.57
  A 0.61 0.60 87.7 0 1 780.13 467.72
  L 781.31 468.29
  A 2.45 2.40 -1.4 0 1 782.36 469.27
  L 783.40 471.06
  A 0.94 0.94 0.0 0 0 784.22 471.54
  L 791.56 471.54
  A 1.14 1.12 -69.6 0 0 792.42 471.14
  L 795.72 467.22
  A 0.40 0.39 33.2 0 1 796.20 467.12
  L 796.45 467.24
  A 0.56 0.56 0.0 0 1 796.72 467.99
  L 794.65 472.29
  A 1.00 0.99 42.6 0 0 794.69 473.21
  L 798.26 479.41
  A 1.23 1.21 74.9 0 0 799.29 480.01
  L 806.52 480.14
  A 0.74 0.73 12.9 0 0 807.20 479.72
  L 810.59 472.69
  A 0.84 0.83 -47.5 0 0 810.56 471.91
  L 808.63 468.57
  A 0.47 0.47 0.0 0 1 809.14 467.87
  C 810.32 468.13 811.51 469.82 812.69 471.22
  A 1.55 1.52 -18.9 0 0 813.82 471.76
  L 821.15 471.89
  A 1.22 1.21 18.8 0 0 822.14 471.41
  C 823.08 470.38 823.48 468.97 825.26 468.13
  A 0.27 0.27 0.0 0 1 825.62 468.49
  Z
  M 854.83 287.34
  Q 854.83 287.69 854.86 287.75
  Q 856.53 291.00 858.42 294.14
  A 1.31 1.29 -14.4 0 0 859.50 294.77
  L 866.39 294.89
  A 1.24 1.22 -72.3 0 0 867.42 294.35
  Q 869.53 291.20 871.21 287.76
  Q 871.24 287.70 871.24 287.53
  Q 871.24 287.36 871.21 287.31
  Q 869.61 283.83 867.57 280.64
  A 1.24 1.22 73.5 0 0 866.55 280.08
  L 859.66 280.05
  A 1.31 1.29 15.6 0 0 858.56 280.66
  Q 856.61 283.75 854.87 286.97
  Q 854.84 287.03 854.83 287.34
  Z
  M 896.01 294.94
  Q 896.49 294.68 897.19 293.51
  Q 900.05 288.68 900.10 288.56
  A 1.68 1.68 0.0 0 0 899.99 287.26
  L 897.17 281.86
  A 2.18 2.17 -11.0 0 0 895.45 280.70
  Q 891.76 280.35 888.36 280.56
  Q 888.28 280.57 888.22 280.60
  Q 888.13 280.65 888.09 280.71
  Q 886.05 283.44 884.33 286.72
  A 2.18 2.17 -45.9 0 0 884.36 288.80
  L 887.35 294.11
  A 1.68 1.68 0.0 0 0 888.38 294.91
  Q 888.50 294.94 894.12 295.17
  Q 895.47 295.23 896.01 294.94
  Z
  M 913.43 288.38
  Q 913.43 288.73 913.46 288.79
  Q 915.16 291.96 917.07 295.00
  A 1.29 1.27 -15.4 0 0 918.14 295.60
  L 924.91 295.60
  A 1.21 1.20 -73.3 0 0 925.91 295.05
  Q 927.93 291.92 929.51 288.52
  Q 929.54 288.46 929.54 288.29
  Q 929.54 288.13 929.51 288.07
  Q 927.88 284.69 925.82 281.59
  A 1.21 1.20 72.5 0 0 924.81 281.05
  L 918.04 281.15
  A 1.29 1.27 14.6 0 0 916.97 281.76
  Q 915.11 284.83 913.45 288.02
  Q 913.42 288.08 913.43 288.38
  Z
  M 723.61 294.06
  Q 723.60 294.41 723.63 294.47
  Q 725.26 297.65 727.11 300.72
  A 1.28 1.26 -14.4 0 0 728.17 301.34
  L 734.91 301.46
  A 1.21 1.19 -72.2 0 0 735.92 300.93
  Q 737.98 297.85 739.63 294.49
  Q 739.65 294.43 739.65 294.26
  Q 739.66 294.10 739.63 294.04
  Q 738.07 290.65 736.07 287.52
  A 1.21 1.19 73.5 0 0 735.07 286.97
  L 728.33 286.94
  A 1.28 1.26 15.7 0 0 727.26 287.53
  Q 725.34 290.55 723.64 293.70
  Q 723.61 293.76 723.61 294.06
  Z
  M 902.96 289.67
  Q 902.66 289.84 902.63 289.89
  Q 900.71 292.89 898.99 296.00
  A 1.27 1.25 45.5 0 0 898.99 297.21
  L 902.24 303.07
  A 1.20 1.19 -12.4 0 0 903.20 303.67
  Q 906.88 303.91 910.58 303.65
  Q 910.64 303.64 910.79 303.56
  Q 910.93 303.48 910.97 303.43
  Q 913.11 300.39 914.80 297.12
  A 1.20 1.19 -46.6 0 0 914.77 295.99
  L 911.44 290.18
  A 1.27 1.25 75.5 0 0 910.39 289.55
  Q 906.84 289.42 903.29 289.52
  Q 903.23 289.52 902.96 289.67
  Z
  M 932.50 289.91
  Q 932.19 290.08 932.16 290.13
  Q 930.16 293.10 928.37 296.20
  A 1.28 1.26 46.7 0 0 928.34 297.43
  L 931.50 303.39
  A 1.21 1.20 -11.2 0 0 932.45 304.02
  Q 936.14 304.34 939.88 304.15
  Q 939.94 304.15 940.10 304.06
  Q 940.24 303.99 940.27 303.94
  Q 942.49 300.92 944.26 297.66
  A 1.21 1.20 -45.4 0 0 944.26 296.52
  L 941.03 290.60
  A 1.28 1.26 76.7 0 0 939.99 289.95
  Q 936.41 289.74 932.83 289.77
  Q 932.77 289.77 932.50 289.91
  Z
  M 720.73 309.30
  Q 721.20 309.05 721.88 307.91
  Q 724.71 303.20 724.76 303.09
  A 1.65 1.64 -49.7 0 0 724.65 301.81
  L 721.92 296.52
  A 2.13 2.12 -10.7 0 0 720.24 295.38
  Q 716.63 295.02 713.30 295.21
  Q 713.23 295.22 713.17 295.25
  Q 713.09 295.29 713.04 295.35
  Q 711.04 298.02 709.34 301.22
  A 2.13 2.12 -45.7 0 0 709.36 303.25
  L 712.26 308.45
  A 1.65 1.64 -6.7 0 0 713.26 309.25
  Q 713.38 309.27 718.87 309.53
  Q 720.20 309.59 720.73 309.30
  Z
  M 885.87 301.26
  Q 884.71 303.27 884.34 303.93
  A 1.81 1.80 -45.3 0 0 884.34 305.70
  L 887.45 311.08
  A 2.24 2.24 0.0 0 0 889.45 312.19
  L 895.62 311.98
  A 1.32 1.31 -73.3 0 0 896.62 311.44
  Q 896.77 311.26 898.39 308.46
  Q 900.00 305.66 900.07 305.43
  A 1.32 1.31 -46.9 0 0 900.04 304.30
  L 897.12 298.86
  A 2.24 2.24 0.0 0 0 895.15 297.69
  L 888.94 297.70
  A 1.81 1.80 -74.9 0 0 887.41 298.59
  Q 887.03 299.24 885.87 301.26
  Z
  M 917.18 312.10
  Q 917.65 312.38 919.02 312.37
  Q 924.66 312.37 924.79 312.35
  A 1.69 1.69 0.0 0 0 925.86 311.58
  L 929.07 306.37
  A 2.19 2.18 48.2 0 0 929.18 304.28
  Q 927.59 300.92 925.65 298.09
  Q 925.61 298.03 925.55 297.99
  Q 925.46 297.94 925.39 297.94
  Q 921.98 297.59 918.27 297.79
  A 2.19 2.18 13.3 0 0 916.49 298.89
  L 913.44 304.19
  A 1.69 1.69 0.0 0 0 913.28 305.49
  Q 913.32 305.61 916.00 310.58
  Q 916.65 311.78 917.18 312.10
  Z
  M 710.23 310.97
  Q 710.24 310.62 710.21 310.56
  Q 708.64 307.33 706.86 304.22
  A 1.28 1.27 -13.2 0 0 705.81 303.58
  L 699.05 303.32
  A 1.21 1.20 -71.0 0 0 698.03 303.82
  Q 695.89 306.87 694.18 310.20
  Q 694.15 310.26 694.14 310.43
  Q 694.14 310.59 694.16 310.65
  Q 695.66 314.09 697.59 317.26
  A 1.21 1.20 74.7 0 0 698.58 317.84
  L 705.34 318.01
  A 1.28 1.27 16.9 0 0 706.43 317.44
  Q 708.41 314.45 710.19 311.33
  Q 710.22 311.27 710.23 310.97
  Z
  M 727.32 317.99
  Q 727.62 318.16 727.68 318.16
  Q 731.26 318.28 734.83 318.15
  A 1.28 1.26 -75.3 0 0 735.88 317.53
  L 739.25 311.70
  A 1.21 1.19 46.8 0 0 739.28 310.56
  Q 737.59 307.27 735.46 304.21
  Q 735.42 304.16 735.27 304.07
  Q 735.13 303.99 735.07 303.99
  Q 731.34 303.71 727.65 303.93
  A 1.21 1.19 12.6 0 0 726.69 304.54
  L 723.39 310.41
  A 1.28 1.26 -45.3 0 0 723.39 311.63
  Q 725.10 314.77 727.02 317.78
  Q 727.06 317.83 727.32 317.99
  Z
  M 768.38 311.34
  Q 768.38 311.00 768.36 310.94
  Q 766.73 307.77 764.89 304.73
  A 1.27 1.26 -14.4 0 0 763.84 304.12
  L 757.14 304.00
  A 1.20 1.19 -72.3 0 0 756.13 304.53
  Q 754.08 307.59 752.46 310.93
  Q 752.43 310.99 752.43 311.16
  Q 752.42 311.32 752.45 311.37
  Q 754.01 314.75 755.99 317.86
  A 1.20 1.19 73.5 0 0 756.99 318.40
  L 763.69 318.43
  A 1.27 1.26 15.6 0 0 764.76 317.84
  Q 766.66 314.83 768.35 311.70
  Q 768.38 311.64 768.38 311.34
  Z
  M 902.66 306.56
  Q 902.19 306.82 901.54 307.99
  Q 898.83 312.80 898.79 312.92
  A 1.65 1.65 0.0 0 0 898.93 314.20
  L 901.82 319.44
  A 2.14 2.14 0.0 0 0 903.55 320.54
  Q 907.18 320.79 910.52 320.50
  Q 910.59 320.50 910.66 320.46
  Q 910.74 320.41 910.78 320.36
  Q 912.72 317.62 914.33 314.36
  A 2.14 2.14 0.0 0 0 914.25 312.31
  L 911.19 307.17
  A 1.65 1.65 0.0 0 0 910.16 306.40
  Q 910.04 306.38 904.51 306.28
  Q 903.18 306.26 902.66 306.56
  Z
  M 944.11 314.02
  Q 944.11 313.67 944.08 313.61
  Q 942.39 310.43 940.48 307.37
  A 1.29 1.27 -15.3 0 0 939.40 306.76
  L 932.60 306.74
  A 1.22 1.20 -73.1 0 0 931.59 307.29
  Q 929.56 310.43 927.96 313.84
  Q 927.93 313.90 927.93 314.08
  Q 927.93 314.24 927.96 314.29
  Q 929.59 317.69 931.65 320.81
  A 1.22 1.20 72.6 0 0 932.67 321.35
  L 939.46 321.28
  A 1.29 1.27 14.8 0 0 940.54 320.66
  Q 942.42 317.58 944.09 314.38
  Q 944.12 314.33 944.11 314.02
  Z
  M 724.77 319.55
  Q 724.77 319.20 724.74 319.15
  Q 723.11 315.96 721.26 312.89
  A 1.28 1.26 -14.4 0 0 720.20 312.27
  L 713.46 312.15
  A 1.21 1.20 -72.2 0 0 712.45 312.68
  Q 710.38 315.76 708.74 319.12
  Q 708.71 319.18 708.71 319.35
  Q 708.71 319.51 708.74 319.57
  Q 710.30 322.97 712.30 326.09
  A 1.21 1.20 73.5 0 0 713.30 326.65
  L 720.04 326.68
  A 1.28 1.26 15.7 0 0 721.11 326.08
  Q 723.03 323.06 724.73 319.91
  Q 724.76 319.85 724.77 319.55
  Z
  M 749.86 326.91
  Q 750.16 326.73 750.20 326.68
  Q 752.10 323.59 753.78 320.38
  A 1.30 1.28 44.3 0 0 753.75 319.14
  L 750.31 313.24
  A 1.22 1.21 -13.5 0 0 749.32 312.64
  Q 745.57 312.48 741.80 312.83
  Q 741.74 312.83 741.59 312.92
  Q 741.45 313.00 741.41 313.06
  Q 739.29 316.20 737.64 319.57
  A 1.22 1.21 -47.8 0 0 737.69 320.72
  L 741.21 326.57
  A 1.30 1.28 74.3 0 0 742.29 327.19
  Q 745.91 327.25 749.53 327.07
  Q 749.60 327.07 749.86 326.91
  Z
  M 929.32 322.23
  Q 929.31 321.88 929.28 321.83
  Q 927.60 318.66 925.70 315.62
  A 1.28 1.27 -15.3 0 0 924.63 315.02
  L 917.87 315.00
  A 1.21 1.20 -73.2 0 0 916.86 315.55
  Q 914.84 318.67 913.25 322.06
  Q 913.23 322.12 913.23 322.29
  Q 913.23 322.45 913.26 322.51
  Q 914.88 325.89 916.93 328.99
  A 1.21 1.20 72.6 0 0 917.94 329.53
  L 924.70 329.45
  A 1.28 1.27 14.7 0 0 925.76 328.83
  Q 927.63 325.77 929.29 322.59
  Q 929.32 322.54 929.32 322.23
  Z
  M 958.47 322.66
  Q 958.48 322.32 958.45 322.26
  Q 956.84 319.10 955.01 316.06
  A 1.27 1.25 -14.3 0 0 953.96 315.44
  L 947.28 315.31
  A 1.20 1.18 -72.2 0 0 946.27 315.83
  Q 944.22 318.89 942.59 322.22
  Q 942.56 322.27 942.56 322.44
  Q 942.56 322.60 942.58 322.66
  Q 944.13 326.03 946.11 329.13
  A 1.20 1.18 73.6 0 0 947.10 329.68
  L 953.78 329.72
  A 1.27 1.25 15.7 0 0 954.84 329.13
  Q 956.75 326.14 958.44 323.02
  Q 958.47 322.96 958.47 322.66
  Z
  M 698.24 320.45
  Q 697.94 320.62 697.91 320.67
  Q 695.97 323.67 694.25 326.78
  A 1.27 1.26 45.6 0 0 694.24 328.00
  L 697.49 333.87
  A 1.20 1.19 -12.2 0 0 698.45 334.48
  Q 702.13 334.73 705.85 334.47
  Q 705.91 334.47 706.06 334.38
  Q 706.20 334.31 706.23 334.26
  Q 708.38 331.22 710.08 327.94
  A 1.20 1.19 -46.5 0 0 710.06 326.81
  L 706.73 320.98
  A 1.27 1.26 75.7 0 0 705.69 320.35
  Q 702.13 320.20 698.57 320.30
  Q 698.50 320.30 698.24 320.45
  Z
  M 739.10 327.81
  Q 739.10 327.46 739.07 327.41
  Q 737.38 324.26 735.48 321.23
  A 1.28 1.26 -15.4 0 0 734.41 320.64
  L 727.67 320.64
  A 1.21 1.19 -73.3 0 0 726.67 321.19
  Q 724.67 324.30 723.10 327.69
  Q 723.07 327.75 723.07 327.92
  Q 723.07 328.08 723.10 328.13
  Q 724.73 331.50 726.78 334.58
  A 1.21 1.19 72.4 0 0 727.79 335.11
  L 734.52 335.01
  A 1.28 1.26 14.6 0 0 735.58 334.40
  Q 737.43 331.35 739.07 328.17
  Q 739.10 328.11 739.10 327.81
  Z
  M 756.40 321.33
  Q 756.10 321.50 756.07 321.55
  Q 754.14 324.55 752.42 327.67
  A 1.28 1.26 45.5 0 0 752.41 328.89
  L 755.68 334.77
  A 1.20 1.19 -12.4 0 0 756.64 335.37
  Q 760.32 335.61 764.04 335.35
  Q 764.10 335.34 764.25 335.26
  Q 764.39 335.18 764.43 335.13
  Q 766.57 332.08 768.27 328.80
  A 1.20 1.19 -46.6 0 0 768.25 327.66
  L 764.90 321.84
  A 1.28 1.26 75.5 0 0 763.85 321.21
  Q 760.29 321.07 756.73 321.18
  Q 756.66 321.18 756.40 321.33
  Z
  M 912.68 326.69
  Q 911.51 324.68 911.13 324.02
  A 1.81 1.80 74.7 0 0 909.59 323.14
  L 903.37 323.15
  A 2.24 2.24 0.0 0 0 901.41 324.33
  L 898.51 329.79
  A 1.32 1.31 46.6 0 0 898.48 330.92
  Q 898.55 331.15 900.18 333.95
  Q 901.80 336.74 901.96 336.92
  A 1.32 1.31 73.1 0 0 902.96 337.46
  L 909.14 337.64
  A 2.24 2.24 0.0 0 0 911.14 336.52
  L 914.23 331.13
  A 1.81 1.80 45.1 0 0 914.23 329.36
  Q 913.85 328.70 912.68 326.69
  Z
  M 931.78 323.74
  Q 931.49 323.91 931.45 323.96
  Q 929.57 326.95 927.90 330.05
  A 1.26 1.24 45.0 0 0 927.90 331.25
  L 931.18 337.03
  A 1.19 1.18 -12.8 0 0 932.14 337.62
  Q 935.78 337.83 939.45 337.54
  Q 939.52 337.53 939.66 337.45
  Q 939.80 337.37 939.83 337.32
  Q 941.93 334.29 943.58 331.03
  A 1.19 1.18 -47.1 0 0 943.55 329.91
  L 940.19 324.17
  A 1.26 1.24 75.1 0 0 939.15 323.56
  Q 935.63 323.46 932.10 323.59
  Q 932.04 323.59 931.78 323.74
  Z
  M 768.07 362.39
  Q 768.07 362.04 768.04 361.99
  Q 766.38 358.79 764.51 355.72
  A 1.29 1.27 -14.7 0 0 763.44 355.10
  L 756.66 355.02
  A 1.22 1.20 -72.6 0 0 755.64 355.55
  Q 753.58 358.66 751.95 362.05
  Q 751.92 362.11 751.92 362.28
  Q 751.92 362.44 751.95 362.50
  Q 753.54 365.91 755.57 369.04
  A 1.22 1.20 73.2 0 0 756.57 369.59
  L 763.36 369.59
  A 1.29 1.27 15.3 0 0 764.43 368.98
  Q 766.34 365.93 768.04 362.75
  Q 768.07 362.70 768.07 362.39
  Z
  M 939.50 358.24
  Q 939.03 357.96 937.67 357.95
  Q 932.03 357.92 931.90 357.94
  A 1.69 1.69 0.0 0 0 930.83 358.70
  L 927.59 363.88
  A 2.19 2.18 48.6 0 0 927.47 365.97
  Q 929.04 369.34 930.95 372.17
  Q 930.99 372.23 931.06 372.27
  Q 931.14 372.32 931.21 372.33
  Q 934.62 372.70 938.33 372.52
  A 2.19 2.18 13.6 0 0 940.11 371.43
  L 943.19 366.16
  A 1.69 1.69 0.0 0 0 943.36 364.85
  Q 943.32 364.73 940.66 359.76
  Q 940.02 358.56 939.50 358.24
  Z
  M 741.58 363.29
  Q 741.28 363.46 741.24 363.51
  Q 739.27 366.49 737.50 369.61
  A 1.28 1.26 46.3 0 0 737.48 370.83
  L 740.68 376.76
  A 1.21 1.19 -11.6 0 0 741.64 377.38
  Q 745.33 377.67 749.07 377.45
  Q 749.13 377.45 749.28 377.37
  Q 749.42 377.29 749.46 377.24
  Q 751.65 374.21 753.39 370.94
  A 1.21 1.19 -45.8 0 0 753.38 369.80
  L 750.10 363.91
  A 1.28 1.26 76.3 0 0 749.06 363.27
  Q 745.49 363.08 741.91 363.14
  Q 741.85 363.14 741.58 363.29
  Z
  M 916.77 365.88
  Q 916.46 366.06 916.43 366.11
  Q 914.46 369.14 912.70 372.31
  A 1.29 1.28 45.7 0 0 912.70 373.54
  L 915.99 379.51
  A 1.22 1.21 -12.2 0 0 916.96 380.13
  Q 920.70 380.39 924.47 380.13
  Q 924.53 380.13 924.68 380.04
  Q 924.83 379.96 924.86 379.91
  Q 927.05 376.83 928.78 373.51
  A 1.22 1.21 -46.4 0 0 928.76 372.35
  L 925.39 366.43
  A 1.29 1.28 75.7 0 0 924.33 365.79
  Q 920.72 365.64 917.10 365.73
  Q 917.04 365.73 916.77 365.88
  Z
  M 755.96 372.30
  Q 755.65 372.47 755.62 372.52
  Q 753.67 375.55 751.93 378.70
  A 1.29 1.27 45.6 0 0 751.93 379.93
  L 755.22 385.86
  A 1.22 1.20 -12.3 0 0 756.19 386.47
  Q 759.90 386.72 763.66 386.45
  Q 763.72 386.45 763.87 386.36
  Q 764.01 386.28 764.05 386.23
  Q 766.21 383.16 767.93 379.85
  A 1.22 1.20 -46.5 0 0 767.90 378.70
  L 764.53 372.82
  A 1.29 1.27 75.6 0 0 763.48 372.19
  Q 759.88 372.04 756.29 372.15
  Q 756.22 372.15 755.96 372.30
  Z
  M 876.28 388.47
  Q 879.37 388.55 879.78 388.49
  A 1.73 1.73 0.0 0 0 881.01 387.65
  L 884.35 381.98
  A 1.49 1.48 -44.1 0 0 884.38 380.52
  L 881.15 374.59
  A 1.18 1.16 -11.9 0 0 880.19 373.98
  Q 879.68 373.95 876.66 373.87
  Q 873.63 373.79 873.12 373.80
  A 1.18 1.16 14.8 0 0 872.13 374.36
  L 868.60 380.12
  A 1.49 1.48 47.0 0 0 868.56 381.58
  L 871.61 387.42
  A 1.73 1.73 0.0 0 0 872.79 388.31
  Q 873.20 388.40 876.28 388.47
  Z
  M 938.96 389.17
  Q 939.43 388.91 940.12 387.75
  Q 942.99 382.95 943.04 382.83
  A 1.67 1.67 0.0 0 0 942.93 381.53
  L 940.13 376.16
  A 2.17 2.16 -10.9 0 0 938.42 375.00
  Q 934.75 374.65 931.36 374.85
  Q 931.29 374.86 931.22 374.89
  Q 931.14 374.94 931.10 375.00
  Q 929.07 377.71 927.35 380.97
  A 2.17 2.16 -45.8 0 0 927.37 383.05
  L 930.33 388.33
  A 1.67 1.67 0.0 0 0 931.36 389.13
  Q 931.48 389.16 937.07 389.40
  Q 938.42 389.46 938.96 389.17
  Z
  M 960.23 389.12
  Q 960.53 389.29 960.59 389.30
  Q 964.14 389.45 967.69 389.37
  A 1.27 1.25 -74.7 0 0 968.74 388.76
  L 972.16 383.02
  A 1.20 1.18 47.5 0 0 972.20 381.89
  Q 970.56 378.59 968.47 375.53
  Q 968.44 375.48 968.29 375.39
  Q 968.15 375.31 968.09 375.31
  Q 964.39 374.98 960.72 375.17
  A 1.20 1.18 13.2 0 0 959.76 375.76
  L 956.42 381.55
  A 1.27 1.25 -44.6 0 0 956.40 382.76
  Q 958.06 385.90 959.94 388.91
  Q 959.97 388.97 960.23 389.12
  Z
  M 694.83 386.55
  Q 694.84 386.20 694.81 386.15
  Q 693.16 382.97 691.29 379.91
  A 1.28 1.26 -14.7 0 0 690.23 379.30
  L 683.48 379.22
  A 1.21 1.20 -72.6 0 0 682.48 379.76
  Q 680.43 382.85 678.81 386.22
  Q 678.78 386.28 678.78 386.45
  Q 678.78 386.61 678.81 386.67
  Q 680.39 390.06 682.40 393.17
  A 1.21 1.20 73.2 0 0 683.41 393.72
  L 690.15 393.70
  A 1.28 1.26 15.3 0 0 691.22 393.10
  Q 693.12 390.07 694.80 386.91
  Q 694.83 386.85 694.83 386.55
  Z
  M 916.26 397.28
  Q 916.56 397.46 916.62 397.46
  Q 920.19 397.63 923.76 397.57
  A 1.28 1.26 -74.4 0 0 924.83 396.96
  L 928.29 391.19
  A 1.21 1.19 47.7 0 0 928.34 390.05
  Q 926.71 386.73 924.62 383.63
  Q 924.58 383.58 924.43 383.49
  Q 924.29 383.41 924.23 383.40
  Q 920.51 383.06 916.81 383.23
  A 1.21 1.19 13.5 0 0 915.84 383.82
  L 912.45 389.64
  A 1.28 1.26 -44.4 0 0 912.43 390.86
  Q 914.09 394.03 915.97 397.07
  Q 916.00 397.12 916.26 397.28
  Z
  M 957.53 390.57
  Q 957.54 390.23 957.51 390.17
  Q 955.89 387.01 954.06 383.98
  A 1.27 1.25 -14.4 0 0 953.01 383.36
  L 946.32 383.24
  A 1.20 1.18 -72.3 0 0 945.32 383.77
  Q 943.28 386.82 941.65 390.16
  Q 941.62 390.21 941.62 390.38
  Q 941.62 390.54 941.64 390.60
  Q 943.20 393.97 945.18 397.06
  A 1.20 1.18 73.5 0 0 946.17 397.61
  L 952.85 397.64
  A 1.27 1.25 15.6 0 0 953.91 397.05
  Q 955.81 394.05 957.50 390.93
  Q 957.53 390.87 957.53 390.57
  Z
  M 763.74 389.29
  Q 763.45 389.11 763.39 389.11
  Q 759.83 388.94 756.27 389.01
  A 1.27 1.26 -74.5 0 0 755.21 389.62
  L 751.77 395.38
  A 1.20 1.19 47.6 0 0 751.72 396.51
  Q 753.36 399.82 755.45 402.90
  Q 755.48 402.95 755.63 403.04
  Q 755.77 403.12 755.83 403.12
  Q 759.54 403.45 763.22 403.28
  A 1.20 1.19 13.4 0 0 764.19 402.69
  L 767.55 396.89
  A 1.27 1.26 -44.5 0 0 767.57 395.67
  Q 765.91 392.52 764.04 389.49
  Q 764.01 389.44 763.74 389.29
  Z
  M 927.05 398.74
  Q 927.05 399.09 927.07 399.15
  Q 928.71 402.36 930.57 405.46
  A 1.29 1.27 -14.2 0 0 931.63 406.08
  L 938.42 406.22
  A 1.22 1.20 -72.1 0 0 939.44 405.69
  Q 941.53 402.59 943.20 399.21
  Q 943.22 399.15 943.23 398.98
  Q 943.23 398.82 943.20 398.76
  Q 941.63 395.33 939.63 392.18
  A 1.22 1.20 73.7 0 0 938.62 391.62
  L 931.83 391.57
  A 1.29 1.27 15.8 0 0 930.75 392.17
  Q 928.81 395.21 927.09 398.38
  Q 927.06 398.43 927.05 398.74
  Z
  M 836.33 412.85
  Q 836.81 412.59 837.49 411.40
  Q 840.34 406.49 840.39 406.37
  A 1.70 1.70 0.0 0 0 840.26 405.05
  L 837.36 399.63
  A 2.20 2.20 0.0 0 0 835.60 398.47
  Q 831.88 398.16 828.44 398.41
  Q 828.37 398.41 828.30 398.45
  Q 828.22 398.50 828.17 398.56
  Q 826.14 401.34 824.44 404.67
  A 2.20 2.20 0.0 0 0 824.49 406.78
  L 827.56 412.11
  A 1.70 1.70 0.0 0 0 828.61 412.91
  Q 828.74 412.93 834.41 413.11
  Q 835.78 413.15 836.33 412.85
  Z
  M 734.25 419.62
  Q 734.56 419.45 734.59 419.40
  Q 736.56 416.37 738.32 413.22
  A 1.29 1.28 45.8 0 0 738.33 411.98
  L 735.05 406.01
  A 1.22 1.21 -12.1 0 0 734.08 405.39
  Q 730.35 405.13 726.58 405.38
  Q 726.52 405.38 726.37 405.47
  Q 726.23 405.55 726.19 405.60
  Q 724.00 408.67 722.26 411.99
  A 1.22 1.21 -46.3 0 0 722.28 413.14
  L 725.64 419.06
  A 1.29 1.28 75.8 0 0 726.70 419.70
  Q 730.31 419.86 733.92 419.77
  Q 733.98 419.77 734.25 419.62
  Z
  M 814.00 406.74
  Q 813.68 406.91 813.65 406.96
  Q 811.62 410.00 809.80 413.18
  A 1.31 1.29 46.5 0 0 809.77 414.43
  L 813.02 420.51
  A 1.24 1.22 -11.4 0 0 814.00 421.15
  Q 817.78 421.46 821.60 421.26
  Q 821.66 421.25 821.82 421.17
  Q 821.96 421.09 822.00 421.04
  Q 824.25 417.95 826.05 414.61
  A 1.24 1.22 -45.6 0 0 826.04 413.44
  L 822.71 407.41
  A 1.31 1.29 76.5 0 0 821.65 406.74
  Q 818.00 406.54 814.33 406.59
  Q 814.27 406.59 814.00 406.74
  Z
  M 827.78 429.53
  Q 828.08 429.72 828.15 429.72
  Q 831.81 430.02 835.49 430.06
  A 1.32 1.30 -72.6 0 0 836.60 429.47
  L 840.35 423.65
  A 1.24 1.23 49.5 0 0 840.43 422.48
  Q 838.86 419.01 836.81 415.76
  Q 836.77 415.70 836.62 415.61
  Q 836.48 415.52 836.42 415.51
  Q 832.61 415.05 828.80 415.10
  A 1.24 1.23 15.3 0 0 827.78 415.68
  L 824.11 421.55
  A 1.32 1.30 -42.6 0 0 824.05 422.81
  Q 825.65 426.12 827.49 429.31
  Q 827.52 429.36 827.78 429.53
  Z
  M 725.90 436.58
  Q 726.20 436.76 726.27 436.77
  Q 729.91 436.96 733.54 436.90
  A 1.30 1.29 -74.2 0 0 734.63 436.28
  L 738.18 430.41
  A 1.23 1.22 47.9 0 0 738.23 429.25
  Q 736.57 425.86 734.45 422.70
  Q 734.42 422.65 734.26 422.56
  Q 734.13 422.48 734.06 422.47
  Q 730.27 422.12 726.50 422.27
  A 1.23 1.22 13.7 0 0 725.51 422.87
  L 722.04 428.79
  A 1.30 1.29 -44.2 0 0 722.02 430.04
  Q 723.70 433.26 725.60 436.37
  Q 725.63 436.42 725.90 436.58
  Z
  M 813.65 423.77
  Q 813.34 423.95 813.30 424.00
  Q 811.30 427.08 809.51 430.29
  A 1.31 1.30 45.8 0 0 809.50 431.55
  L 812.83 437.61
  A 1.24 1.23 -12.1 0 0 813.82 438.24
  Q 817.62 438.51 821.45 438.25
  Q 821.51 438.25 821.67 438.16
  Q 821.81 438.08 821.85 438.03
  Q 824.07 434.90 825.84 431.53
  A 1.24 1.23 -46.3 0 0 825.82 430.36
  L 822.40 424.34
  A 1.31 1.30 75.8 0 0 821.33 423.69
  Q 817.66 423.53 813.98 423.62
  Q 813.92 423.62 813.65 423.77
  Z
  M 855.10 431.50
  Q 855.11 431.15 855.08 431.09
  Q 853.42 427.82 851.55 424.67
  A 1.31 1.29 -14.0 0 0 850.47 424.03
  L 843.57 423.87
  A 1.24 1.22 -71.9 0 0 842.53 424.40
  Q 840.40 427.54 838.70 430.97
  Q 838.68 431.03 838.67 431.21
  Q 838.67 431.37 838.70 431.43
  Q 840.28 434.92 842.30 438.13
  A 1.24 1.22 73.9 0 0 843.32 438.70
  L 850.22 438.77
  A 1.31 1.29 16.0 0 0 851.33 438.17
  Q 853.30 435.08 855.06 431.87
  Q 855.10 431.81 855.10 431.50
  Z
  M 909.69 425.14
  Q 909.39 424.96 909.33 424.96
  Q 905.70 424.77 902.07 424.83
  A 1.30 1.28 -74.3 0 0 900.99 425.45
  L 897.45 431.31
  A 1.23 1.21 47.8 0 0 897.40 432.47
  Q 899.05 435.85 901.17 439.00
  Q 901.21 439.05 901.36 439.14
  Q 901.50 439.22 901.56 439.23
  Q 905.34 439.58 909.10 439.42
  A 1.23 1.21 13.6 0 0 910.09 438.82
  L 913.55 432.91
  A 1.30 1.28 -44.3 0 0 913.57 431.67
  Q 911.89 428.45 909.99 425.35
  Q 909.96 425.30 909.69 425.14
  Z
  M 926.78 432.47
  Q 926.78 432.82 926.81 432.87
  Q 928.46 436.00 930.32 439.00
  A 1.26 1.25 -15.0 0 0 931.37 439.60
  L 938.03 439.64
  A 1.19 1.18 -72.9 0 0 939.02 439.11
  Q 941.02 436.04 942.60 432.70
  Q 942.63 432.65 942.63 432.48
  Q 942.63 432.32 942.60 432.26
  Q 941.02 428.93 939.01 425.86
  A 1.19 1.18 72.8 0 0 938.02 425.33
  L 931.36 425.38
  A 1.26 1.25 15.0 0 0 930.31 425.98
  Q 928.45 428.99 926.81 432.12
  Q 926.78 432.17 926.78 432.47
  Z
  M 967.90 439.92
  Q 968.20 439.75 968.23 439.70
  Q 970.13 436.66 971.82 433.50
  A 1.28 1.26 44.8 0 0 971.81 432.27
  L 968.46 426.41
  A 1.21 1.20 -13.0 0 0 967.49 425.82
  Q 963.78 425.62 960.05 425.93
  Q 959.98 425.94 959.84 426.02
  Q 959.70 426.10 959.66 426.15
  Q 957.54 429.24 955.88 432.56
  A 1.21 1.20 -47.3 0 0 955.92 433.70
  L 959.35 439.51
  A 1.28 1.26 74.9 0 0 960.41 440.13
  Q 963.99 440.23 967.57 440.08
  Q 967.63 440.08 967.90 439.92
  Z
  M 690.28 444.38
  Q 690.58 444.21 690.61 444.16
  Q 692.53 441.15 694.23 438.02
  A 1.27 1.26 45.2 0 0 694.22 436.80
  L 690.93 430.96
  A 1.20 1.19 -12.6 0 0 689.97 430.35
  Q 686.29 430.13 682.58 430.42
  Q 682.51 430.42 682.36 430.51
  Q 682.23 430.59 682.19 430.64
  Q 680.06 433.69 678.38 436.98
  A 1.20 1.19 -46.9 0 0 678.41 438.11
  L 681.79 443.92
  A 1.27 1.26 75.2 0 0 682.83 444.54
  Q 686.39 444.66 689.95 444.54
  Q 690.02 444.53 690.28 444.38
  Z
  M 711.27 444.67
  Q 711.57 444.85 711.63 444.85
  Q 715.21 445.06 718.80 445.03
  A 1.28 1.27 -73.9 0 0 719.87 444.43
  L 723.40 438.67
  A 1.21 1.20 48.3 0 0 723.46 437.53
  Q 721.85 434.18 719.78 431.05
  Q 719.75 431.00 719.60 430.91
  Q 719.46 430.83 719.40 430.82
  Q 715.67 430.45 711.96 430.58
  A 1.21 1.20 14.0 0 0 710.98 431.16
  L 707.52 436.97
  A 1.28 1.27 -43.8 0 0 707.49 438.19
  Q 709.12 441.38 710.98 444.45
  Q 711.01 444.51 711.27 444.67
  Z
  M 736.61 437.97
  Q 736.60 438.31 736.63 438.37
  Q 738.26 441.55 740.11 444.61
  A 1.28 1.26 -14.4 0 0 741.16 445.23
  L 747.89 445.35
  A 1.21 1.19 -72.2 0 0 748.90 444.82
  Q 750.96 441.75 752.60 438.39
  Q 752.63 438.34 752.63 438.16
  Q 752.63 438.01 752.61 437.95
  Q 751.04 434.56 749.05 431.44
  A 1.21 1.19 73.5 0 0 748.06 430.89
  L 741.33 430.86
  A 1.28 1.26 15.7 0 0 740.25 431.45
  Q 738.34 434.47 736.64 437.61
  Q 736.61 437.66 736.61 437.97
  Z
  M 840.38 439.68
  Q 840.39 439.32 840.36 439.27
  Q 838.67 436.02 836.77 432.90
  A 1.31 1.29 -14.6 0 0 835.69 432.27
  L 828.80 432.18
  A 1.24 1.22 -72.5 0 0 827.77 432.73
  Q 825.68 435.88 824.02 439.33
  Q 823.99 439.38 823.99 439.56
  Q 823.99 439.72 824.02 439.78
  Q 825.63 443.24 827.68 446.43
  A 1.24 1.22 73.3 0 0 828.71 446.98
  L 835.59 446.98
  A 1.31 1.29 15.4 0 0 836.69 446.37
  Q 838.63 443.27 840.35 440.05
  Q 840.38 439.99 840.38 439.68
  Z
  M 857.36 432.86
  Q 856.89 433.13 856.21 434.31
  Q 853.43 439.21 853.39 439.33
  A 1.69 1.68 -51.0 0 0 853.52 440.63
  L 856.45 445.98
  A 2.19 2.18 -12.1 0 0 858.20 447.11
  Q 861.90 447.39 865.30 447.12
  Q 865.38 447.11 865.44 447.07
  Q 865.53 447.03 865.57 446.97
  Q 867.56 444.19 869.22 440.87
  A 2.19 2.18 -47.0 0 0 869.15 438.79
  L 866.06 433.53
  A 1.69 1.68 -8.1 0 0 865.01 432.74
  Q 864.88 432.72 859.26 432.59
  Q 857.90 432.56 857.36 432.86
  Z
  M 923.89 447.94
  Q 924.20 447.77 924.23 447.72
  Q 926.17 444.72 927.91 441.60
  A 1.28 1.26 45.7 0 0 927.91 440.37
  L 924.66 434.48
  A 1.21 1.19 -12.2 0 0 923.70 433.87
  Q 920.01 433.62 916.28 433.87
  Q 916.22 433.88 916.07 433.96
  Q 915.93 434.04 915.89 434.09
  Q 913.73 437.14 912.02 440.42
  A 1.21 1.19 -46.4 0 0 912.04 441.56
  L 915.38 447.41
  A 1.28 1.26 75.7 0 0 916.42 448.04
  Q 919.99 448.19 923.57 448.09
  Q 923.63 448.09 923.89 447.94
  Z
  M 953.24 434.52
  Q 952.94 434.35 952.88 434.34
  Q 949.33 434.18 945.79 434.27
  A 1.27 1.25 -74.6 0 0 944.74 434.87
  L 941.32 440.62
  A 1.20 1.18 47.5 0 0 941.27 441.75
  Q 942.91 445.04 945.00 448.11
  Q 945.04 448.16 945.18 448.25
  Q 945.32 448.33 945.38 448.33
  Q 949.08 448.66 952.75 448.47
  A 1.20 1.18 13.2 0 0 953.72 447.88
  L 957.06 442.09
  A 1.27 1.25 -44.6 0 0 957.07 440.88
  Q 955.41 437.74 953.53 434.73
  Q 953.50 434.67 953.24 434.52
  Z
  M 696.84 439.35
  Q 696.54 439.52 696.51 439.57
  Q 694.60 442.60 692.90 445.75
  A 1.28 1.26 45.0 0 0 692.91 446.98
  L 696.23 452.84
  A 1.21 1.20 -12.9 0 0 697.20 453.44
  Q 700.91 453.65 704.64 453.35
  Q 704.70 453.35 704.85 453.26
  Q 704.99 453.18 705.02 453.13
  Q 707.15 450.05 708.82 446.75
  A 1.21 1.20 -47.1 0 0 708.79 445.60
  L 705.38 439.78
  A 1.28 1.26 75.0 0 0 704.32 439.16
  Q 700.75 439.05 697.17 439.19
  Q 697.11 439.19 696.84 439.35
  Z
  M 737.94 446.68
  Q 737.94 446.33 737.91 446.27
  Q 736.25 443.09 734.39 440.03
  A 1.28 1.27 -14.7 0 0 733.32 439.42
  L 726.57 439.34
  A 1.21 1.20 -72.6 0 0 725.56 439.88
  Q 723.51 442.97 721.89 446.35
  Q 721.86 446.41 721.86 446.58
  Q 721.86 446.74 721.89 446.80
  Q 723.48 450.19 725.49 453.31
  A 1.21 1.20 73.2 0 0 726.50 453.85
  L 733.25 453.84
  A 1.28 1.27 15.3 0 0 734.32 453.24
  Q 736.22 450.20 737.91 447.04
  Q 737.93 446.98 737.94 446.68
  Z
  M 755.31 439.88
  Q 754.83 440.14 754.13 441.31
  Q 751.26 446.16 751.21 446.28
  A 1.69 1.69 0.0 0 0 751.33 447.59
  L 754.16 453.00
  A 2.19 2.18 -11.1 0 0 755.90 454.16
  Q 759.60 454.51 763.01 454.29
  Q 763.09 454.29 763.15 454.25
  Q 763.24 454.21 763.28 454.15
  Q 765.32 451.40 767.04 448.10
  A 2.19 2.18 -46.0 0 0 767.01 446.01
  L 764.00 440.70
  A 1.69 1.69 0.0 0 0 762.97 439.89
  Q 762.84 439.86 757.21 439.64
  Q 755.85 439.58 755.31 439.88
  Z
  M 817.76 440.54
  Q 814.63 440.48 814.21 440.55
  A 1.76 1.76 0.0 0 0 812.97 441.40
  L 809.61 447.17
  A 1.51 1.50 -44.4 0 0 809.60 448.66
  L 812.91 454.65
  A 1.20 1.17 -12.2 0 0 813.88 455.26
  Q 814.40 455.29 817.46 455.35
  Q 820.53 455.41 821.06 455.40
  A 1.20 1.17 14.5 0 0 822.05 454.83
  L 825.59 448.97
  A 1.51 1.50 46.7 0 0 825.63 447.49
  L 822.50 441.59
  A 1.76 1.76 0.0 0 0 821.30 440.69
  Q 820.89 440.60 817.76 440.54
  Z
  M 842.65 441.14
  Q 842.35 441.32 842.31 441.37
  Q 840.33 444.47 838.57 447.68
  A 1.31 1.30 45.4 0 0 838.57 448.94
  L 841.94 454.98
  A 1.24 1.23 -12.5 0 0 842.93 455.60
  Q 846.72 455.84 850.55 455.56
  Q 850.61 455.56 850.77 455.47
  Q 850.91 455.39 850.95 455.34
  Q 853.15 452.19 854.89 448.81
  A 1.24 1.23 -46.7 0 0 854.86 447.64
  L 851.41 441.65
  A 1.31 1.30 75.4 0 0 850.33 441.01
  Q 846.66 440.87 842.99 440.99
  Q 842.93 440.99 842.65 441.14
  Z
  M 926.50 449.41
  Q 926.50 449.76 926.53 449.81
  Q 928.15 452.97 929.98 456.01
  A 1.27 1.25 -14.4 0 0 931.04 456.63
  L 937.73 456.74
  A 1.20 1.19 -72.3 0 0 938.73 456.22
  Q 940.78 453.16 942.40 449.82
  Q 942.43 449.76 942.43 449.59
  Q 942.43 449.43 942.41 449.38
  Q 940.85 446.01 938.87 442.91
  A 1.20 1.19 73.5 0 0 937.88 442.36
  L 931.18 442.34
  A 1.27 1.25 15.6 0 0 930.12 442.93
  Q 928.22 445.93 926.53 449.06
  Q 926.51 449.11 926.50 449.41
  Z
  M 967.62 456.55
  Q 967.92 456.38 967.95 456.33
  Q 969.82 453.33 971.47 450.21
  A 1.26 1.25 44.6 0 0 971.46 449.00
  L 968.13 443.23
  A 1.19 1.18 -13.2 0 0 967.17 442.64
  Q 963.52 442.46 959.84 442.78
  Q 959.78 442.79 959.63 442.87
  Q 959.49 442.95 959.46 443.00
  Q 957.38 446.06 955.75 449.33
  A 1.19 1.18 -47.5 0 0 955.79 450.46
  L 959.19 456.18
  A 1.26 1.25 74.7 0 0 960.24 456.78
  Q 963.77 456.87 967.30 456.71
  Q 967.36 456.71 967.62 456.55
  Z
  M 707.26 454.78
  Q 707.26 455.13 707.29 455.18
  Q 708.97 458.33 710.86 461.35
  A 1.28 1.26 -15.3 0 0 711.93 461.95
  L 718.64 461.96
  A 1.20 1.19 -73.2 0 0 719.64 461.42
  Q 721.65 458.32 723.23 454.94
  Q 723.26 454.89 723.26 454.71
  Q 723.26 454.56 723.23 454.50
  Q 721.61 451.14 719.57 448.06
  A 1.20 1.19 72.6 0 0 718.57 447.52
  L 711.85 447.61
  A 1.28 1.26 14.7 0 0 710.79 448.22
  Q 708.93 451.26 707.29 454.42
  Q 707.26 454.48 707.26 454.78
  Z
  M 740.67 448.24
  Q 740.37 448.41 740.34 448.46
  Q 738.40 451.43 736.67 454.52
  A 1.27 1.25 46.0 0 0 736.65 455.74
  L 739.86 461.60
  A 1.20 1.18 -11.9 0 0 740.81 462.21
  Q 744.47 462.48 748.17 462.24
  Q 748.23 462.24 748.38 462.16
  Q 748.52 462.08 748.56 462.03
  Q 750.72 459.01 752.43 455.76
  A 1.20 1.18 -46.2 0 0 752.41 454.63
  L 749.13 448.81
  A 1.27 1.25 76.0 0 0 748.09 448.18
  Q 744.55 448.02 741.00 448.09
  Q 740.94 448.10 740.67 448.24
  Z
  M 852.98 456.77
  Q 852.98 457.12 853.01 457.18
  Q 854.67 460.37 856.54 463.44
  A 1.29 1.27 -14.7 0 0 857.61 464.06
  L 864.39 464.14
  A 1.22 1.20 -72.6 0 0 865.40 463.60
  Q 867.46 460.50 869.09 457.11
  Q 869.11 457.05 869.12 456.87
  Q 869.12 456.71 869.09 456.66
  Q 867.50 453.25 865.47 450.12
  A 1.22 1.20 73.2 0 0 864.46 449.57
  L 857.68 449.58
  A 1.29 1.27 15.3 0 0 856.61 450.19
  Q 854.70 453.24 853.01 456.41
  Q 852.98 456.47 852.98 456.77
  Z
  M 953.01 451.30
  Q 952.56 451.02 951.23 451.02
  Q 945.75 451.00 945.63 451.02
  A 1.64 1.64 0.0 0 0 944.59 451.76
  L 941.45 456.80
  A 2.13 2.12 48.5 0 0 941.33 458.83
  Q 942.86 462.10 944.72 464.85
  Q 944.76 464.91 944.82 464.95
  Q 944.90 465.00 944.97 465.01
  Q 948.28 465.36 951.89 465.19
  A 2.13 2.12 13.6 0 0 953.63 464.13
  L 956.61 458.99
  A 1.64 1.64 0.0 0 0 956.78 457.73
  Q 956.73 457.61 954.15 452.77
  Q 953.53 451.61 953.01 451.30
  Z
  M 696.53 469.92
  Q 696.83 470.10 696.89 470.10
  Q 700.47 470.29 704.05 470.22
  A 1.28 1.26 -74.3 0 0 705.11 469.62
  L 708.59 463.84
  A 1.21 1.19 47.8 0 0 708.64 462.70
  Q 707.01 459.38 704.92 456.27
  Q 704.89 456.22 704.74 456.13
  Q 704.60 456.05 704.54 456.04
  Q 700.81 455.70 697.11 455.86
  A 1.21 1.19 13.6 0 0 696.13 456.45
  L 692.73 462.27
  A 1.28 1.26 -44.3 0 0 692.71 463.49
  Q 694.37 466.66 696.24 469.72
  Q 696.27 469.77 696.53 469.92
  Z
  M 733.98 456.79
  Q 733.67 456.62 733.61 456.61
  Q 729.98 456.45 726.36 456.54
  A 1.30 1.28 -74.7 0 0 725.28 457.17
  L 721.79 463.05
  A 1.23 1.21 47.4 0 0 721.75 464.20
  Q 723.43 467.56 725.57 470.70
  Q 725.61 470.75 725.76 470.84
  Q 725.90 470.92 725.96 470.92
  Q 729.74 471.25 733.49 471.06
  A 1.23 1.21 13.2 0 0 734.48 470.45
  L 737.89 464.53
  A 1.30 1.28 -44.7 0 0 737.90 463.28
  Q 736.20 460.08 734.28 457.00
  Q 734.24 456.95 733.98 456.79
  Z
  M 842.15 472.13
  Q 842.45 472.32 842.52 472.32
  Q 846.17 472.54 849.82 472.50
  A 1.31 1.29 -73.8 0 0 850.91 471.89
  L 854.52 466.03
  A 1.23 1.22 48.3 0 0 854.57 464.86
  Q 852.94 461.45 850.83 458.26
  Q 850.80 458.21 850.64 458.12
  Q 850.51 458.03 850.44 458.03
  Q 846.64 457.64 842.86 457.78
  A 1.23 1.22 14.1 0 0 841.86 458.37
  L 838.33 464.28
  A 1.31 1.29 -43.8 0 0 838.30 465.54
  Q 839.96 468.79 841.85 471.92
  Q 841.88 471.97 842.15 472.13
  Z
  M 879.72 472.88
  Q 880.20 472.61 880.89 471.42
  Q 883.73 466.49 883.77 466.37
  A 1.70 1.70 0.0 0 0 883.64 465.05
  L 880.72 459.63
  A 2.21 2.20 -11.7 0 0 878.96 458.48
  Q 875.22 458.17 871.78 458.43
  Q 871.71 458.44 871.64 458.47
  Q 871.55 458.52 871.51 458.58
  Q 869.49 461.38 867.79 464.72
  A 2.21 2.20 -46.7 0 0 867.85 466.83
  L 870.94 472.16
  A 1.70 1.70 0.0 0 0 871.99 472.96
  Q 872.12 472.98 877.80 473.15
  Q 879.18 473.18 879.72 472.88
  Z
  M 942.20 466.61
  Q 942.20 466.26 942.18 466.21
  Q 940.57 463.07 938.75 460.05
  A 1.26 1.25 -14.3 0 0 937.71 459.44
  L 931.06 459.31
  A 1.19 1.18 -72.2 0 0 930.07 459.84
  Q 928.03 462.87 926.41 466.18
  Q 926.38 466.24 926.38 466.41
  Q 926.38 466.56 926.41 466.62
  Q 927.95 469.97 929.91 473.05
  A 1.19 1.18 73.6 0 0 930.90 473.59
  L 937.54 473.63
  A 1.26 1.25 15.7 0 0 938.60 473.04
  Q 940.49 470.06 942.17 466.96
  Q 942.20 466.91 942.20 466.61
  Z
  M 961.00 459.62
  A 2.44 2.44 0.0 0 0 958.90 460.76
  L 956.07 465.36
  A 2.71 2.71 0.0 0 0 956.02 468.13
  L 959.15 473.54
  A 1.56 1.56 0.0 0 0 961.87 473.50
  C 964.01 469.53 966.50 465.79 968.11 461.29
  A 1.17 1.16 -79.6 0 0 967.04 459.73
  L 961.00 459.62
  Z
  M 723.17 472.02
  Q 723.17 471.68 723.14 471.62
  Q 721.48 468.47 719.61 465.43
  A 1.28 1.26 -14.9 0 0 718.55 464.83
  L 711.83 464.77
  A 1.20 1.19 -72.8 0 0 710.83 465.31
  Q 708.81 468.40 707.20 471.76
  Q 707.18 471.82 707.18 471.99
  Q 707.18 472.15 707.20 472.21
  Q 708.80 475.58 710.82 478.67
  A 1.20 1.19 73.0 0 0 711.82 479.21
  L 718.54 479.17
  A 1.28 1.26 15.1 0 0 719.60 478.57
  Q 721.47 475.54 723.14 472.38
  Q 723.17 472.33 723.17 472.02
  Z
  M 752.26 472.09
  Q 752.26 471.75 752.23 471.69
  Q 750.55 468.53 748.67 465.50
  A 1.28 1.26 -15.2 0 0 747.60 464.90
  L 740.87 464.88
  A 1.21 1.19 -73.1 0 0 739.87 465.42
  Q 737.86 468.53 736.27 471.91
  Q 736.24 471.96 736.24 472.14
  Q 736.24 472.29 736.27 472.35
  Q 737.88 475.72 739.92 478.81
  A 1.21 1.19 72.7 0 0 740.93 479.34
  L 747.65 479.27
  A 1.28 1.26 14.8 0 0 748.71 478.66
  Q 750.58 475.62 752.23 472.45
  Q 752.26 472.40 752.26 472.09
  Z
  M 856.71 480.95
  Q 857.02 481.13 857.08 481.13
  Q 860.75 481.30 864.42 481.21
  A 1.31 1.30 -74.7 0 0 865.50 480.58
  L 869.04 474.64
  A 1.24 1.23 47.5 0 0 869.08 473.47
  Q 867.39 470.07 865.22 466.90
  Q 865.19 466.85 865.04 466.76
  Q 864.89 466.67 864.83 466.67
  Q 861.01 466.34 857.21 466.53
  A 1.24 1.23 13.2 0 0 856.21 467.14
  L 852.76 473.13
  A 1.31 1.30 -44.7 0 0 852.75 474.38
  Q 854.47 477.62 856.41 480.74
  Q 856.44 480.79 856.71 480.95
  Z
  M 882.22 474.19
  Q 882.22 474.54 882.24 474.59
  Q 883.91 477.80 885.79 480.89
  A 1.29 1.28 -14.6 0 0 886.86 481.51
  L 893.67 481.60
  A 1.22 1.21 -72.5 0 0 894.69 481.06
  Q 896.76 477.94 898.40 474.54
  Q 898.43 474.48 898.43 474.30
  Q 898.43 474.14 898.40 474.09
  Q 896.80 470.66 894.77 467.52
  A 1.22 1.21 73.3 0 0 893.76 466.96
  L 886.95 466.97
  A 1.29 1.28 15.4 0 0 885.87 467.57
  Q 883.96 470.63 882.25 473.82
  Q 882.22 473.88 882.22 474.19
  Z
  M 944.59 481.88
  Q 944.89 482.05 944.95 482.06
  Q 948.47 482.23 952.00 482.16
  A 1.26 1.25 -74.4 0 0 953.05 481.56
  L 956.47 475.87
  A 1.19 1.18 47.7 0 0 956.52 474.74
  Q 954.90 471.46 952.84 468.41
  Q 952.81 468.35 952.66 468.27
  Q 952.53 468.19 952.46 468.18
  Q 948.79 467.85 945.14 468.01
  A 1.19 1.18 13.5 0 0 944.18 468.59
  L 940.83 474.34
  A 1.26 1.25 -44.4 0 0 940.81 475.54
  Q 942.45 478.67 944.30 481.67
  Q 944.33 481.73 944.59 481.88
  Z
  M 733.79 473.56
  Q 733.49 473.39 733.43 473.39
  Q 729.85 473.24 726.28 473.34
  A 1.28 1.26 -74.9 0 0 725.22 473.95
  L 721.79 479.76
  A 1.21 1.19 47.3 0 0 721.75 480.90
  Q 723.42 484.21 725.54 487.30
  Q 725.57 487.35 725.72 487.44
  Q 725.86 487.52 725.92 487.52
  Q 729.65 487.83 733.35 487.63
  A 1.21 1.19 13.0 0 0 734.32 487.04
  L 737.67 481.18
  A 1.28 1.26 -44.9 0 0 737.68 479.96
  Q 735.99 476.80 734.09 473.77
  Q 734.05 473.72 733.79 473.56
  Z
  M 766.80 480.92
  Q 766.80 480.57 766.77 480.52
  Q 765.09 477.35 763.20 474.30
  A 1.28 1.27 -15.1 0 0 762.13 473.70
  L 755.38 473.67
  A 1.21 1.20 -73.0 0 0 754.37 474.21
  Q 752.35 477.33 750.75 480.72
  Q 750.73 480.77 750.73 480.95
  Q 750.73 481.10 750.75 481.16
  Q 752.37 484.54 754.41 487.64
  A 1.21 1.20 72.7 0 0 755.42 488.18
  L 762.17 488.12
  A 1.28 1.27 14.9 0 0 763.23 487.51
  Q 765.11 484.46 766.77 481.28
  Q 766.80 481.23 766.80 480.92
  Z
  M 791.73 488.29
  Q 792.20 488.03 792.90 486.86
  Q 795.77 482.01 795.82 481.89
  A 1.69 1.68 -50.0 0 0 795.70 480.59
  L 792.88 475.18
  A 2.19 2.18 -11.0 0 0 791.14 474.02
  Q 787.45 473.68 784.04 473.89
  Q 783.96 473.90 783.90 473.93
  Q 783.81 473.98 783.77 474.04
  Q 781.73 476.78 780.01 480.07
  A 2.19 2.18 -46.0 0 0 780.04 482.16
  L 783.04 487.47
  A 1.69 1.68 -7.0 0 0 784.07 488.27
  Q 784.20 488.30 789.83 488.53
  Q 791.18 488.58 791.73 488.29
  Z
  M 821.48 474.36
  Q 821.01 474.08 819.61 474.08
  Q 813.85 474.07 813.72 474.09
  A 1.73 1.72 9.4 0 0 812.63 474.88
  L 809.34 480.18
  A 2.24 2.23 48.3 0 0 809.22 482.32
  Q 810.84 485.76 812.81 488.65
  Q 812.85 488.71 812.92 488.75
  Q 813.00 488.80 813.07 488.81
  Q 816.55 489.17 820.35 488.97
  A 2.24 2.23 13.4 0 0 822.17 487.86
  L 825.29 482.45
  A 1.73 1.72 52.3 0 0 825.46 481.11
  Q 825.42 480.99 822.69 475.91
  Q 822.03 474.69 821.48 474.36
  Z
  M 854.53 482.44
  Q 854.54 482.08 854.52 482.03
  Q 852.90 478.71 851.07 475.52
  A 1.32 1.30 -13.2 0 0 849.99 474.86
  L 843.06 474.59
  A 1.24 1.23 -71.1 0 0 842.00 475.11
  Q 839.81 478.24 838.05 481.66
  Q 838.02 481.72 838.02 481.90
  Q 838.01 482.06 838.04 482.12
  Q 839.58 485.65 841.56 488.91
  A 1.24 1.23 74.7 0 0 842.58 489.50
  L 849.52 489.67
  A 1.32 1.30 16.8 0 0 850.64 489.09
  Q 852.67 486.02 854.49 482.81
  Q 854.52 482.75 854.53 482.44
  Z
  M 871.19 489.55
  Q 871.49 489.73 871.55 489.73
  Q 875.19 489.94 878.82 489.90
  A 1.30 1.28 -73.9 0 0 879.91 489.29
  L 883.48 483.45
  A 1.23 1.21 48.2 0 0 883.54 482.29
  Q 881.91 478.90 879.80 475.73
  Q 879.77 475.68 879.62 475.59
  Q 879.48 475.50 879.42 475.50
  Q 875.63 475.12 871.87 475.26
  A 1.23 1.21 14.0 0 0 870.87 475.85
  L 867.38 481.74
  A 1.30 1.28 -43.9 0 0 867.35 482.99
  Q 869.01 486.22 870.89 489.33
  Q 870.92 489.39 871.19 489.55
  Z
  M 900.93 476.07
  Q 900.63 476.25 900.59 476.30
  Q 898.68 479.35 896.99 482.52
  A 1.29 1.27 44.9 0 0 897.00 483.75
  L 900.36 489.62
  A 1.21 1.20 -13.0 0 0 901.33 490.23
  Q 905.05 490.42 908.79 490.11
  Q 908.86 490.11 909.01 490.02
  Q 909.14 489.94 909.18 489.89
  Q 911.31 486.79 912.98 483.46
  A 1.21 1.20 -47.2 0 0 912.94 482.32
  L 909.50 476.49
  A 1.29 1.27 74.9 0 0 908.44 475.87
  Q 904.85 475.77 901.25 475.92
  Q 901.19 475.92 900.93 476.07
  Z
  M 926.17 483.28
  Q 926.17 483.62 926.20 483.68
  Q 927.86 486.82 929.73 489.84
  A 1.27 1.25 -15.1 0 0 930.79 490.44
  L 937.48 490.47
  A 1.20 1.19 -73.0 0 0 938.47 489.93
  Q 940.48 486.85 942.07 483.49
  Q 942.09 483.44 942.09 483.26
  Q 942.09 483.11 942.07 483.05
  Q 940.47 479.70 938.45 476.63
  A 1.20 1.19 72.8 0 0 937.45 476.09
  L 930.76 476.15
  A 1.27 1.25 14.9 0 0 929.70 476.75
  Q 927.84 479.78 926.19 482.92
  Q 926.17 482.98 926.17 483.28
  Z
  M 718.86 481.94
  Q 718.55 481.77 718.49 481.76
  Q 714.92 481.66 711.35 481.80
  A 1.28 1.26 -75.6 0 0 710.30 482.43
  L 706.95 488.27
  A 1.21 1.19 46.6 0 0 706.93 489.41
  Q 708.63 492.69 710.78 495.75
  Q 710.81 495.80 710.96 495.88
  Q 711.10 495.96 711.17 495.96
  Q 714.89 496.23 718.58 495.99
  A 1.21 1.19 12.3 0 0 719.55 495.38
  L 722.82 489.50
  A 1.28 1.26 -45.5 0 0 722.81 488.27
  Q 721.09 485.14 719.15 482.14
  Q 719.12 482.09 718.86 481.94
  Z
  M 740.06 496.19
  Q 740.37 496.36 740.43 496.36
  Q 744.04 496.50 747.65 496.39
  A 1.29 1.28 -75.1 0 0 748.72 495.76
  L 752.15 489.89
  A 1.22 1.21 47.0 0 0 752.19 488.74
  Q 750.50 485.40 748.35 482.29
  Q 748.31 482.24 748.16 482.16
  Q 748.02 482.08 747.96 482.07
  Q 744.19 481.77 740.46 481.98
  A 1.22 1.21 12.8 0 0 739.48 482.59
  L 736.12 488.51
  A 1.29 1.28 -45.1 0 0 736.12 489.75
  Q 737.83 492.93 739.76 495.98
  Q 739.80 496.03 740.06 496.19
  Z
  M 781.25 489.77
  Q 781.25 489.42 781.22 489.37
  Q 779.59 486.18 777.75 483.11
  A 1.28 1.26 -14.3 0 0 776.69 482.49
  L 769.95 482.36
  A 1.21 1.19 -72.2 0 0 768.94 482.89
  Q 766.87 485.96 765.23 489.32
  Q 765.20 489.38 765.20 489.55
  Q 765.20 489.71 765.22 489.77
  Q 766.78 493.17 768.77 496.30
  A 1.21 1.19 73.6 0 0 769.77 496.85
  L 776.51 496.89
  A 1.28 1.26 15.7 0 0 777.59 496.29
  Q 779.51 493.28 781.21 490.13
  Q 781.24 490.07 781.25 489.77
  Z
  M 806.78 482.84
  Q 806.30 482.55 804.93 482.54
  Q 799.23 482.51 799.10 482.53
  A 1.71 1.71 0.0 0 0 798.01 483.30
  L 794.74 488.53
  A 2.21 2.20 48.6 0 0 794.61 490.64
  Q 796.19 494.05 798.13 496.92
  Q 798.17 496.98 798.23 497.02
  Q 798.31 497.07 798.39 497.07
  Q 801.83 497.45 805.58 497.28
  A 2.21 2.20 13.7 0 0 807.39 496.18
  L 810.50 490.85
  A 1.71 1.71 0.0 0 0 810.68 489.53
  Q 810.63 489.41 807.96 484.37
  Q 807.31 483.16 806.78 482.84
  Z
  M 827.31 497.40
  Q 827.62 497.58 827.69 497.59
  Q 831.40 497.76 835.12 497.69
  A 1.33 1.31 -74.5 0 0 836.22 497.05
  L 839.82 491.04
  A 1.26 1.24 47.6 0 0 839.87 489.86
  Q 838.16 486.41 835.98 483.19
  Q 835.94 483.14 835.79 483.05
  Q 835.65 482.96 835.58 482.96
  Q 831.71 482.61 827.87 482.79
  A 1.26 1.24 13.4 0 0 826.85 483.40
  L 823.34 489.46
  A 1.33 1.31 -44.5 0 0 823.32 490.73
  Q 825.05 494.02 827.01 497.18
  Q 827.04 497.24 827.31 497.40
  Z
  M 864.78 497.83
  Q 865.09 497.66 865.12 497.61
  Q 867.11 494.56 868.88 491.39
  A 1.30 1.28 45.8 0 0 868.89 490.14
  L 865.59 484.14
  A 1.23 1.21 -12.0 0 0 864.62 483.51
  Q 860.86 483.25 857.07 483.50
  Q 857.01 483.50 856.85 483.59
  Q 856.71 483.67 856.68 483.72
  Q 854.47 486.81 852.72 490.15
  A 1.23 1.21 -46.3 0 0 852.74 491.31
  L 856.12 497.26
  A 1.30 1.28 75.9 0 0 857.18 497.91
  Q 860.81 498.07 864.45 497.98
  Q 864.51 497.98 864.78 497.83
  Z
  M 885.81 498.32
  Q 886.11 498.50 886.18 498.50
  Q 889.79 498.70 893.41 498.66
  A 1.29 1.28 -74.0 0 0 894.49 498.05
  L 898.04 492.24
  A 1.22 1.21 48.1 0 0 898.09 491.08
  Q 896.46 487.71 894.37 484.56
  Q 894.33 484.51 894.18 484.42
  Q 894.05 484.33 893.98 484.33
  Q 890.22 483.96 886.47 484.10
  A 1.22 1.21 13.9 0 0 885.48 484.69
  L 882.01 490.55
  A 1.29 1.28 -44.0 0 0 881.98 491.79
  Q 883.64 495.01 885.52 498.10
  Q 885.55 498.16 885.81 498.32
  Z
  M 927.45 491.79
  Q 927.45 491.24 926.76 490.08
  Q 923.90 485.26 923.82 485.16
  A 1.68 1.68 0.0 0 0 922.62 484.63
  L 916.55 484.52
  A 2.18 2.17 -72.3 0 0 914.71 485.48
  Q 912.64 488.54 911.20 491.62
  Q 911.17 491.69 911.17 491.76
  Q 911.17 491.86 911.20 491.92
  Q 912.62 495.01 914.67 498.09
  A 2.18 2.17 72.7 0 0 916.51 499.06
  L 922.58 498.98
  A 1.68 1.68 0.0 0 0 923.78 498.46
  Q 923.86 498.36 926.75 493.56
  Q 927.44 492.40 927.45 491.79
  Z
  M 733.36 504.60
  Q 733.66 504.43 733.69 504.38
  Q 735.67 501.39 737.43 498.27
  A 1.28 1.27 46.1 0 0 737.44 497.04
  L 734.23 491.10
  A 1.21 1.20 -11.7 0 0 733.27 490.48
  Q 729.56 490.20 725.82 490.43
  Q 725.76 490.43 725.61 490.51
  Q 725.47 490.59 725.43 490.64
  Q 723.24 493.68 721.50 496.96
  A 1.21 1.20 -46.0 0 0 721.51 498.11
  L 724.81 504.00
  A 1.28 1.27 76.2 0 0 725.86 504.64
  Q 729.44 504.82 733.03 504.75
  Q 733.09 504.75 733.36 504.60
  Z
  M 754.61 490.78
  Q 754.30 490.95 754.27 491.00
  Q 752.35 494.04 750.64 497.21
  A 1.29 1.27 45.0 0 0 750.65 498.44
  L 753.99 504.33
  A 1.21 1.20 -12.8 0 0 754.96 504.93
  Q 758.68 505.14 762.43 504.84
  Q 762.49 504.84 762.64 504.75
  Q 762.78 504.67 762.81 504.62
  Q 764.95 501.53 766.64 498.21
  A 1.21 1.20 -47.1 0 0 766.60 497.06
  L 763.18 491.22
  A 1.29 1.27 75.1 0 0 762.12 490.60
  Q 758.53 490.49 754.93 490.62
  Q 754.87 490.62 754.61 490.78
  Z
  M 795.80 498.23
  Q 795.80 497.88 795.77 497.82
  Q 794.05 494.62 792.12 491.55
  A 1.30 1.28 -15.4 0 0 791.04 490.95
  L 784.21 490.95
  A 1.23 1.21 -73.3 0 0 783.19 491.50
  Q 781.16 494.66 779.56 498.10
  Q 779.53 498.16 779.53 498.33
  Q 779.53 498.49 779.56 498.55
  Q 781.21 501.96 783.29 505.09
  A 1.23 1.21 72.5 0 0 784.31 505.63
  L 791.15 505.54
  A 1.30 1.28 14.6 0 0 792.22 504.92
  Q 794.10 501.82 795.77 498.59
  Q 795.80 498.54 795.80 498.23
  Z
  M 808.72 498.53
  Q 808.72 498.89 808.75 498.95
  Q 810.45 502.26 812.37 505.44
  A 1.33 1.31 -14.4 0 0 813.47 506.08
  L 820.47 506.20
  A 1.26 1.24 -72.3 0 0 821.52 505.65
  Q 823.66 502.45 825.36 498.96
  Q 825.39 498.90 825.39 498.72
  Q 825.39 498.55 825.37 498.49
  Q 823.74 494.97 821.66 491.72
  A 1.26 1.24 73.5 0 0 820.62 491.15
  L 813.62 491.13
  A 1.33 1.31 15.6 0 0 812.51 491.75
  Q 810.53 494.89 808.76 498.16
  Q 808.73 498.22 808.72 498.53
  Z
  M 850.33 492.08
  Q 850.03 491.90 849.96 491.90
  Q 846.31 491.69 842.65 491.74
  A 1.31 1.29 -74.0 0 0 841.56 492.35
  L 837.97 498.23
  A 1.24 1.22 48.1 0 0 837.91 499.40
  Q 839.56 502.81 841.68 505.99
  Q 841.71 506.05 841.87 506.14
  Q 842.01 506.22 842.07 506.23
  Q 845.87 506.60 849.66 506.46
  A 1.24 1.22 13.9 0 0 850.66 505.86
  L 854.17 499.93
  A 1.31 1.29 -44.0 0 0 854.20 498.68
  Q 852.53 495.43 850.63 492.30
  Q 850.60 492.25 850.33 492.08
  Z
  M 883.44 499.75
  Q 883.45 499.40 883.42 499.34
  Q 881.81 496.10 879.99 492.98
  A 1.29 1.28 -13.6 0 0 878.93 492.34
  L 872.12 492.13
  A 1.22 1.21 -71.5 0 0 871.09 492.65
  Q 868.96 495.74 867.26 499.11
  Q 867.23 499.17 867.23 499.34
  Q 867.22 499.50 867.25 499.56
  Q 868.79 503.01 870.76 506.20
  A 1.22 1.21 74.3 0 0 871.76 506.77
  L 878.57 506.88
  A 1.29 1.28 16.4 0 0 879.66 506.30
  Q 881.64 503.27 883.40 500.11
  Q 883.43 500.06 883.44 499.75
  Z
  M 896.63 499.88
  Q 896.64 500.42 897.34 501.58
  Q 900.23 506.36 900.31 506.46
  A 1.67 1.67 0.0 0 0 901.51 506.97
  L 907.56 507.03
  A 2.17 2.16 -72.9 0 0 909.39 506.05
  Q 911.43 502.98 912.84 499.89
  Q 912.87 499.83 912.86 499.75
  Q 912.86 499.66 912.83 499.59
  Q 911.39 496.53 909.31 493.48
  A 2.17 2.16 72.2 0 0 907.47 492.53
  L 901.42 492.66
  A 1.67 1.67 0.0 0 0 900.23 493.19
  Q 900.15 493.29 897.31 498.11
  Q 896.63 499.27 896.63 499.88
  Z
  M 752.06 506.05
  Q 752.05 505.71 752.02 505.65
  Q 750.28 502.50 748.32 499.48
  A 1.29 1.27 -16.2 0 0 747.24 498.89
  L 740.46 498.99
  A 1.22 1.20 -74.1 0 0 739.46 499.55
  Q 737.49 502.71 735.94 506.15
  Q 735.92 506.20 735.92 506.38
  Q 735.93 506.54 735.95 506.59
  Q 737.64 509.96 739.74 513.03
  A 1.22 1.20 71.7 0 0 740.76 513.56
  L 747.54 513.37
  A 1.29 1.27 13.8 0 0 748.60 512.74
  Q 750.43 509.64 752.04 506.42
  Q 752.06 506.36 752.06 506.05
  Z
  M 769.25 499.67
  Q 768.94 499.84 768.91 499.89
  Q 766.94 502.86 765.19 505.96
  A 1.27 1.26 46.2 0 0 765.17 507.18
  L 768.36 513.09
  A 1.20 1.19 -11.6 0 0 769.31 513.71
  Q 772.99 513.99 776.71 513.77
  Q 776.77 513.77 776.92 513.68
  Q 777.06 513.61 777.10 513.56
  Q 779.28 510.54 781.01 507.28
  A 1.20 1.19 -45.9 0 0 781.00 506.15
  L 777.73 500.28
  A 1.27 1.26 76.2 0 0 776.69 499.65
  Q 773.14 499.46 769.57 499.52
  Q 769.51 499.52 769.25 499.67
  Z
  M 798.04 513.86
  Q 798.34 514.04 798.40 514.05
  Q 802.04 514.23 805.69 514.16
  A 1.30 1.29 -74.3 0 0 806.77 513.55
  L 810.31 507.67
  A 1.23 1.22 47.8 0 0 810.36 506.51
  Q 808.70 503.12 806.57 499.96
  Q 806.54 499.90 806.39 499.81
  Q 806.25 499.73 806.18 499.73
  Q 802.39 499.37 798.62 499.54
  A 1.23 1.22 13.6 0 0 797.62 500.14
  L 794.16 506.07
  A 1.30 1.29 -44.3 0 0 794.14 507.31
  Q 795.83 510.54 797.74 513.65
  Q 797.77 513.70 798.04 513.86
  Z
  M 827.04 514.42
  Q 827.35 514.60 827.41 514.61
  Q 831.11 514.83 834.81 514.80
  A 1.32 1.31 -73.8 0 0 835.91 514.18
  L 839.57 508.24
  A 1.25 1.24 48.3 0 0 839.63 507.06
  Q 837.97 503.61 835.84 500.38
  Q 835.81 500.32 835.66 500.23
  Q 835.52 500.14 835.45 500.14
  Q 831.60 499.74 827.77 499.88
  A 1.25 1.24 14.1 0 0 826.75 500.48
  L 823.18 506.46
  A 1.32 1.31 -43.8 0 0 823.14 507.73
  Q 824.83 511.02 826.74 514.20
  Q 826.77 514.25 827.04 514.42
  Z
  M 852.49 507.69
  Q 852.49 508.05 852.51 508.10
  Q 854.15 511.37 856.00 514.50
  A 1.30 1.29 -13.9 0 0 857.08 515.14
  L 863.94 515.33
  A 1.23 1.22 -71.7 0 0 864.98 514.80
  Q 867.11 511.68 868.81 508.27
  Q 868.84 508.21 868.84 508.03
  Q 868.84 507.87 868.82 507.81
  Q 867.25 504.34 865.25 501.14
  A 1.23 1.22 74.0 0 0 864.24 500.57
  L 857.37 500.48
  A 1.30 1.29 16.1 0 0 856.27 501.07
  Q 854.29 504.13 852.53 507.33
  Q 852.50 507.38 852.49 507.69
  Z
  M 881.85 508.06
  Q 881.85 508.40 881.87 508.46
  Q 883.52 511.66 885.39 514.73
  A 1.29 1.27 -14.5 0 0 886.45 515.35
  L 893.22 515.45
  A 1.21 1.20 -72.4 0 0 894.24 514.92
  Q 896.30 511.82 897.94 508.43
  Q 897.97 508.38 897.97 508.20
  Q 897.97 508.04 897.95 507.99
  Q 896.36 504.58 894.35 501.44
  A 1.21 1.20 73.4 0 0 893.35 500.89
  L 886.57 500.88
  A 1.29 1.27 15.5 0 0 885.50 501.48
  Q 883.58 504.52 881.88 507.69
  Q 881.85 507.75 881.85 508.06
  Z
  M 915.13 515.22
  Q 915.42 515.40 915.49 515.40
  Q 919.01 515.58 922.53 515.52
  A 1.26 1.24 -74.3 0 0 923.58 514.93
  L 927.02 509.24
  A 1.19 1.18 47.8 0 0 927.07 508.12
  Q 925.46 504.84 923.40 501.78
  Q 923.37 501.73 923.22 501.64
  Q 923.09 501.56 923.03 501.55
  Q 919.36 501.21 915.71 501.37
  A 1.19 1.18 13.6 0 0 914.74 501.95
  L 911.39 507.68
  A 1.26 1.24 -44.3 0 0 911.37 508.89
  Q 913.00 512.01 914.84 515.02
  Q 914.87 515.07 915.13 515.22
  Z
  M 750.35 514.53
  Q 750.35 514.88 750.38 514.93
  Q 751.98 518.10 753.80 521.16
  A 1.27 1.25 -14.1 0 0 754.84 521.77
  L 761.53 521.93
  A 1.20 1.19 -72.0 0 0 762.54 521.41
  Q 764.60 518.36 766.25 515.04
  Q 766.28 514.98 766.28 514.81
  Q 766.28 514.65 766.26 514.59
  Q 764.72 511.21 762.76 508.10
  A 1.20 1.19 73.8 0 0 761.77 507.55
  L 755.08 507.49
  A 1.27 1.25 15.9 0 0 754.01 508.07
  Q 752.09 511.06 750.39 514.18
  Q 750.36 514.23 750.35 514.53
  Z
  M 791.68 522.31
  Q 791.98 522.13 792.01 522.08
  Q 793.91 519.01 795.59 515.82
  A 1.29 1.27 44.5 0 0 795.57 514.58
  L 792.16 508.71
  A 1.22 1.20 -13.4 0 0 791.17 508.11
  Q 787.44 507.94 783.69 508.28
  Q 783.62 508.28 783.47 508.37
  Q 783.34 508.45 783.30 508.51
  Q 781.19 511.63 779.53 514.98
  A 1.22 1.20 -47.7 0 0 779.58 516.13
  L 783.07 521.95
  A 1.29 1.27 74.5 0 0 784.14 522.57
  Q 787.75 522.64 791.35 522.47
  Q 791.42 522.46 791.68 522.31
  Z
  M 812.64 522.75
  Q 813.12 523.04 814.50 523.04
  Q 820.26 523.04 820.39 523.02
  A 1.72 1.72 0.0 0 0 821.48 522.24
  L 824.76 516.94
  A 2.23 2.23 0.0 0 0 824.88 514.81
  Q 823.26 511.38 821.29 508.49
  Q 821.25 508.43 821.19 508.39
  Q 821.10 508.34 821.03 508.33
  Q 817.56 507.97 813.77 508.17
  A 2.23 2.23 0.0 0 0 811.95 509.29
  L 808.84 514.69
  A 1.72 1.72 0.0 0 0 808.67 516.01
  Q 808.71 516.14 811.44 521.21
  Q 812.10 522.43 812.64 522.75
  Z
  M 841.75 523.04
  Q 842.05 523.22 842.11 523.22
  Q 845.77 523.43 849.43 523.38
  A 1.31 1.29 -74.0 0 0 850.52 522.76
  L 854.11 516.88
  A 1.24 1.22 48.1 0 0 854.16 515.71
  Q 852.51 512.30 850.39 509.11
  Q 850.36 509.06 850.20 508.97
  Q 850.06 508.89 850.00 508.88
  Q 846.19 508.51 842.40 508.65
  A 1.24 1.22 13.9 0 0 841.40 509.25
  L 837.90 515.19
  A 1.31 1.29 -44.0 0 0 837.87 516.44
  Q 839.54 519.69 841.45 522.82
  Q 841.48 522.87 841.75 523.04
  Z
  M 879.28 509.69
  Q 878.98 509.51 878.92 509.51
  Q 875.31 509.33 871.70 509.40
  A 1.29 1.28 -74.4 0 0 870.62 510.01
  L 867.12 515.85
  A 1.22 1.21 47.7 0 0 867.07 517.00
  Q 868.72 520.36 870.84 523.49
  Q 870.87 523.54 871.02 523.63
  Q 871.16 523.71 871.22 523.72
  Q 874.99 524.06 878.73 523.89
  A 1.22 1.21 13.5 0 0 879.71 523.29
  L 883.13 517.41
  A 1.29 1.28 -44.4 0 0 883.16 516.17
  Q 881.48 512.98 879.58 509.90
  Q 879.55 509.84 879.28 509.69
  Z
  M 908.60 510.12
  Q 908.15 509.84 906.83 509.84
  Q 901.38 509.80 901.26 509.82
  A 1.63 1.63 0.0 0 0 900.22 510.56
  L 897.09 515.56
  A 2.12 2.11 48.7 0 0 896.96 517.57
  Q 898.48 520.83 900.33 523.57
  Q 900.37 523.63 900.43 523.67
  Q 900.51 523.72 900.58 523.73
  Q 903.86 524.09 907.45 523.92
  A 2.12 2.11 13.7 0 0 909.18 522.87
  L 912.16 517.78
  A 1.63 1.63 0.0 0 0 912.33 516.52
  Q 912.28 516.40 909.73 511.59
  Q 909.11 510.43 908.60 510.12
  Z
  M 776.98 516.69
  Q 776.52 516.42 775.18 516.43
  Q 769.62 516.47 769.50 516.49
  A 1.66 1.66 0.0 0 0 768.45 517.25
  L 765.32 522.39
  A 2.16 2.15 47.9 0 0 765.22 524.44
  Q 766.81 527.74 768.73 530.52
  Q 768.77 530.57 768.83 530.61
  Q 768.91 530.66 768.98 530.67
  Q 772.34 530.99 775.99 530.77
  A 2.16 2.15 13.0 0 0 777.74 529.68
  L 780.71 524.45
  A 1.66 1.66 0.0 0 0 780.86 523.16
  Q 780.82 523.05 778.15 518.17
  Q 777.50 517.00 776.98 516.69
  Z
  M 806.26 516.85
  Q 805.95 516.67 805.89 516.67
  Q 802.23 516.51 798.57 516.61
  A 1.31 1.29 -74.8 0 0 797.49 517.24
  L 793.97 523.17
  A 1.24 1.22 47.3 0 0 793.93 524.34
  Q 795.63 527.73 797.79 530.89
  Q 797.83 530.94 797.98 531.03
  Q 798.12 531.12 798.19 531.12
  Q 802.00 531.44 805.79 531.25
  A 1.24 1.22 13.1 0 0 806.78 530.64
  L 810.21 524.65
  A 1.31 1.29 -44.8 0 0 810.23 523.40
  Q 808.51 520.17 806.56 517.06
  Q 806.53 517.01 806.26 516.85
  Z
  M 839.66 524.45
  Q 839.66 524.09 839.63 524.04
  Q 837.91 520.78 835.97 517.64
  A 1.32 1.30 -15.1 0 0 834.87 517.02
  L 827.93 516.98
  A 1.24 1.23 -73.0 0 0 826.90 517.54
  Q 824.81 520.74 823.17 524.22
  Q 823.14 524.28 823.14 524.45
  Q 823.14 524.62 823.17 524.68
  Q 824.82 528.15 826.91 531.35
  A 1.24 1.23 72.8 0 0 827.95 531.90
  L 834.89 531.84
  A 1.32 1.30 14.9 0 0 835.99 531.22
  Q 837.92 528.08 839.63 524.82
  Q 839.66 524.76 839.66 524.45
  Z
  M 856.38 531.54
  Q 856.68 531.72 856.74 531.72
  Q 860.37 531.94 864.00 531.91
  A 1.30 1.28 -73.8 0 0 865.09 531.30
  L 868.68 525.47
  A 1.23 1.21 48.3 0 0 868.74 524.32
  Q 867.11 520.92 865.02 517.75
  Q 864.98 517.70 864.83 517.61
  Q 864.69 517.52 864.63 517.52
  Q 860.85 517.13 857.09 517.26
  A 1.23 1.21 14.1 0 0 856.09 517.85
  L 852.59 523.73
  A 1.30 1.28 -43.8 0 0 852.55 524.97
  Q 854.21 528.21 856.08 531.32
  Q 856.11 531.38 856.38 531.54
  Z
  M 883.39 521.66
  Q 882.23 523.65 881.86 524.31
  A 1.80 1.79 -45.0 0 0 881.86 526.07
  L 884.92 531.43
  A 2.23 2.22 74.3 0 0 886.91 532.54
  L 893.05 532.36
  A 1.31 1.30 -73.1 0 0 894.04 531.83
  Q 894.20 531.65 895.81 528.87
  Q 897.43 526.09 897.50 525.87
  A 1.31 1.30 -46.6 0 0 897.47 524.74
  L 894.59 519.32
  A 2.23 2.22 -14.0 0 0 892.64 518.15
  L 886.46 518.14
  A 1.80 1.79 -74.6 0 0 884.94 519.01
  Q 884.55 519.66 883.39 521.66
  Z
  M 791.33 539.28
  Q 791.64 539.11 791.67 539.06
  Q 793.61 536.02 795.33 532.86
  A 1.29 1.27 45.3 0 0 795.32 531.63
  L 792.00 525.71
  A 1.22 1.20 -12.6 0 0 791.03 525.11
  Q 787.31 524.88 783.56 525.17
  Q 783.49 525.17 783.34 525.26
  Q 783.20 525.34 783.17 525.39
  Q 781.01 528.47 779.32 531.79
  A 1.22 1.20 -46.8 0 0 779.35 532.94
  L 782.75 538.81
  A 1.29 1.27 75.3 0 0 783.81 539.43
  Q 787.41 539.56 791.00 539.44
  Q 791.07 539.43 791.33 539.28
  Z
  M 820.95 525.61
  Q 820.65 525.42 820.59 525.42
  Q 816.94 525.17 813.29 525.16
  A 1.31 1.29 -73.3 0 0 812.19 525.76
  L 808.52 531.59
  A 1.23 1.22 48.9 0 0 808.45 532.76
  Q 810.06 536.19 812.13 539.39
  Q 812.17 539.45 812.32 539.54
  Q 812.45 539.63 812.52 539.63
  Q 816.32 540.06 820.10 539.96
  A 1.23 1.22 14.6 0 0 821.11 539.38
  L 824.69 533.50
  A 1.31 1.29 -43.3 0 0 824.74 532.25
  Q 823.10 528.98 821.25 525.83
  Q 821.22 525.77 820.95 525.61
  Z
  M 837.60 532.97
  Q 837.59 533.32 837.62 533.38
  Q 839.28 536.62 841.16 539.74
  A 1.30 1.28 -14.3 0 0 842.23 540.37
  L 849.08 540.49
  A 1.23 1.21 -72.2 0 0 850.11 539.96
  Q 852.21 536.83 853.88 533.41
  Q 853.91 533.35 853.91 533.18
  Q 853.92 533.02 853.89 532.96
  Q 852.30 529.50 850.28 526.33
  A 1.23 1.21 73.6 0 0 849.26 525.76
  L 842.41 525.73
  A 1.30 1.28 15.7 0 0 841.32 526.33
  Q 839.37 529.40 837.63 532.60
  Q 837.60 532.66 837.60 532.97
  Z
  M 883.07 533.65
  Q 883.08 533.31 883.05 533.25
  Q 881.44 530.06 879.62 526.98
  A 1.28 1.26 -14.0 0 0 878.57 526.36
  L 871.83 526.19
  A 1.21 1.19 -71.9 0 0 870.82 526.71
  Q 868.73 529.77 867.07 533.12
  Q 867.04 533.18 867.04 533.35
  Q 867.04 533.51 867.06 533.57
  Q 868.60 536.97 870.58 540.11
  A 1.21 1.19 73.9 0 0 871.57 540.66
  L 878.31 540.74
  A 1.28 1.26 16.0 0 0 879.38 540.15
  Q 881.31 537.15 883.04 534.01
  Q 883.07 533.96 883.07 533.65
  Z
  M 805.82 547.95
  Q 806.30 547.68 806.98 546.52
  Q 809.79 541.69 809.84 541.57
  A 1.67 1.67 0.0 0 0 809.71 540.28
  L 806.87 534.94
  A 2.17 2.16 -11.4 0 0 805.14 533.80
  Q 801.47 533.48 798.09 533.72
  Q 798.02 533.72 797.96 533.76
  Q 797.87 533.81 797.83 533.86
  Q 795.83 536.60 794.14 539.87
  A 2.17 2.16 -46.4 0 0 794.19 541.94
  L 797.20 547.19
  A 1.67 1.67 0.0 0 0 798.23 547.99
  Q 798.36 548.01 803.94 548.20
  Q 805.29 548.24 805.82 547.95
  Z
  M 827.16 534.04
  Q 826.68 534.31 825.98 535.50
  Q 823.10 540.43 823.06 540.55
  A 1.71 1.71 0.0 0 0 823.18 541.87
  L 826.08 547.33
  A 2.22 2.21 -11.4 0 0 827.84 548.50
  Q 831.59 548.83 835.05 548.59
  Q 835.12 548.58 835.19 548.55
  Q 835.27 548.50 835.32 548.44
  Q 837.36 545.65 839.09 542.30
  A 2.22 2.21 -46.4 0 0 839.04 540.19
  L 835.97 534.82
  A 1.71 1.71 0.0 0 0 834.92 534.01
  Q 834.79 533.99 829.09 533.79
  Q 827.71 533.74 827.16 534.04
  Z
  M 852.51 542.49
  L 855.92 548.39
  A 1.24 1.24 0.0 0 0 857.22 548.99
  L 864.15 547.73
  A 2.00 1.96 15.8 0 0 865.23 547.14
  Q 866.84 545.44 868.08 542.10
  A 1.51 1.51 0.0 0 0 867.97 540.83
  L 864.71 535.18
  A 1.06 1.06 0.0 0 0 863.81 534.65
  L 856.95 534.52
  A 1.59 1.56 12.9 0 0 855.51 535.41
  L 852.48 541.70
  A 0.86 0.85 43.2 0 0 852.51 542.49
  Z"
        />
        <path d="
  M 860.33 329.45
  A 0.13 0.13 0.0 0 1 860.34 329.64
  Q 856.19 333.86 854.40 337.68
  A 1.20 1.16 -44.1 0 0 854.37 338.62
  Q 856.11 342.97 858.84 345.61
  A 1.08 1.08 0.0 0 1 859.01 346.95
  C 856.87 350.43 853.94 354.51 854.12 358.11
  A 0.64 0.64 0.0 0 1 853.47 358.79
  L 853.20 358.78
  A 0.33 0.32 83.1 0 1 852.89 358.53
  Q 852.63 357.44 852.05 356.70
  A 1.31 1.29 -18.1 0 0 851.04 356.20
  L 844.57 356.08
  A 1.39 1.38 18.0 0 0 843.42 356.66
  L 839.73 361.81
  A 1.60 1.59 -40.9 0 0 839.61 363.46
  L 842.11 368.33
  A 0.84 0.83 -25.0 0 1 841.69 369.48
  L 841.53 369.53
  A 1.30 1.30 0.0 0 1 839.99 368.99
  L 837.27 364.67
  A 1.29 1.27 74.5 0 0 836.20 364.06
  L 829.37 363.94
  A 1.10 1.10 0.0 0 0 828.37 364.55
  L 825.24 371.06
  A 1.41 1.40 -47.3 0 0 825.29 372.37
  L 826.18 373.92
  A 0.70 0.70 0.0 0 1 825.16 374.84
  L 822.41 372.87
  A 2.57 2.55 -26.3 0 0 820.98 372.39
  L 815.45 372.30
  A 1.27 1.26 16.2 0 0 814.33 372.91
  Q 812.51 375.88 809.91 377.14
  A 0.50 0.50 0.0 0 1 809.24 376.47
  L 811.76 371.24
  A 0.83 0.81 43.2 0 0 811.73 370.47
  L 808.19 364.34
  A 1.40 1.39 -14.3 0 0 807.02 363.65
  L 801.35 363.56
  A 1.01 1.00 0.3 0 1 800.36 362.57
  L 800.36 362.52
  A 1.04 1.04 0.0 0 1 801.40 361.53
  L 807.64 361.54
  A 1.06 1.05 -77.0 0 0 808.61 360.93
  L 811.79 354.34
  A 0.60 0.58 -47.9 0 0 811.77 353.78
  L 808.20 347.59
  A 1.30 1.28 74.9 0 0 807.11 346.95
  L 801.04 346.84
  A 0.71 0.71 0.0 0 1 800.34 346.11
  L 800.35 345.69
  A 1.20 1.20 0.0 0 1 801.65 344.55
  Q 803.97 344.74 806.39 344.49
  C 808.78 344.24 810.30 340.63 811.72 337.97
  A 1.45 1.43 -46.1 0 0 811.70 336.57
  L 808.19 330.49
  A 1.24 1.23 -14.6 0 0 807.14 329.88
  L 801.38 329.77
  A 0.75 0.75 0.0 0 1 800.64 329.01
  L 800.65 328.62
  A 1.07 1.07 0.0 0 1 801.73 327.57
  L 807.15 327.67
  A 1.54 1.53 -76.4 0 0 808.56 326.80
  L 811.80 320.07
  A 0.67 0.66 -48.0 0 0 811.77 319.43
  L 808.68 314.07
  A 2.60 2.59 75.3 0 0 806.47 312.77
  L 801.72 312.68
  A 0.70 0.69 -89.2 0 1 801.04 311.97
  L 801.05 311.67
  A 1.09 1.09 0.0 0 1 802.16 310.60
  L 806.56 310.67
  A 2.91 2.90 -74.9 0 0 809.17 309.16
  L 811.83 304.29
  A 1.24 1.23 33.5 0 1 813.68 303.92
  L 813.70 303.93
  A 1.17 1.16 35.3 0 1 813.96 305.43
  L 810.55 311.07
  A 0.94 0.93 -44.7 0 0 810.54 312.01
  L 814.39 318.67
  A 0.99 0.98 75.5 0 0 815.23 319.17
  L 822.24 319.30
  A 1.52 1.51 13.3 0 0 823.62 318.45
  L 826.74 311.96
  A 0.67 0.67 0.0 0 0 826.74 311.38
  Q 825.31 308.38 824.63 307.22
  Q 824.08 306.29 824.16 305.52
  A 0.47 0.47 0.0 0 1 824.93 305.21
  Q 827.33 307.28 828.83 310.45
  A 1.15 1.13 -11.0 0 0 829.82 311.11
  Q 833.20 311.24 836.81 311.22
  Q 838.46 311.21 839.24 309.48
  A 0.65 0.65 0.0 0 1 840.47 309.61
  Q 840.69 310.60 840.04 311.65
  A 1.60 1.58 46.0 0 0 840.02 313.27
  L 843.45 319.21
  A 1.05 1.02 -14.2 0 0 844.33 319.72
  L 852.09 319.86
  A 0.91 0.90 14.6 0 0 852.90 319.39
  L 853.44 318.41
  A 0.83 0.80 89.0 0 1 853.71 318.12
  Q 854.80 317.43 854.41 319.61
  C 853.86 322.72 858.16 327.78 860.33 329.45
  Z
  M 829.42 313.58
  Q 828.94 313.84 828.24 315.04
  Q 825.34 319.99 825.30 320.11
  A 1.72 1.72 0.0 0 0 825.42 321.44
  L 828.33 326.93
  A 2.23 2.22 -11.3 0 0 830.10 328.11
  Q 833.87 328.44 837.34 328.20
  Q 837.41 328.19 837.48 328.16
  Q 837.57 328.11 837.61 328.05
  Q 839.67 325.24 841.40 321.88
  A 2.23 2.22 -46.3 0 0 841.36 319.76
  L 838.28 314.36
  A 1.72 1.72 0.0 0 0 837.22 313.55
  Q 837.09 313.52 831.36 313.32
  Q 829.98 313.27 829.42 313.58
  Z
  M 814.49 336.06
  Q 814.79 336.25 814.85 336.25
  Q 818.50 336.46 822.14 336.42
  A 1.31 1.29 -74.0 0 0 823.23 335.81
  L 826.82 329.94
  A 1.23 1.22 48.2 0 0 826.88 328.78
  Q 825.23 325.38 823.12 322.20
  Q 823.09 322.15 822.94 322.05
  Q 822.80 321.97 822.74 321.97
  Q 818.94 321.59 815.16 321.73
  A 1.23 1.22 13.9 0 0 814.16 322.32
  L 810.66 328.24
  A 1.31 1.29 -43.9 0 0 810.63 329.48
  Q 812.30 332.73 814.19 335.85
  Q 814.22 335.90 814.49 336.06
  Z
  M 856.26 329.51
  Q 856.27 329.15 856.24 329.10
  Q 854.53 325.82 852.61 322.67
  A 1.32 1.30 -14.7 0 0 851.51 322.04
  L 844.56 321.96
  A 1.25 1.23 -72.6 0 0 843.52 322.51
  Q 841.42 325.70 839.75 329.18
  Q 839.72 329.23 839.72 329.41
  Q 839.72 329.58 839.74 329.63
  Q 841.38 333.13 843.45 336.34
  A 1.25 1.23 73.2 0 0 844.49 336.90
  L 851.44 336.89
  A 1.32 1.30 15.3 0 0 852.54 336.27
  Q 854.50 333.14 856.23 329.88
  Q 856.26 329.82 856.26 329.51
  Z
  M 841.44 337.86
  Q 841.44 337.51 841.42 337.45
  Q 839.77 334.20 837.90 331.07
  A 1.30 1.29 -14.1 0 0 836.83 330.43
  L 829.97 330.27
  A 1.23 1.22 -72.0 0 0 828.93 330.81
  Q 826.81 333.93 825.13 337.35
  Q 825.10 337.41 825.10 337.58
  Q 825.09 337.74 825.12 337.80
  Q 826.70 341.27 828.71 344.46
  A 1.23 1.22 73.8 0 0 829.73 345.03
  L 836.59 345.09
  A 1.30 1.29 15.9 0 0 837.69 344.49
  Q 839.65 341.43 841.40 338.23
  Q 841.43 338.17 841.44 337.86
  Z
  M 826.78 346.05
  Q 826.78 345.71 826.76 345.65
  Q 825.14 342.43 823.32 339.34
  A 1.29 1.27 -13.9 0 0 822.26 338.71
  L 815.49 338.53
  A 1.21 1.20 -71.7 0 0 814.47 339.05
  Q 812.37 342.13 810.69 345.49
  Q 810.66 345.54 810.66 345.72
  Q 810.66 345.88 810.68 345.94
  Q 812.23 349.36 814.20 352.52
  A 1.21 1.20 74.0 0 0 815.20 353.08
  L 821.97 353.17
  A 1.29 1.27 16.2 0 0 823.05 352.58
  Q 825.00 349.56 826.74 346.41
  Q 826.77 346.36 826.78 346.05
  Z
  M 851.89 339.58
  Q 851.59 339.40 851.53 339.40
  Q 847.93 339.20 844.33 339.25
  A 1.29 1.27 -74.0 0 0 843.26 339.85
  L 839.73 345.64
  A 1.22 1.20 48.1 0 0 839.68 346.79
  Q 841.30 350.15 843.39 353.28
  Q 843.42 353.33 843.57 353.42
  Q 843.71 353.50 843.77 353.51
  Q 847.52 353.88 851.24 353.73
  A 1.22 1.20 13.9 0 0 852.23 353.14
  L 855.68 347.30
  A 1.29 1.27 -44.0 0 0 855.71 346.07
  Q 854.06 342.88 852.19 339.80
  Q 852.15 339.74 851.89 339.58
  Z
  M 837.17 347.60
  Q 836.70 347.32 835.34 347.32
  Q 829.69 347.31 829.57 347.33
  A 1.69 1.69 0.0 0 0 828.50 348.10
  L 825.27 353.30
  A 2.19 2.18 48.4 0 0 825.16 355.39
  Q 826.74 358.75 828.67 361.59
  Q 828.71 361.65 828.78 361.69
  Q 828.86 361.74 828.93 361.74
  Q 832.34 362.10 836.06 361.91
  A 2.19 2.18 13.4 0 0 837.84 360.81
  L 840.90 355.52
  A 1.69 1.69 0.0 0 0 841.07 354.21
  Q 841.03 354.09 838.35 349.12
  Q 837.70 347.92 837.17 347.60
  Z
  M 826.55 363.19
  Q 826.57 362.83 826.54 362.77
  Q 824.96 359.48 823.17 356.30
  A 1.31 1.29 -12.7 0 0 822.11 355.64
  L 815.23 355.32
  A 1.23 1.22 -70.6 0 0 814.19 355.83
  Q 811.99 358.91 810.22 362.29
  Q 810.19 362.35 810.18 362.53
  Q 810.18 362.69 810.20 362.75
  Q 811.70 366.26 813.65 369.50
  A 1.23 1.22 75.1 0 0 814.65 370.10
  L 821.53 370.32
  A 1.31 1.29 17.3 0 0 822.64 369.74
  Q 824.68 366.72 826.51 363.55
  Q 826.54 363.50 826.55 363.19
  Z"
        />
        <path d="
  M 737.17 351.45
  A 0.90 0.61 -86.0 0 1 736.40 350.13
  Q 736.75 349.55 737.09 349.69
  Q 737.73 349.94 737.65 350.46
  Q 737.54 351.10 737.17 351.45
  Z"
        />
      </g>
    </chakra.svg>
  );
};

export default Logo;
